/* RŌGMA IA Skin Ritual · escaneo unificado (loader MediaPipe + A1 + A2 + A3 + B + coordinador) */
/* RŌGMA IA local MediaPipe loader. Asset files must be hash-verified as 0.10.35 before installation. */
(() => {
  'use strict';
  const modules = new Map();
  let lastErrors = [];

  function pathWithoutQuery(value) {
    try { return new URL(String(value), window.location && window.location.href).pathname; }
    catch (_) { return String(value || '').split(/[?#]/, 1)[0].slice(0, 300); }
  }
  function recordError(stage, error, url) {
    const message = String(error && error.message ? error.message : error || 'Error desconocido')
      .replace(/[?#][^\s"'<>]*/g, '').slice(0, 300);
    lastErrors.push(Object.freeze({
      stage,
      errorName: String(error && error.name || 'Error').slice(0, 80),
      errorMessage: message,
      path: pathWithoutQuery(url),
    }));
  }
  function snapshotErrors() { return Object.freeze(lastErrors.map((item) => Object.freeze({ ...item }))); }

  function urlsFrom(root) {
    const rawBase = String(root.dataset.mpBaseUrl || '').trim();
    let base = '';
    if (rawBase) {
      let parsed;
      try { parsed = new URL(rawBase); } catch (_) { throw new Error('La URL base de MediaPipe debe ser HTTPS absoluta.'); }
      if (parsed.protocol !== 'https:' || !parsed.host || parsed.search || parsed.hash || parsed.username || parsed.password) {
        throw new Error('La URL base de MediaPipe debe ser HTTPS absoluta, sin parámetros ni fragmentos.');
      }
      base = rawBase.replace(/\/+$/, '');
    }
    const asset = (filename, themeUrl) => base ? `${base}/${filename}` : themeUrl;
    return {
      module: asset('rogma-mp-vision-0.10.35.mjs', root.dataset.mpModuleUrl),
      simdJs: asset('rogma-mp-vision-wasm-simd-0.10.35.js', root.dataset.mpWasmSimdJs),
      simdWasm: asset('rogma-mp-vision-wasm-simd-0.10.35.wasm', root.dataset.mpWasmSimdWasm),
      noSimdJs: asset('rogma-mp-vision-wasm-nosimd-0.10.35.js', root.dataset.mpWasmNoSimdJs),
      noSimdWasm: asset('rogma-mp-vision-wasm-nosimd-0.10.35.wasm', root.dataset.mpWasmNoSimdWasm),
      model: asset('rogma-mp-face-landmarker-float16-v1.task', root.dataset.mpFaceModel),
    };
  }

  async function loadModule(root, importModule = (url) => import(url)) {
    const urls = urlsFrom(root);
    for (const [key, value] of Object.entries(urls)) {
      if (!value) throw new Error(`Falta el asset local de MediaPipe: ${key}`);
    }
    if (!modules.has(urls.module)) modules.set(urls.module, Promise.resolve().then(() => importModule(urls.module)));
    let vision;
    try {
      vision = await modules.get(urls.module);
    } catch (error) {
      modules.delete(urls.module);
      recordError('module', error, urls.module);
      throw error;
    }
    if (!vision || !vision.FaceLandmarker || !vision.FilesetResolver) {
      const error = new Error('El módulo local no contiene FaceLandmarker/FilesetResolver.');
      recordError('module', error, urls.module);
      throw error;
    }
    return { vision, urls };
  }

  async function createFaceLandmarker(root, config, dependencies = {}) {
    lastErrors = [];
    const importer = typeof dependencies.importModule === 'function' ? dependencies.importModule : (url) => import(url);
    const { vision, urls } = await loadModule(root, importer);
    const extra = config || {};
    const base={runningMode:'VIDEO',numFaces:1,minFaceDetectionConfidence:.5,minFacePresenceConfidence:.5,minTrackingConfidence:.5,outputFaceBlendshapes:false,outputFacialTransformationMatrixes:false,...extra};
    const candidates=[{stage:'simd',wasmLoaderPath:urls.simdJs,wasmBinaryPath:urls.simdWasm},{stage:'nosimd',wasmLoaderPath:urls.noSimdJs,wasmBinaryPath:urls.noSimdWasm}];
    for(const candidate of candidates){const fileset={wasmLoaderPath:candidate.wasmLoaderPath,wasmBinaryPath:candidate.wasmBinaryPath};for(const delegate of ['GPU','CPU']){const options={...base,baseOptions:{...(extra.baseOptions||{}),delegate,modelAssetPath:urls.model}};try{const landmarker=await vision.FaceLandmarker.createFromOptions(fileset,options);return{vision,landmarker,wasm:fileset.wasmLoaderPath,delegate}}catch(error){recordError(`${candidate.stage}_${delegate.toLowerCase()}`,error,candidate.wasmLoaderPath)}}}
    throw new Error('No se pudo iniciar el detector con los archivos SIMD ni sin SIMD.');
  }

  const API = { version: '0.10.35', resolveUrls: urlsFrom, loadModule, createFaceLandmarker };
  Object.defineProperty(API, 'lastErrors', { enumerable: true, get: snapshotErrors });
  window.RogmaMediaPipeLoader = Object.freeze(API);
  if (typeof module !== 'undefined' && module.exports) module.exports = window.RogmaMediaPipeLoader;
})();
(() => {
  'use strict';

  document.querySelectorAll('[data-rogma-a1]').forEach((root) => {
    const screens = [...root.querySelectorAll('[data-screen]')];
    const progress = [...root.querySelectorAll('[data-progress]')];
    const backButton = root.querySelector('[data-back]');
    const menu = root.querySelector('[data-a1-menu]');
    const ageInput = root.querySelector('[data-age]');
    const ageError = root.querySelector('[data-age-error]');
    const consentRequired = root.querySelector('[data-consent-required]');
    const consentError = root.querySelector('[data-consent-error]');
    const status = root.querySelector('[data-device-message]');
    if (status) {
      status.classList.add('sr-only');
      Object.assign(status.style, {
        position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px',
        overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: '0',
      });
    }

    const state = {
      screen: 0,
      age: null,
      consentProcess: false,
      consentImprove: false,
    };

    function showScreen(index, focusHeading = true) {
      if (index < 0 || index >= screens.length) return;
      state.screen = index;
      root.dispatchEvent(new CustomEvent('rogma:a1-screen', { bubbles: true, detail: { screen: index } }));
      if (index === 3) root.dispatchEvent(new CustomEvent('rogma:a1-prepare-detector', { bubbles: true }));
      root.classList.toggle('is-welcome', index === 0);
      if (menu) menu.open = false;
      if (backButton) {
        backButton.hidden = index === 0;
        backButton.setAttribute('aria-label', `Volver a ${index === 1 ? 'bienvenida' : index === 2 ? 'edad' : 'privacidad'}`);
      }
      screens.forEach((screen) => {
        const active = Number(screen.dataset.screen) === index;
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
      });
      progress.forEach((step) => {
        const value = Number(step.dataset.progress);
        step.classList.toggle('is-active', value === index);
        step.classList.toggle('is-done', value < index);
      });
      if (ageError) ageError.hidden = true;
      if (consentError) consentError.hidden = true;
      if (status) status.hidden = true;
      if (focusHeading) {
        const heading = screens[index].querySelector('h1, h2');
        if (heading) heading.focus({ preventScroll: true });
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    }

    function validateAge() {
      const raw = ageInput.value.trim();
      const age = Number(raw);
      const valid = /^\d+$/.test(raw) && Number.isInteger(age) && age >= 18 && age <= 120;
      ageInput.setAttribute('aria-invalid', String(!valid));
      ageError.textContent = age < 18 && raw !== ''
        ? 'Esta experiencia está disponible para personas de 18 años o más.'
        : 'Escribe tu edad en número entero, de 18 a 120 años.';
      ageError.hidden = valid;
      state.age = valid ? age : null;
      return valid;
    }

    root.addEventListener('click', (event) => {
      const next = event.target.closest('[data-next]');
      if (next && root.contains(next)) {
        const current = Number(next.dataset.next);
        if (current !== state.screen) return;
        if (current === 1 && !validateAge()) {
          ageInput.focus();
          return;
        }
        if (current === 2 && !consentRequired.checked) {
          consentError.hidden = false;
          consentRequired.focus();
          return;
        }
        if (current === 2) {
          state.consentProcess = true;
          state.consentImprove = false;
        }
        showScreen(current + 1);
        return;
      }

      if (event.target.closest('[data-back]')) {
        showScreen(state.screen - 1);
        return;
      }

      if (event.target.closest('[data-finish]')) {
        if (!state.age || !state.consentProcess) {
          showScreen(state.age ? 2 : 1);
          return;
        }
        root.dispatchEvent(new CustomEvent('rogma:a1-ready-for-capture', {
          bubbles: true,
          detail: {
            edad: state.age,
            consentimientos: {
              procesar_imagenes: state.consentProcess,
              mejora_sistema: state.consentImprove,
            },
          },
        }));
        status.textContent = 'Preparación completa.';
        status.hidden = false;
      }
    });

    ageInput.addEventListener('input', () => {
      state.age = null;
      ageError.hidden = true;
      ageInput.removeAttribute('aria-invalid');
    });
    consentRequired.addEventListener('change', () => {
      if (consentRequired.checked) consentError.hidden = true;
    });

    root.__rogmaShow = showScreen; root.__rogmaScreen = () => state.screen;
    showScreen(0, false);
  });
})();

/* RŌGMA A2 camera capture. No network, persistence, console, or image data URLs. */
(() => {
  'use strict';
  const CONFIG = Object.freeze({
    // Umbrales relativos compartidos por Android y iPhone; revisar con pruebas reales.
    faceHeightMin: 0.45,
    faceHeightMax: 0.60,
    centerToleranceX: 0.16, // centro facial respecto al centro del fotograma; por medir
    centerToleranceY: 0.16,
    maxRollDeg: 14, // por medir
    frontalYawMaxDeg: 8,
    profileYawMinDeg: 15,
    profileYawMaxDeg: 30,
    cheekVisibilityMinShare: 0.60, // solo referencia histórica de calibración; no decide captura
    normalFlowV2Enabled: true,
    faceEvaluationGraceMs: 500, // ventana inicial de detección; normalFlowV2Enabled
    postCapturePauseMs: 1000, // guía de transición; normalFlowV2Enabled
    countdownSeconds: 2, // cuenta regresiva visible; normalFlowV2Enabled
    stabilityHoldMs: 800, // tiempo continuo dentro de tolerancias; por medir
    stabilityBoxDelta: 0.025,
    stabilityRollDeltaDeg: 3.5,
    stabilityYawDeltaDeg: 5,
    maxPhotoPoseRetries: 3,
    debounceGuidanceMs: 120,
    detectorTimeoutMs: 12000,
    cameraStartTimeoutMs: 12000,
    cameraPermissionTimeoutMs: 30000, // cierre seguro si getUserMedia queda pendiente; por medir
    photoMaxLongSide: 3072,
    jpegQuality: 0.98, // calidad preliminar; por medir
    minBrightness: 0.18, // luminancia media normalizada 0..1; por medir
    maxBrightness: 0.94,
    cheekLightDeltaMax: 0.25,
    cheekLightWaitMs: 3000,
    mirrorCorrelationMargin: 0.10,
    mirrorCorrelationMin: 0.35,
    mirrorThumbnailWidth: 64,
    mirrorThumbnailHeight: 64,
    cheekLightSampleWidth: 96,
    cheekLightSampleHeight: 96,
    // Umbrales iniciales para la prueba ?luz=prueba; validar en móviles reales.
    warmCheekBStarMax: 24,
    mixedCheekDeltaEAbMax: 12,
    darkCheekLuminanceMax: 0.35,
    screenLightMaxOpacity: 0.72,
    logDeviceCapabilities: true,
    minFaceDetectionConfidence: 0.50,
    minFacePresenceConfidence: 0.50,
    minTrackingConfidence: 0.50,
    sampleWidth: 24,
    sampleHeight: 24,
    ovalHeight: 0.60,
    frameMaxHeightVh: 0.75,
    ovalWidthRatio: 0.72,
  });
  function distanceModeFromSearch(search) {
    try { return new URLSearchParams(String(search || '')).get('distancia') === 'lejos' ? 'lejos' : 'normal'; }
    catch (_) { return 'normal'; }
  }
  function configForDistanceMode(mode, config = CONFIG) {
    if (mode !== 'lejos') return config;
    return Object.freeze({
      ...config,
      faceHeightMin: 0.34,
      faceHeightMax: 0.46,
      // The normal face range scales by about 0.76 (0.34/0.45 to 0.46/0.60).
      // Shrink only the guide oval; camera constraints and image pixels stay unchanged.
      ovalHeight: config.ovalHeight * 0.76,
    });
  }
  function focusModesFromCapabilities(capabilities) {
    const supported = new Set(['none', 'manual', 'single-shot', 'continuous']);
    const raw = capabilities && capabilities.focusMode;
    const values = Array.isArray(raw) ? raw : (typeof raw === 'string' ? [raw] : []);
    return Object.freeze([...new Set(values.filter((value) => typeof value === 'string' && supported.has(value)))]);
  }
  function lightingTestEnabledFromSearch(search) {
    try { return new URLSearchParams(String(search || '')).get('luz') === 'prueba'; }
    catch (_) { return false; }
  }
  function linearSrgb(value) {
    const channel = Math.max(0, Math.min(1, Number(value) / 255));
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }
  function rgbToLab(r, g, b) {
    const red = linearSrgb(r); const green = linearSrgb(g); const blue = linearSrgb(b);
    const x = (red * 0.4124564 + green * 0.3575761 + blue * 0.1804375) / 0.95047;
    const y = red * 0.2126729 + green * 0.7151522 + blue * 0.0721750;
    const z = (red * 0.0193339 + green * 0.1191920 + blue * 0.9503041) / 1.08883;
    const f = (value) => value > 0.008856451679 ? Math.cbrt(value) : (7.787037037 * value + 16 / 116);
    const fx = f(x); const fy = f(y); const fz = f(z);
    return { a: 500 * (fx - fy), b: 200 * (fy - fz) };
  }
  function cheekColorFromPixels(imageData, width, height, boxes) {
    const sample = (box) => {
      if (!box || !imageData || !width || !height) return { a: null, b: null };
      const x1 = Math.max(0, Math.min(width, Math.floor(box.x1 * width)));
      const x2 = Math.max(0, Math.min(width, Math.ceil(box.x2 * width)));
      const y1 = Math.max(0, Math.min(height, Math.floor(box.y1 * height)));
      const y2 = Math.max(0, Math.min(height, Math.ceil(box.y2 * height)));
      if (x2 <= x1 || y2 <= y1) return { a: null, b: null };
      let sumA = 0; let sumB = 0; let count = 0;
      for (let y = y1; y < y2; y += 1) for (let x = x1; x < x2; x += 1) {
        const i = (y * width + x) * 4; const lab = rgbToLab(imageData[i], imageData[i + 1], imageData[i + 2]);
        sumA += lab.a; sumB += lab.b; count += 1;
      }
      return count ? { a: sumA / count, b: sumB / count } : { a: null, b: null };
    };
    const left = sample(boxes && boxes.left); const right = sample(boxes && boxes.right);
    return Object.freeze({ cheekLeftAStar: left.a, cheekLeftBStar: left.b, cheekRightAStar: right.a, cheekRightBStar: right.b });
  }
  function evaluateCheekColor(leftA, leftB, rightA, rightB, config = CONFIG) {
    const raw = [leftA, leftB, rightA, rightB];
    if (!raw.every((value) => value !== null && value !== undefined && Number.isFinite(Number(value)))) return Object.freeze({ measurable: false, warm: false, mixed: false, deltaEAb: null, meanBStar: null });
    const values = raw.map(Number);
    const deltaEAb = Math.hypot(values[0] - values[2], values[1] - values[3]);
    const meanBStar = (values[1] + values[3]) / 2;
    return Object.freeze({ measurable: true, meanBStar, deltaEAb, warm: meanBStar > config.warmCheekBStarMax, mixed: deltaEAb > config.mixedCheekDeltaEAbMax });
  }
  function evaluateExperimentalLighting(face, elapsedMs = 0, config = CONFIG) {
    const color = evaluateCheekColor(face && face.cheekLeftAStar, face && face.cheekLeftBStar, face && face.cheekRightAStar, face && face.cheekRightBStar, config);
    const rawLuminances = [face && face.cheekLeftLuminance, face && face.cheekRightLuminance];
    const luminances = rawLuminances.map(Number);
    const dark = rawLuminances.every((value) => value !== null && value !== undefined && Number.isFinite(Number(value))) && (luminances[0] + luminances[1]) / 2 < config.darkCheekLuminanceMax;
    const blockedCue = color.measurable && (color.mixed || color.warm);
    const timedOut = Number(elapsedMs) >= config.cheekLightWaitMs;
    return Object.freeze({ ...color, dark, cue: blockedCue && !timedOut, acceptedAfterWait: blockedCue && timedOut, cueCode: color.mixed ? 'mixed_light' : color.warm ? 'warm_light' : null });
  }
  function screenLightOpacity(face, config = CONFIG) {
    const raw = [face && face.cheekLeftLuminance, face && face.cheekRightLuminance];
    if (!raw.every((value) => value !== null && value !== undefined && Number.isFinite(Number(value)))) return 0;
    const luminances = raw.map(Number);
    const mean = (luminances[0] + luminances[1]) / 2;
    return Math.max(0, Math.min(config.screenLightMaxOpacity, (config.darkCheekLuminanceMax - mean) / config.darkCheekLuminanceMax * config.screenLightMaxOpacity));
  }
  const CAMERA_CAPABILITY_FIELDS = Object.freeze(['width', 'height', 'imageWidth', 'imageHeight', 'frameRate', 'focusMode', 'focusDistance', 'exposureMode', 'exposureCompensation', 'exposureTime', 'iso', 'whiteBalanceMode', 'colorTemperature', 'pointsOfInterest', 'torch', 'fillLightMode', 'zoom']);
  const CAMERA_ENUMS = Object.freeze({
    focusMode: new Set(['none', 'manual', 'single-shot', 'continuous']),
    exposureMode: new Set(['none', 'manual', 'single-shot', 'continuous']),
    whiteBalanceMode: new Set(['none', 'manual', 'single-shot', 'continuous']),
    fillLightMode: new Set(['auto', 'off', 'flash']),
  });
  function sanitizeCameraCapabilities(source) {
    const output = {};
    if (!source || typeof source !== 'object') return output;
    for (const key of CAMERA_CAPABILITY_FIELDS) {
      const value = source[key];
      if (typeof value === 'number' && Number.isFinite(value) && Math.abs(value) <= 100000) output[key] = value;
      else if (typeof value === 'boolean' && ['torch'].includes(key)) output[key] = value;
      else if (typeof value === 'string' && CAMERA_ENUMS[key] && CAMERA_ENUMS[key].has(value)) output[key] = value;
      else if (key === 'pointsOfInterest' && Array.isArray(value)) {
        output[key] = value.slice(0, 8).filter((point) => point && typeof point === 'object' && Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y)))
          .map((point) => ({ x: Math.max(0, Math.min(1, Number(point.x))), y: Math.max(0, Math.min(1, Number(point.y))) }));
      } else if (Array.isArray(value) && value.length <= 32) {
        const entries = value.filter((item) => typeof item === 'string' && CAMERA_ENUMS[key] && CAMERA_ENUMS[key].has(item));
        if (entries.length) output[key] = [...new Set(entries)];
      } else if (value && typeof value === 'object' && ['width', 'height', 'imageWidth', 'imageHeight', 'frameRate', 'focusDistance', 'exposureCompensation', 'exposureTime', 'iso', 'colorTemperature', 'zoom'].includes(key)) {
        const range = {};
        for (const rangeKey of ['min', 'max', 'step']) if (typeof value[rangeKey] === 'number' && Number.isFinite(value[rangeKey]) && Math.abs(value[rangeKey]) <= 100000) range[rangeKey] = value[rangeKey];
        if (Object.keys(range).length) output[key] = range;
      }
    }
    return output;
  }
  function cameraLockPlan(capabilities, settings) {
    const caps = capabilities && typeof capabilities === 'object' ? capabilities : {};
    const current = settings && typeof settings === 'object' ? settings : {};
    const modeFor = (key) => ['manual', 'single-shot'].find((mode) => Array.isArray(caps[key]) && caps[key].includes(mode));
    const exposure = {};
    const exposureMode = modeFor('exposureMode');
    if (exposureMode) {
      for (const key of ['exposureCompensation', 'exposureTime', 'iso']) {
        const value = current[key]; const range = caps[key];
        if (typeof value === 'number' && Number.isFinite(value)
          && (!range || typeof range.min !== 'number' || value >= range.min)
          && (!range || typeof range.max !== 'number' || value <= range.max)) exposure[key] = value;
      }
    }
    const whiteBalanceMode = modeFor('whiteBalanceMode');
    const whiteBalance = whiteBalanceMode && typeof current.colorTemperature === 'number' && Number.isFinite(current.colorTemperature)
      ? { whiteBalanceMode, colorTemperature: current.colorTemperature } : null;
    return Object.freeze({ exposure: exposureMode && Object.keys(exposure).length ? { exposureMode, ...exposure } : null, whiteBalance });
  }
  function automaticCameraModesPlan(capabilities, locked = {}) {
    const caps = capabilities && typeof capabilities === 'object' ? capabilities : {};
    const advanced = {};
    if (locked.exposure && Array.isArray(caps.exposureMode) && caps.exposureMode.includes('continuous')) advanced.exposureMode = 'continuous';
    if (locked.whiteBalance && Array.isArray(caps.whiteBalanceMode) && caps.whiteBalanceMode.includes('continuous')) advanced.whiteBalanceMode = 'continuous';
    return Object.keys(advanced).length ? Object.freeze(advanced) : null;
  }
  function experimentalLightingForSearch(search, face, elapsedMs = 0, config = CONFIG) {
    return lightingTestEnabledFromSearch(search) ? evaluateExperimentalLighting(face, elapsedMs, config) : null;
  }
  function deviceCapabilitiesForLogging(capabilities, settings, photoCapabilities, enabled = CONFIG.logDeviceCapabilities) {
    if (!enabled) return null;
    const result = { track_capabilities: sanitizeCameraCapabilities(capabilities), track_settings: sanitizeCameraCapabilities(settings) };
    if (photoCapabilities) result.photo_capabilities = sanitizeCameraCapabilities(photoCapabilities);
    return result;
  }
  // Primero se gira a la derecha para mostrar la mejilla izquierda;
  // después se gira a la izquierda para mostrar la mejilla derecha.
  const STEP_ORDER = Object.freeze(['frontal', 'perfil_izq', 'perfil_der']);
  const STEP_META = Object.freeze({
    frontal: { title: 'Vista frontal', yaw: 'frontal', eyebrow: 'VISTA FRONTAL · 01 / 03', intro: 'Mira al centro y relaja el rostro' },
    // The keys name the anatomical cheek sent to the backend. With unmirrored
    // capture pixels, exposing the subject's left cheek requires turning right.
    perfil_izq: { title: 'Voltea a tu derecha', yaw: 'right', eyebrow: 'GIRO A TU DERECHA · 02 / 03', intro: 'Gira suavemente hacia tu derecha · ¾' },
    perfil_der: { title: 'Voltea a tu izquierda', yaw: 'left', eyebrow: 'GIRO A TU IZQUIERDA · 03 / 03', intro: 'Gira suavemente hacia tu izquierda · ¾' },
  });
  function finite(value, fallback = 0) { return Number.isFinite(Number(value)) ? Number(value) : fallback; }
  function classifyCameraError(error, secure = true) {
    if (!secure) return { code: 'insecure_context', title: 'No se puede abrir la cámara aquí', text: 'Abre esta página desde una conexión segura (HTTPS) y vuelve a intentarlo.' };
    if (error && error.message === 'camera_permission_timeout') return { code: 'camera_timeout', title: 'La cámara no respondió', text: 'No recibimos respuesta de la cámara. Revisa el permiso y vuelve a intentarlo; las capturas anteriores siguen disponibles en esta página.' };
    const name = error && error.name;
    const map = {
      NotAllowedError: ['permission_denied', 'Permiso de cámara denegado', 'Permite el acceso a la cámara en los ajustes del navegador para continuar.'],
      SecurityError: ['permission_denied', 'Permiso de cámara denegado', 'Permite el acceso a la cámara en los ajustes del navegador para continuar.'],
      NotFoundError: ['no_camera', 'No encontramos una cámara', 'Conecta o habilita una cámara y vuelve a intentarlo.'],
      DevicesNotFoundError: ['no_camera', 'No encontramos una cámara', 'Conecta o habilita una cámara y vuelve a intentarlo.'],
      NotReadableError: ['camera_busy', 'La cámara está ocupada', 'Cierra otra aplicación que use la cámara y vuelve a intentarlo.'],
      TrackStartError: ['camera_busy', 'La cámara está ocupada', 'Cierra otra aplicación que use la cámara y vuelve a intentarlo.'],
      AbortError: ['camera_interrupted', 'La cámara se interrumpió', 'Puedes volver a intentar; las capturas anteriores siguen disponibles mientras esta página permanezca abierta.'],
    };
    const item = map[name] || ['camera_error', 'No se pudo iniciar la cámara', 'Revisa los permisos y vuelve a intentarlo.'];
    return { code: item[0], title: item[1], text: item[2] };
  }
  function normalizeFace(face) {
    if (!face) return null;
    const box = face.box || face;
    const width = finite(box.width, finite(box.right) - finite(box.left));
    const height = finite(box.height, finite(box.bottom) - finite(box.top));
    const x = finite(box.x, finite(box.left));
    const y = finite(box.y, finite(box.top));
    return {
      x, y, width, height,
      centerX: finite(face.centerX, x + width / 2),
      centerY: finite(face.centerY, y + height / 2),
      rollDeg: finite(face.rollDeg),
      yawDeg: finite(face.yawDeg),
      yawHeuristicDeg: finite(face.yawHeuristicDeg, finite(face.yawDeg)),
      yawMatrixDeg: face.yawMatrixDeg !== null && face.yawMatrixDeg !== undefined && Number.isFinite(Number(face.yawMatrixDeg)) ? Number(face.yawMatrixDeg) : null,
      eyeDistancePx: face.eyeDistancePx !== null && face.eyeDistancePx !== undefined && Number.isFinite(Number(face.eyeDistancePx)) ? Number(face.eyeDistancePx) : null,
      eyeDistanceHeightRatio: face.eyeDistanceHeightRatio !== null && face.eyeDistanceHeightRatio !== undefined && Number.isFinite(Number(face.eyeDistanceHeightRatio)) ? Number(face.eyeDistanceHeightRatio) : null,
      eyeDistanceWidthRatio: face.eyeDistanceWidthRatio !== null && face.eyeDistanceWidthRatio !== undefined && Number.isFinite(Number(face.eyeDistanceWidthRatio)) ? Number(face.eyeDistanceWidthRatio) : null,
      brightness: finite(face.brightness, 0.5),
      cheekLeftShare: face.cheekLeftShare !== null && face.cheekLeftShare !== undefined && Number.isFinite(Number(face.cheekLeftShare)) ? Number(face.cheekLeftShare) : null,
      cheekRightShare: face.cheekRightShare !== null && face.cheekRightShare !== undefined && Number.isFinite(Number(face.cheekRightShare)) ? Number(face.cheekRightShare) : null,
      cheekLeftLuminance: face.cheekLeftLuminance !== null && face.cheekLeftLuminance !== undefined && Number.isFinite(Number(face.cheekLeftLuminance)) ? Number(face.cheekLeftLuminance) : null,
      cheekRightLuminance: face.cheekRightLuminance !== null && face.cheekRightLuminance !== undefined && Number.isFinite(Number(face.cheekRightLuminance)) ? Number(face.cheekRightLuminance) : null,
      cheekLeftAStar: face.cheekLeftAStar !== null && face.cheekLeftAStar !== undefined && Number.isFinite(Number(face.cheekLeftAStar)) ? Number(face.cheekLeftAStar) : null,
      cheekLeftBStar: face.cheekLeftBStar !== null && face.cheekLeftBStar !== undefined && Number.isFinite(Number(face.cheekLeftBStar)) ? Number(face.cheekLeftBStar) : null,
      cheekRightAStar: face.cheekRightAStar !== null && face.cheekRightAStar !== undefined && Number.isFinite(Number(face.cheekRightAStar)) ? Number(face.cheekRightAStar) : null,
      cheekRightBStar: face.cheekRightBStar !== null && face.cheekRightBStar !== undefined && Number.isFinite(Number(face.cheekRightBStar)) ? Number(face.cheekRightBStar) : null,
    };
  }
  function targetCheekShare(faceInput, step) {
    const face = normalizeFace(faceInput);
    if (!face) return null;
    if (step === 'perfil_izq') return face.cheekLeftShare;
    if (step === 'perfil_der') return face.cheekRightShare;
    return null;
  }
  function assessFrame(faceInput, step, config = CONFIG) {
    const face = normalizeFace(faceInput);
    if (!face || face.width <= 0 || face.height <= 0) return { ok: false, code: 'no_face', face };
    if (face.height < config.faceHeightMin) return { ok: false, code: 'face_too_small', face };
    if (face.height > config.faceHeightMax) return { ok: false, code: 'face_too_large', face };
    if (Math.abs(face.centerX - 0.5) > config.centerToleranceX || Math.abs(face.centerY - 0.5) > config.centerToleranceY) return { ok: false, code: 'center_face', face };
    if (Math.abs(face.rollDeg) > config.maxRollDeg) return { ok: false, code: 'level_head', face };
    if (face.brightness < config.minBrightness) return { ok: false, code: 'more_light', face };
    if (face.brightness > config.maxBrightness) return { ok: false, code: 'less_light', face };
    if (face.yawMatrixDeg === null) return { ok: false, code: 'matrix_yaw_unavailable', face };
    const yaw = Math.abs(face.yawMatrixDeg);
    if (step === 'frontal' && yaw > config.frontalYawMaxDeg) return { ok: false, code: 'look_front', face };
    if (step === 'perfil_izq' && !(face.yawMatrixDeg <= -config.profileYawMinDeg && yaw <= config.profileYawMaxDeg)) return { ok: false, code: 'turn_right', face };
    if (step === 'perfil_der' && !(face.yawMatrixDeg >= config.profileYawMinDeg && yaw <= config.profileYawMaxDeg)) return { ok: false, code: 'turn_left', face };
    return { ok: true, code: 'ready', face };
  }
  function stableEnough(previous, current, config = CONFIG) {
    const a = normalizeFace(previous); const b = normalizeFace(current);
    if (!a || !b) return false;
    return Math.abs(a.centerX - b.centerX) <= config.stabilityBoxDelta
      && Math.abs(a.centerY - b.centerY) <= config.stabilityBoxDelta
      && Math.abs(a.width - b.width) <= config.stabilityBoxDelta
      && Math.abs(a.height - b.height) <= config.stabilityBoxDelta
      && Math.abs(a.rollDeg - b.rollDeg) <= config.stabilityRollDeltaDeg
      && Math.abs((a.yawMatrixDeg === null ? a.yawDeg : a.yawMatrixDeg) - (b.yawMatrixDeg === null ? b.yawDeg : b.yawMatrixDeg)) <= config.stabilityYawDeltaDeg;
  }
  function yawFromTransformationMatrix(matrix) {
    const values = matrix && (Array.isArray(matrix) ? matrix : (matrix.data || matrix.packedData));
    if (!values || values.length < 16) return null;
    const m = Array.from(values, Number);
    if (!m.slice(0, 16).every(Number.isFinite)) return null;
    // MediaPipe entrega la matriz column-major: yaw = atan2(m[8], m[10]).
    // Positivo se trata como giro a la izquierda; si un dispositivo invierte el convenio, ajustar solo este signo.
    return Math.atan2(m[8], m[10]) * 180 / Math.PI;
  }
  function faceFromLandmarks(landmarks, brightness = 0.5, facialTransformationMatrix = null, frameWidth = 0, frameHeight = 0) {
    if (!Array.isArray(landmarks) || landmarks.length < 455) return null;
    const xs = landmarks.map((p) => finite(p.x)); const ys = landmarks.map((p) => finite(p.y));
    const minX = Math.min(...xs); const maxX = Math.max(...xs); const minY = Math.min(...ys); const maxY = Math.max(...ys);
    const leftEye = landmarks[33]; const rightEye = landmarks[263]; const nose = landmarks[1];
    const eyeDx = finite(rightEye.x) - finite(leftEye.x); const eyeDy = finite(rightEye.y) - finite(leftEye.y);
    const eyeDistance = Math.max(0.001, Math.hypot(eyeDx, eyeDy));
    const frameW = finite(frameWidth); const frameH = finite(frameHeight);
    const eyeDxPx = eyeDx * frameW; const eyeDyPx = eyeDy * frameH;
    const eyeDistancePx = frameW > 0 && frameH > 0 ? Math.hypot(eyeDxPx, eyeDyPx) : null;
    const eyeMidX = (finite(leftEye.x) + finite(rightEye.x)) / 2;
    const yawDeg = Math.max(-90, Math.min(90, ((finite(nose.x) - eyeMidX) / eyeDistance) * 85));
    const leftBoundaryX = finite(landmarks[234].x, NaN); const rightBoundaryX = finite(landmarks[454].x, NaN);
    const noseX = finite(nose.x, NaN);
    const leftSpan = noseX - leftBoundaryX; const rightSpan = rightBoundaryX - noseX;
    const totalCheekSpan = leftSpan + rightSpan;
    const cheekLeftShare = Number.isFinite(totalCheekSpan) && totalCheekSpan > 0 && leftSpan >= 0 ? leftSpan / totalCheekSpan : null;
    const cheekRightShare = Number.isFinite(totalCheekSpan) && totalCheekSpan > 0 && rightSpan >= 0 ? rightSpan / totalCheekSpan : null;
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY, rollDeg: Math.atan2(eyeDy, eyeDx) * 180 / Math.PI,
      yawDeg, yawHeuristicDeg: yawDeg, yawMatrixDeg: yawFromTransformationMatrix(facialTransformationMatrix),
      eyeDistancePx, eyeDistanceHeightRatio: eyeDistancePx !== null && frameH > 0 ? eyeDistancePx / frameH : null,
      eyeDistanceWidthRatio: eyeDistancePx !== null && frameW > 0 ? eyeDistancePx / frameW : null,
      brightness, cheekLeftShare, cheekRightShare };
  }
  function simulatedLandmarks(faceInput) {
    const face = normalizeFace(faceInput);
    if (!face) return null;
    const points = Array.from({ length: 468 }, () => ({ x: face.centerX, y: face.centerY }));
    points[10] = { x: face.centerX, y: face.y };
    points[152] = { x: face.centerX, y: face.y + face.height };
    points[234] = { x: face.x, y: face.centerY };
    points[454] = { x: face.x + face.width, y: face.centerY };
    const eyeSpan = face.width * .36;
    const eyeY = face.centerY - face.height * .12;
    const eyeRise = eyeSpan * Math.tan(face.rollDeg * Math.PI / 180);
    points[33] = { x: face.centerX - eyeSpan / 2, y: eyeY };
    points[263] = { x: face.centerX + eyeSpan / 2, y: eyeY + eyeRise };
    points[1] = { x: face.centerX + face.yawDeg * eyeSpan / 85, y: face.centerY };
    points[234] = { x: face.x, y: face.centerY };
    points[454] = { x: face.x + face.width, y: face.centerY };
    return points;
  }
  function simulatedMatrix(yawDeg = 0) {
    const angle = finite(yawDeg) * Math.PI / 180;
    const matrix = new Array(16).fill(0);
    matrix[0] = Math.cos(angle); matrix[2] = -Math.sin(angle); matrix[5] = 1;
    matrix[8] = Math.sin(angle); matrix[10] = Math.cos(angle); matrix[15] = 1;
    return { data: matrix };
  }
  function diagnosticEnabled(search = '') {
    return String(search).split(/[?&]/).some((part) => part === 'rogma_debug=1' || part === 'debug' || part === 'debug=1');
  }
  function calibrationMetric(step, assessment, frameWidth, frameHeight, elapsedMs) {
    const face = normalizeFace(assessment && assessment.face);
    const numberOrNull = (value) => value !== null && value !== undefined && Number.isFinite(Number(value)) ? Number(value) : null;
    return Object.freeze({
      step,
      yawDeg: face ? numberOrNull(face.yawDeg) : null,
      yawHeuristicDeg: face ? numberOrNull(face.yawHeuristicDeg) : null,
      yawMatrixDeg: face ? numberOrNull(face.yawMatrixDeg) : null,
      rollDeg: face ? numberOrNull(face.rollDeg) : null,
      faceHeightRatio: face ? numberOrNull(face.height) : null,
      eyeDistancePx: face ? numberOrNull(face.eyeDistancePx) : null,
      eyeDistanceHeightRatio: face ? numberOrNull(face.eyeDistanceHeightRatio) : null,
      eyeDistanceWidthRatio: face ? numberOrNull(face.eyeDistanceWidthRatio) : null,
      centerX: face ? numberOrNull(face.centerX) : null,
      centerY: face ? numberOrNull(face.centerY) : null,
      brightness: face ? numberOrNull(face.brightness) : null,
      cheekLeftRatio: face ? numberOrNull(face.cheekLeftShare) : null,
      cheekRightRatio: face ? numberOrNull(face.cheekRightShare) : null,
      evaluationCode: assessment && assessment.code ? String(assessment.code) : 'no_face',
      wouldPass: Boolean(assessment && assessment.ok),
      frameWidth: numberOrNull(frameWidth),
      frameHeight: numberOrNull(frameHeight),
      elapsedMs: Math.max(0, Math.round(finite(elapsedMs))),
    });
  }
  function calibrationExport(records, live) {
    return JSON.stringify({ registros: Array.from(records || [], (record) => ({ ...record })), valores_en_vivo: live ? { ...live } : null }, null, 2);
  }
  function diagnosticReason(assessment, step, stableFor = 0, config = CONFIG) {
    const code = assessment && assessment.code ? assessment.code : 'no_face';
    const reasons = {
      no_face: 'No se detecta un rostro completo.', face_too_small: 'Acércate hasta que el rostro ocupe el rango indicado.',
      face_too_large: 'Aléjate un poco para mantener el rostro completo.', center_face: 'Centra el rostro.', level_head: 'Mantén la cabeza recta.',
      more_light: 'Hace falta más luz frontal.', less_light: 'Reduce la luz directa.', look_front: 'Mira al frente.',
      turn_left: `Gira hacia la izquierda dentro de ${config.profileYawMinDeg}–${config.profileYawMaxDeg}° según yaw por matriz.`, turn_right: `Gira hacia la derecha dentro de ${config.profileYawMinDeg}–${config.profileYawMaxDeg}° según yaw por matriz.`,
      matrix_yaw_unavailable: 'No está disponible el yaw de la matriz facial.',
      matrix_yaw_unavailable: 'No está disponible el yaw de la matriz facial.',
      cheek_landmarks_missing: 'No están disponibles los puntos necesarios para medir la mejilla.',
      cheek_left_not_visible: 'Los landmarks aún no confirman suficiente mejilla izquierda visible.',
      cheek_right_not_visible: 'Los landmarks aún no confirman suficiente mejilla derecha visible.',
    };
    if (!assessment || !assessment.ok) return reasons[code] || 'La captura espera una condición válida.';
    if (stableFor < config.stabilityHoldMs) return `Esperando estabilidad: ${Math.max(0, Math.round(stableFor))}/${config.stabilityHoldMs} ms.`;
    return `Lista para captura automática de ${step}.`;
  }
  function brightnessFromPixels(pixels, width, height, sampleWidth = CONFIG.sampleWidth, sampleHeight = CONFIG.sampleHeight) {
    if (!pixels || !width || !height) return .5;
    let sum = 0; let count = 0;
    for (let sy = 0; sy < sampleHeight; sy += 1) for (let sx = 0; sx < sampleWidth; sx += 1) {
      const x = Math.min(width - 1, Math.floor((sx + .5) * width / sampleWidth));
      const y = Math.min(height - 1, Math.floor((sy + .5) * height / sampleHeight));
      const i = (y * width + x) * 4; sum += (0.2126 * pixels[i] + 0.7152 * pixels[i + 1] + 0.0722 * pixels[i + 2]) / 255; count += 1;
    }
    return count ? sum / count : .5;
  }
  function brightnessOf(video, canvas, config = CONFIG) {
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    canvas.width = config.sampleWidth; canvas.height = config.sampleHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let sum = 0;
    for (let i = 0; i < pixels.length; i += 4) sum += (0.2126 * pixels[i] + 0.7152 * pixels[i + 1] + 0.0722 * pixels[i + 2]) / 255;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    return sum / (pixels.length / 4);
  }
  function pearsonCorrelation(a, b) {
    if (!a || !b || a.length !== b.length || a.length < 2) return null;
    let meanA = 0; let meanB = 0;
    for (let i = 0; i < a.length; i += 1) { meanA += a[i]; meanB += b[i]; }
    meanA /= a.length; meanB /= b.length;
    let numerator = 0; let varianceA = 0; let varianceB = 0;
    for (let i = 0; i < a.length; i += 1) {
      const da = a[i] - meanA; const db = b[i] - meanB;
      numerator += da * db; varianceA += da * da; varianceB += db * db;
    }
    const denominator = Math.sqrt(varianceA * varianceB);
    return denominator > 1e-8 ? numerator / denominator : null;
  }
  function horizontallyFlippedGray(values, width, height) {
    if (!values || values.length !== width * height) return [];
    const flipped = new Array(values.length);
    for (let y = 0; y < height; y += 1) {
      const row = y * width;
      for (let x = 0; x < width; x += 1) flipped[row + x] = values[row + width - 1 - x];
    }
    return flipped;
  }
  function detectPhotoMirrorOrientation(referenceGray, photoGray, width = CONFIG.mirrorThumbnailWidth, height = CONFIG.mirrorThumbnailHeight, config = CONFIG) {
    const flipped = horizontallyFlippedGray(photoGray, width, height);
    const normalCorrelation = pearsonCorrelation(referenceGray, photoGray);
    const mirroredCorrelation = pearsonCorrelation(referenceGray, flipped);
    const valid = Number.isFinite(normalCorrelation) && Number.isFinite(mirroredCorrelation);
    if (!valid || Math.max(normalCorrelation, mirroredCorrelation) < config.mirrorCorrelationMin
      || Math.abs(mirroredCorrelation - normalCorrelation) < config.mirrorCorrelationMargin) {
      return Object.freeze({ mirrorCorrected: 'dudoso', normalCorrelation, mirroredCorrelation });
    }
    return Object.freeze({
      mirrorCorrected: mirroredCorrelation > normalCorrelation,
      normalCorrelation,
      mirroredCorrelation,
    });
  }
  function evaluateCheekLighting(leftLuminance, rightLuminance, elapsedMs = 0, config = CONFIG) {
    const left = Number(leftLuminance); const right = Number(rightLuminance);
    if (!Number.isFinite(left) || !Number.isFinite(right) || left < 0 || right < 0) {
      return Object.freeze({ measurable: false, cue: false, acceptedAsymmetric: false, deltaRatio: null });
    }
    const deltaRatio = Math.abs(left - right) / Math.max(left, right, 0.01);
    const imbalanced = deltaRatio > config.cheekLightDeltaMax;
    const timedOut = Number(elapsedMs) >= config.cheekLightWaitMs;
    return Object.freeze({
      measurable: true,
      leftLuminance: left,
      rightLuminance: right,
      deltaRatio,
      cue: imbalanced && !timedOut,
      acceptedAsymmetric: imbalanced && timedOut,
    });
  }
  function applyFrontalLightingAssessment(assessment, step, elapsedMs, config = CONFIG) {
    if (!assessment || step !== 'frontal' || !assessment.face) return assessment;
    const lighting = evaluateCheekLighting(
      assessment.face.cheekLeftLuminance,
      assessment.face.cheekRightLuminance,
      elapsedMs,
      config,
    );
    if (!lighting.measurable) return assessment;
    return Object.freeze({
      ...assessment,
      ...(lighting.cue && assessment.ok ? { ok: false, code: 'uneven_cheek_light' } : {}),
      lighting,
    });
  }
  function luminanceForNormalizedBox(imageData, width, height, box) {
    const x1 = Math.max(0, Math.min(width, Math.floor(box.x1 * width)));
    const x2 = Math.max(0, Math.min(width, Math.ceil(box.x2 * width)));
    const y1 = Math.max(0, Math.min(height, Math.floor(box.y1 * height)));
    const y2 = Math.max(0, Math.min(height, Math.ceil(box.y2 * height)));
    if (x2 <= x1 || y2 <= y1) return null;
    let sum = 0; let count = 0;
    for (let y = y1; y < y2; y += 1) {
      for (let x = x1; x < x2; x += 1) {
        const i = (y * width + x) * 4;
        sum += (0.2126 * imageData[i] + 0.7152 * imageData[i + 1] + 0.0722 * imageData[i + 2]) / 255;
        count += 1;
      }
    }
    return count ? sum / count : null;
  }
  function cheekLuminanceFromPixels(imageData, width, height, boxes) {
    return Object.freeze({
      cheekLeftLuminance: luminanceForNormalizedBox(imageData, width, height, boxes.left),
      cheekRightLuminance: luminanceForNormalizedBox(imageData, width, height, boxes.right),
    });
  }
  function cheekBoxesFromLandmarks(landmarks) {
    if (!Array.isArray(landmarks) || landmarks.length <= 454) return null;
    const point = (index) => landmarks[index] && { x: finite(landmarks[index].x, NaN), y: finite(landmarks[index].y, NaN) };
    const leftBoundary = point(234); const rightBoundary = point(454); const nose = point(1);
    const eyeA = point(33); const eyeB = point(263); const mouthA = point(13); const mouthB = point(14);
    const forehead = point(10); const chin = point(152);
    if (![leftBoundary, rightBoundary, nose, eyeA, eyeB, mouthA, mouthB, forehead, chin].every((p) => p && Number.isFinite(p.x) && Number.isFinite(p.y))) return null;
    const topFace = Math.min(forehead.y, chin.y); const faceHeight = Math.abs(chin.y - forehead.y);
    if (faceHeight < 0.05 || nose.x <= leftBoundary.x || nose.x >= rightBoundary.x) return null;
    const eyeY = (eyeA.y + eyeB.y) / 2; const mouthY = (mouthA.y + mouthB.y) / 2;
    const y1 = Math.max(eyeY + 0.025 * faceHeight, topFace + 0.40 * faceHeight);
    const y2 = Math.min(mouthY - 0.035 * faceHeight, topFace + 0.69 * faceHeight);
    if (y2 <= y1) return null;
    const leftSpan = nose.x - leftBoundary.x; const rightSpan = rightBoundary.x - nose.x;
    const imageLeft = Object.freeze({ x1: leftBoundary.x + 0.14 * leftSpan, x2: leftBoundary.x + 0.76 * leftSpan, y1, y2 });
    const imageRight = Object.freeze({ x1: nose.x + 0.24 * rightSpan, x2: rightBoundary.x - 0.12 * rightSpan, y1, y2 });
    // The front-camera frame is unmirrored: image-right is the subject's left cheek.
    return Object.freeze({ left: imageRight, right: imageLeft });
  }
  function cheekLuminanceOf(video, landmarks, canvas = document.createElement('canvas'), config = CONFIG) {
    const boxes = cheekBoxesFromLandmarks(landmarks);
    const width = config.cheekLightSampleWidth || 96; const height = config.cheekLightSampleHeight || 96;
    if (!boxes || !video || !(video.videoWidth || video.width) || !(video.videoHeight || video.height)) {
      return { cheekLeftLuminance: null, cheekRightLuminance: null };
    }
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return { cheekLeftLuminance: null, cheekRightLuminance: null };
    canvas.width = width; canvas.height = height;
    ctx.drawImage(video, 0, 0, width, height);
    const pixels = ctx.getImageData(0, 0, width, height).data;
    const result = cheekLuminanceFromPixels(pixels, width, height, boxes);
    const color = cheekColorFromPixels(pixels, width, height, boxes);
    ctx.clearRect(0, 0, width, height);
    return { ...result, ...color };
  }
  function grayscaleThumbnail(source, canvasFactory = () => document.createElement('canvas'), config = CONFIG) {
    const width = config.mirrorThumbnailWidth; const height = config.mirrorThumbnailHeight;
    const canvas = canvasFactory(); canvas.width = width; canvas.height = height;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) throw new Error('mirror_canvas_unavailable');
    ctx.drawImage(source, 0, 0, width, height);
    const rgba = ctx.getImageData(0, 0, width, height).data;
    const gray = new Array(width * height);
    for (let p = 0, i = 0; i < rgba.length; i += 4, p += 1) gray[p] = 0.2126 * rgba[i] + 0.7152 * rgba[i + 1] + 0.0722 * rgba[i + 2];
    ctx.clearRect(0, 0, width, height); canvas.width = 1; canvas.height = 1;
    return gray;
  }
  async function comparePhotoToVideo(blob, video, createBitmap = (source, options) => createImageBitmap(source, options), canvasFactory = () => document.createElement('canvas'), config = CONFIG) {
    let bitmap;
    try {
      bitmap = await createBitmap(blob, { imageOrientation: 'from-image' });
      const videoWidth = Number(video && (video.videoWidth || video.width));
      const videoHeight = Number(video && (video.videoHeight || video.height));
      if (!videoWidth || ! videoHeight || !bitmap.width || !bitmap.height
        || Math.abs(Math.log((bitmap.width / bitmap.height) / (videoWidth / videoHeight))) > 0.08) {
        return Object.freeze({ mirrorCorrected: 'dudoso', normalCorrelation: null, mirroredCorrelation: null });
      }
      const referenceGray = grayscaleThumbnail(video, canvasFactory, config);
      const photoGray = grayscaleThumbnail(bitmap, canvasFactory, config);
      return detectPhotoMirrorOrientation(referenceGray, photoGray, config.mirrorThumbnailWidth, config.mirrorThumbnailHeight, config);
    } catch (_) {
      return Object.freeze({ mirrorCorrected: 'dudoso', normalCorrelation: null, mirroredCorrelation: null });
    } finally {
      if (bitmap && typeof bitmap.close === 'function') bitmap.close();
    }
  }
  function guideFor(code, step) {
    const messages = {
      no_face: ['◌', 'Coloca el rostro completo dentro del óvalo.'],
      face_too_small: ['↗', 'Acércate un poco a la cámara.'],
      face_too_large: ['↙', 'Aléjate un poco para mostrar el rostro completo.'],
      center_face: ['⊙', 'Centra el rostro dentro del óvalo.'],
      level_head: ['↔', 'Mantén la cabeza recta.'],
      more_light: ['☼', 'Busca luz frontal uniforme.'],
      less_light: ['☼', 'Reduce la luz directa sobre el rostro.'],
      uneven_cheek_light: ['☼', 'La luz llega más de un lado. Ponte de frente a la luz.'],
      warm_light: ['☼', 'La luz es muy amarilla. Si puedes, acércate a una ventana o a una luz blanca.'],
      mixed_light: ['☼', 'Hay luz de distinto color a cada lado. Ponte de frente a una sola luz.'],
      look_front: ['◎', 'Mira al frente.'],
      turn_left: ['←', 'Gira suavemente a tu izquierda, unos tres cuartos.'],
      turn_right: ['→', 'Gira suavemente a tu derecha, unos tres cuartos.'],
      turn_less: ['↩', 'Gira un poco menos, vuelve hacia el frente.'],
      cheek_landmarks_missing: ['◌', 'Ajusta un poco el giro para que podamos ver la mejilla.'],
      cheek_left_not_visible: ['←', 'Gira un poco más a tu izquierda para mostrar la mejilla.'],
      cheek_right_not_visible: ['→', 'Gira un poco más a tu derecha para mostrar la mejilla.'],
      matrix_yaw_unavailable: ['◌', 'No está disponible la guía de giro. Vuelve a iniciar el detector.'],
      ready: ['●', step === 'frontal' ? 'Quédate quieto; tomaremos la foto.' : 'Mantén el giro; tomaremos la foto.'],
      matrix_yaw_unavailable: ['◌', 'No está disponible la guía de giro. Vuelve a iniciar el detector.'],
    };
    return messages[code] || messages.no_face;
  }
  function guideForAssessment(assessment, step) {
    const code = assessment && assessment.code || 'no_face';
    const face = normalizeFace(assessment && assessment.face);
    if (face && face.yawMatrixDeg !== null) {
      if (step === 'perfil_izq' && code === 'turn_right' && face.yawMatrixDeg < -CONFIG.profileYawMaxDeg) return guideFor('turn_less', step);
      if (step === 'perfil_der' && code === 'turn_left' && face.yawMatrixDeg > CONFIG.profileYawMaxDeg) return guideFor('turn_less', step);
    }
    return guideFor(code, step);
  }
  function fitOval(media, frame, oval, config = CONFIG) {
    const sourceW = media.videoWidth || media.width; const sourceH = media.videoHeight || media.height;
    let availableWidth = frame.parentElement ? frame.parentElement.clientWidth : frame.clientWidth;
    if (frame.parentElement && typeof getComputedStyle === 'function') {
      const columns = getComputedStyle(frame.parentElement).gridTemplateColumns.split(/\s+/).filter(Boolean);
      const firstColumnWidth = Number.parseFloat(columns[0]);
      if (columns.length > 1 && Number.isFinite(firstColumnWidth)) availableWidth = firstColumnWidth;
    }
    const hasViewport = typeof window !== 'undefined' && Number(window.innerHeight);
    const maxHeight = hasViewport ? Math.min(window.innerHeight * config.frameMaxHeightVh, 720) : (frame.clientHeight || 720);
    if (!availableWidth || !maxHeight || !sourceW || !sourceH) return;
    const aspect = sourceW / sourceH;
    const frameW = Math.min(availableWidth, maxHeight * aspect);
    const frameH = frameW / aspect;
    frame.style.width = `${frameW}px`; frame.style.height = `${frameH}px`; frame.style.aspectRatio = `${sourceW} / ${sourceH}`;
    const shownHeight = frameH;
    const ovalHeight = shownHeight * config.ovalHeight;
    oval.style.height = `${ovalHeight}px`; oval.style.width = `${ovalHeight * config.ovalWidthRatio}px`;
    const frameRect = frame.getBoundingClientRect(); const ovalRect = oval.getBoundingClientRect();
    const guidePlacement = turnGuideVerticalPlacement(frameRect.width, frameRect.height, ovalRect.height, 6, 10);
    frame.style.setProperty('--a2-oval-bottom', `${guidePlacement.ovalBottom}px`);
    frame.style.setProperty('--a2-turn-guide-top', `${guidePlacement.top}px`);
  }
  function pixelOrientedJpeg(video, config = CONFIG) {
    return new Promise((resolve, reject) => {
      const width = video.videoWidth; const height = video.videoHeight;
      if (!width || !height) return reject(new Error('El fotograma de cámara aún no está disponible.'));
      const canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
      const ctx = canvas.getContext('2d');
      // Captura cruda y sin espejo; refleja la imagen de video, no el canvas.
      ctx.drawImage(video, 0, 0, width, height);
      canvas.toBlob((blob) => {
        ctx.clearRect(0, 0, width, height);
        canvas.width = 1; canvas.height = 1;
        if (!blob) reject(new Error('No se pudo crear la foto en memoria.'));
        else resolve({ blob, width, height, mimeType: 'image/jpeg' });
      }, 'image/jpeg', config.jpegQuality);
    });
  }
  function photoYawCode(faceInput, step, config = CONFIG) {
    const face = normalizeFace(faceInput);
    if (!face) return 'no_face';
    if (face.yawMatrixDeg === null) return 'matrix_yaw_unavailable';
    const yaw = face.yawMatrixDeg;
    if (step === 'frontal' && Math.abs(yaw) > config.frontalYawMaxDeg) return 'look_front';
    if (step === 'perfil_izq' && !(yaw <= -config.profileYawMinDeg && yaw >= -config.profileYawMaxDeg)) return 'turn_right';
    if (step === 'perfil_der' && !(yaw >= config.profileYawMinDeg && yaw <= config.profileYawMaxDeg)) return 'turn_left';
    return 'ready';
  }
  function markerAnimationPosition(previous, now) {
    if (!previous) return 0;
    const elapsed = Math.max(0, finite(now) - finite(previous.startAt));
    const duration = Math.max(1, finite(previous.duration, 1));
    const progress = Math.max(0, Math.min(1, elapsed / duration));
    return finite(previous.from) + (finite(previous.to) - finite(previous.from)) * progress;
  }
  function markerAnimationPlan(previous, now, to, duration) {
    return Object.freeze({ from: markerAnimationPosition(previous, now), to: finite(to), startAt: finite(now), duration: Math.max(1, finite(duration, 1)) });
  }
  function photoCaptureOptionsFromCapabilities(capabilities) {
    if (!capabilities || typeof capabilities !== 'object') return null;
    const options = {};
    if (Array.isArray(capabilities.fillLightMode) && capabilities.fillLightMode.includes('off')) options.fillLightMode = 'off';
    if (Object.prototype.hasOwnProperty.call(capabilities, 'redEyeReduction')) options.redEyeReduction = false;
    return Object.keys(options).length ? Object.freeze(options) : null;
  }
  function turnGuideGeometry(yaw,config=CONFIG,measuredWidth=140){const value=Number.isFinite(Number(yaw))?Math.max(0,Math.min(40,Number(yaw))):0,min=config.profileYawMinDeg,max=config.profileYawMaxDeg;return Object.freeze({inTarget:value>=min&&value<=max,bandStartPct:min/40*100,bandWidthPct:(max-min)/40*100,pointOffsetPx:value/40*measuredWidth-measuredWidth/2})}
  function detectionDimensions(width, height, maxLongSide = 960) {
    const w = Math.max(0, Math.round(finite(width))); const h = Math.max(0, Math.round(finite(height)));
    if (!w || !h) return { width: 0, height: 0 };
    const scale = Math.min(1, finite(maxLongSide, 960) / Math.max(w, h));
    return { width: Math.max(1, Math.round(w * scale)), height: Math.max(1, Math.round(h * scale)) };
  }
  function turnGuideVerticalPlacement(frameWidth, frameHeight, ovalHeight, barHeight = 6, gap = 10) {
    const fw = Math.max(0, finite(frameWidth)); const fh = Math.max(0, finite(frameHeight));
    const oh = Math.max(0, finite(ovalHeight)); const ovalBottom = (fh + oh) / 2;
    const freeHeight = Math.max(0, fh - ovalBottom); const clearance = Math.max(0, finite(gap, 10));
    const top = freeHeight >= barHeight + clearance * 2
      ? ovalBottom + (freeHeight - barHeight) / 2
      : ovalBottom + clearance;
    const barBottom = top + barHeight;
    return Object.freeze({ ovalBottom, top, barBottom, frameBottom: fh, belowOval: top >= ovalBottom + clearance - .01, insideFrame: barBottom <= fh - clearance + .01, topClearance: top - ovalBottom, bottomClearance: fh - barBottom, frameWidth: fw });
  }
  function captureInstructionForStep(step) { return step === 'frontal' ? 'Mira al frente' : step === 'perfil_izq' ? 'Gira a tu derecha' : step === 'perfil_der' ? 'Gira a tu izquierda' : ''; }
  function capturePillMessage(step, code, yawProgress, quiet = false) {
    if (code === 'more_light' || code === 'uneven_cheek_light' || code === 'warm_light' || code === 'mixed_light') return 'Busca más luz';
    if (code === 'less_light') return 'Reduce luz directa';
    if (!code || code === 'no_face') return 'Coloca tu rostro en el óvalo';
    if (code === 'face_too_small') return 'Acércate';
    if (code === 'face_too_large') return 'Aléjate';
    if (code === 'center_face') return 'Al centro';
    if (code === 'level_head') return 'Endereza la cabeza';
    if (code === 'look_front') return 'Mira al frente';
    if (step !== 'frontal') {
      if (Number.isFinite(yawProgress) && yawProgress > CONFIG.profileYawMaxDeg) return 'Un poco menos';
      if (Number.isFinite(yawProgress) && yawProgress >= 5 && yawProgress < CONFIG.profileYawMinDeg) return 'Un poco más';
      if (code === 'ready') return quiet ? 'Quédate quieto' : 'Perfecto';
      return step === 'perfil_izq' ? 'Gira a tu derecha' : 'Gira a tu izquierda';
    }
    if (code === 'ready') return quiet ? 'Quédate quieto' : 'Perfecto';
    return 'Coloca tu rostro en el óvalo';
  }
  function ovalColorState(assessmentOk, stableForMs, stabilityMs = CONFIG.stabilityHoldMs, capturedHold = false) {
    return capturedHold || (assessmentOk && stableForMs >= stabilityMs) ? 'green' : 'copper';
  }
  function scaledPhotoDimensions(width, height, maxLongSide = CONFIG.photoMaxLongSide) {
    const w = Math.max(0, Math.round(finite(width))); const h = Math.max(0, Math.round(finite(height)));
    if (!w || !h) return { width: 0, height: 0 };
    const scale = Math.min(1, finite(maxLongSide, CONFIG.photoMaxLongSide) / Math.max(w, h));
    return { width: Math.max(1, Math.round(w * scale)), height: Math.max(1, Math.round(h * scale)) };
  }
  function bitmapToJpeg(bitmap, config = CONFIG, canvasFactory = () => document.createElement('canvas'), mirrorHorizontal = false) {
    const dimensions = scaledPhotoDimensions(bitmap.width, bitmap.height, config.photoMaxLongSide);
    if (!dimensions.width || !dimensions.height) return Promise.reject(new Error('La foto no tiene dimensiones válidas.'));
    const canvas = canvasFactory(); canvas.width = dimensions.width; canvas.height = dimensions.height;
    const context = canvas.getContext('2d');
    if (!context) return Promise.reject(new Error('No se pudo preparar la foto.'));
    if (mirrorHorizontal) {
      context.translate(dimensions.width, 0);
      context.scale(-1, 1);
    }
    context.drawImage(bitmap, 0, 0, dimensions.width, dimensions.height);
    if (mirrorHorizontal && typeof context.setTransform === 'function') context.setTransform(1, 0, 0, 1, 0, 0);
    return new Promise((resolve, reject) => canvas.toBlob((blob) => {
      context.clearRect(0, 0, canvas.width, canvas.height); canvas.width = 1; canvas.height = 1;
      if (!blob) reject(new Error('No se pudo comprimir la foto.'));
      else resolve({ blob, width: dimensions.width, height: dimensions.height, mimeType: 'image/jpeg' });
    }, 'image/jpeg', config.jpegQuality));
  }
  async function validateAndEncodePhoto(blob, landmarker, step, brightness = 0.5, config = CONFIG, createBitmap = (source, options) => createImageBitmap(source, options), canvasFactory, requirePortrait = true, mirrorHorizontal = false) {
    let bitmap;
    try { bitmap = await createBitmap(blob, { imageOrientation: 'from-image' }); }
    catch (_) { return { ok: false, code: 'photo_decode_failed' }; }
    try {
      const sourceWidth = Number(bitmap.width) || 0; const sourceHeight = Number(bitmap.height) || 0;
      if (!sourceWidth || !sourceHeight) return { ok: false, code: 'photo_dimensions_invalid' };
      if (requirePortrait && sourceWidth > sourceHeight) return { ok: false, code: 'photo_horizontal', sourceWidth, sourceHeight };
      if (!landmarker || typeof landmarker.detectForVideo !== 'function') return { ok: false, code: 'detector_unavailable', sourceWidth, sourceHeight };
      const detectSize = detectionDimensions(sourceWidth, sourceHeight, 960);
      const detectionCanvas = (canvasFactory || (() => document.createElement('canvas')))();
      detectionCanvas.width = detectSize.width; detectionCanvas.height = detectSize.height;
      const detectionContext = detectionCanvas.getContext('2d');
      if (!detectionContext) return { ok: false, code: 'photo_detection_copy_failed', sourceWidth, sourceHeight };
      detectionContext.drawImage(bitmap, 0, 0, detectSize.width, detectSize.height);
      let result;
      try { result = landmarker.detectForVideo(detectionCanvas, typeof performance !== 'undefined' ? performance.now() : Date.now()); }
      catch (_) { detectionContext.clearRect(0, 0, detectSize.width, detectSize.height); detectionCanvas.width = 1; detectionCanvas.height = 1; return { ok: false, code: 'photo_detection_failed', sourceWidth, sourceHeight }; }
      const landmarks = result && result.faceLandmarks && result.faceLandmarks[0];
      const matrix = result && result.facialTransformationMatrixes && result.facialTransformationMatrixes[0];
      const detected = faceFromLandmarks(landmarks, brightness, matrix, detectSize.width, detectSize.height);
      const face = mirrorHorizontal && detected && detected.yawMatrixDeg !== null
        ? { ...detected, yawMatrixDeg: -detected.yawMatrixDeg, yawDeg: -detected.yawDeg, yawHeuristicDeg: -detected.yawHeuristicDeg }
        : detected;
      const code = photoYawCode(face, step, config);
      if (code !== 'ready') { detectionContext.clearRect(0, 0, detectSize.width, detectSize.height); detectionCanvas.width = 1; detectionCanvas.height = 1; return { ok: false, code, face, sourceWidth, sourceHeight }; }
      const encoded = await bitmapToJpeg(bitmap, config, canvasFactory, mirrorHorizontal);
      detectionContext.clearRect(0, 0, detectSize.width, detectSize.height); detectionCanvas.width = 1; detectionCanvas.height = 1;
      return { ok: true, code: 'ready', face, sourceWidth, sourceHeight, ...encoded };
    } finally { if (bitmap && typeof bitmap.close === 'function') bitmap.close(); }
  }
  function browserDeviceFamilyFromUserAgent(userAgent) {
    const ua = String(userAgent || '');
    const ios = /iPhone|iPad|iPod/i.test(ua);
    const android = /Android/i.test(ua);
    const samsung = android && /Samsung|SM-[A-Z0-9]+/i.test(ua);
    const browser = /SamsungBrowser/i.test(ua) ? 'Samsung Internet'
      : /EdgA?|EdgiOS/i.test(ua) ? 'Edge'
        : /FxiOS|Firefox/i.test(ua) ? 'Firefox'
          : /CriOS|Chrome/i.test(ua) ? 'Chrome'
            : /OPR|Opera/i.test(ua) ? 'Opera'
              : /Safari/i.test(ua) ? 'Safari' : '';
    if (ios) return `iOS ${browser || 'Safari'}`;
    if (android) return `Android ${browser || 'Browser'}${samsung ? ' Samsung' : ''}`;
    if (/Windows|Macintosh|Mac OS|Linux/i.test(ua)) return `Desktop ${browser || 'Browser'}`;
    return 'Navegador';
  }
  function reducedTrackSettings(track) {
    let settings = {};
    try { settings = track && typeof track.getSettings === 'function' ? track.getSettings() || {} : {}; } catch (_) { settings = {}; }
    const number = (value) => Number.isFinite(Number(value)) && Number(value) >= 0 ? Number(value) : null;
    return Object.freeze({ width: number(settings.width), height: number(settings.height), frameRate: number(settings.frameRate) });
  }
  function facePointOfInterest(landmarks) {
    if (!Array.isArray(landmarks) || landmarks.length <= 454) return null;
    const left = landmarks[234]; const right = landmarks[454]; const top = landmarks[10]; const bottom = landmarks[152];
    if (![left, right, top, bottom].every((point) => point && Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y)))) return null;
    return { x: Math.max(0, Math.min(1, (Number(left.x) + Number(right.x)) / 2)), y: Math.max(0, Math.min(1, (Number(top.y) + Number(bottom.y)) / 2)) };
  }
  async function applyFacePointsOfInterest(track, point, capabilities) {
    if (!track || typeof track.applyConstraints !== 'function' || !capabilities || !Object.prototype.hasOwnProperty.call(capabilities, 'pointsOfInterest')) return false;
    if (!point || !Number.isFinite(Number(point.x)) || !Number.isFinite(Number(point.y))) return false;
    try { await track.applyConstraints({ advanced: [{ pointsOfInterest: [{ x: Number(point.x), y: Number(point.y) }] }] }); return true; }
    catch (_) { return false; }
  }
  const API = Object.freeze({ CONFIG, STEP_ORDER, classifyCameraError, assessFrame, stableEnough, ovalColorState, yawFromTransformationMatrix, faceFromLandmarks, simulatedLandmarks, simulatedMatrix, targetCheekShare, diagnosticEnabled, diagnosticReason, calibrationMetric, calibrationExport, guideFor, guideForAssessment, fitOval, pixelOrientedJpeg, photoYawCode, detectionDimensions, turnGuideVerticalPlacement, captureInstructionForStep, markerAnimationPosition, markerAnimationPlan, photoCaptureOptionsFromCapabilities, brightnessFromPixels, capturePillMessage, turnGuideGeometry, scaledPhotoDimensions, bitmapToJpeg, validateAndEncodePhoto, pearsonCorrelation, horizontallyFlippedGray, detectPhotoMirrorOrientation, evaluateCheekLighting, applyFrontalLightingAssessment, cheekBoxesFromLandmarks, cheekLuminanceFromPixels, cheekColorFromPixels, rgbToLab, evaluateCheekColor, evaluateExperimentalLighting, experimentalLightingForSearch, screenLightOpacity, sanitizeCameraCapabilities, cameraLockPlan, automaticCameraModesPlan, deviceCapabilitiesForLogging, facePointOfInterest, applyFacePointsOfInterest, browserDeviceFamilyFromUserAgent, reducedTrackSettings, distanceModeFromSearch, configForDistanceMode, focusModesFromCapabilities, lightingTestEnabledFromSearch });
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  function install(root) {
    if (!root || root.dataset.a2Installed === 'true') return;
    root.dataset.a2Installed = 'true';
    const q = (selector) => root.querySelector(selector);
    const video = q('[data-a2-video]'); const simulated = q('[data-a2-simulated-video]');
    const guideText = q('[data-a2-guidance-text]'); const guideIcon = q('[data-a2-guidance-icon]');
    const manual = q('[data-a2-manual]'); const retry = q('[data-a2-retry]'); const retryDetector = q('[data-a2-retry-detector]');
    const message = q('[data-a2-message]'); const messageTitle = q('[data-a2-message-title]'); const messageText = q('[data-a2-message-text]');
    const captureView = q('[data-a2-capture-view]'); const completeView = q('[data-a2-complete]');
    const debugPanel = q('[data-a2-debug]');
    const debugTools = q('[data-a2-debug-tools]');
    const countdownNode = q('[data-a2-countdown]'); const visualCue = q('[data-a2-visual-cue]');
    const frameNode = q('[data-a2-frame]'); const ovalNode = q('[data-a2-oval]');
    const debugOutput = q('[data-a2-debug-output]');
    const debugCopyStatus = q('[data-a2-debug-copy-status]');
    const debugThumbnails = q('[data-a2-debug-thumbnails]');
    const debugMode = diagnosticEnabled(window.location && window.location.search);
    const distanceMode = distanceModeFromSearch(window.location && window.location.search);
     const captureConfig = configForDistanceMode(distanceMode);
     const lightTestMode = lightingTestEnabledFromSearch(window.location && window.location.search);
     const state = { active:false, stopping:false, capturing:false, countdownActive:false, stream:null, imageCapture:null, photoCapabilitiesPromise:null, photoCaptureOptions:null, photoOptionsUnsupported:false, landmarker:null, detectorPromise:null, delegate:null, warmedLandmarker:null, pointRaf:0, pointLastFrameAt:0, pointCurrentYaw:0, pointTargetYaw:0, pointFilteredYaw:0, pointLastDetectionAt:0, markerAnimation:null, markerAnimationPlan:null, turnGuideWidth:0, lastPointTransform:'', nextDetectionDelayMs:66, lastDetectDurationMs:0, detectDurations:[], detectTimes:[], drawImageDurations:[], drawImageLastMs:0, sampleDrawImageDurations:[], sampleDrawImageLastMs:0, detectorCanvas:null, detectorContext:null, detectorSize:{width:0,height:0}, sampleCanvas:null, sampleContext:null, videoFrameTimes:[], videoFpsCallback:0, shutterTimeline:debugMode?[]:null, activeShutterEntry:null, activeShutterAttempt:null, shutterTraceActive:false, shutterRafProbeId:0, detectInProgress:false, lastDetectEndedAt:0, lastPerfPanelUpdateAt:0, diagnosticBaseText:'', frameDeltas:[], longTaskTimes:[], longTaskCount:0, longTaskObserver:null, cameraControlsLockPromise: null, animation: 0, animationKind: '', visualCommitRaf: 0, pendingVisual: null, timer: 0, guideTimer: 0, visualCueHideTimer: 0, guidanceSwapTimer: 0, pillSwapTimer: 0, pillText: '', flashTimer: 0, flashAnimation:null, cameraExitAnimation:null, retryMessageTimer: 0, retryPhotoMessage: false, retryRequested: '', currentGuide: '', pendingGuide: '', step: 0, captures: Object.create(null), pendingValidations: Object.create(null), captureMetadata: null, lightingGuideShown: false, lightingUnevenSince: 0, lightingTestSince: 0, warmCueShown: false, mixedCueShown: false, screenLightShown: false, screenLightOverlay: null, cameraCapabilities: null, frontCameraSettings: null, poiAttempted: false, poiPromise: null, poiApplied: false, exposureLocked: false, whiteBalanceLocked: false, exposureLockApplied: false, whiteBalanceLockApplied: false, age: null, consents: null, previousFace: null, stabilityReference: null, faceDetectedAt: 0, pauseUntil: 0, normalCountdownToken: 0, countdownStartedAt: 0, captureGreenHold: false, captureNoticeLabel: false, photoPoseRetryStep: -1, photoPoseRetryCount: 0, currentAssessment: null, stableSince: 0, startedAt: 0, lastAutoCapture: 0, lastDetectionAt: 0, lastBrightnessAt: 0, lastCheekLightAt: 0, cachedBrightness: null, cachedCheekLight: null, analysisTotalMs: 0, analysisCount: 0, visualFace: null, turnGuide: null, turnGuideMarker: null, turnGuideTarget: null, chevrons: null, topbarStep: null, topbarCount: null, countdownVisual: null, cameraPillBase: null, captureFlash: null, simulatedFace: null, debugMetrics: [], debugThumbnails: [], lastCapturedStep: -1 };
     const cameraPill = q('[data-a2-camera-pill]') || q('.rogma-a2__camera-pill');
      initCaptureVisuals();
     function cameraTrack() { return state.stream && state.stream.getVideoTracks ? state.stream.getVideoTracks()[0] : null; }
     function readTrackCapabilities(track) { try { return track && typeof track.getCapabilities === 'function' ? track.getCapabilities() || {} : {}; } catch (_) { return {}; } }
     function readTrackSettings(track) { try { return track && typeof track.getSettings === 'function' ? track.getSettings() || {} : {}; } catch (_) { return {}; } }
     function initCaptureVisuals() {
       if (manual) { if (debugMode) manual.disabled = true; else manual.remove(); }
       const manualHelp = q('[data-a2-no-face-help]'); if (manualHelp) manualHelp.remove();
       if (countdownNode) { countdownNode.removeAttribute('aria-live'); countdownNode.setAttribute('aria-hidden', 'true'); }
       if (visualCue && typeof document.createElement === 'function' && !visualCue.querySelector('.rogma-a2__chevrons')) {
         const oldArrow = visualCue.querySelector('.rogma-a2__visual-arrow'); if (oldArrow) oldArrow.hidden = true;
         const cue = document.createElement('span'); cue.className = 'rogma-a2__chevrons'; cue.setAttribute('aria-hidden', 'true');
         for (let i = 0; i < 3; i += 1) { const chevron = document.createElement('span'); chevron.textContent = '›'; cue.append(chevron); }
         visualCue.append(cue); state.chevrons = cue;
       }
       const topbar = document.createElement('div'); topbar.className = 'rogma-a2__capture-topbar';
       const brand = document.createElement('strong'); brand.className = 'rogma-a2__capture-brand'; brand.textContent = 'RŌGMA IA SKIN RITUAL';
       const stepWrap = document.createElement('div'); stepWrap.className = 'rogma-a2__capture-step-wrap';
       state.topbarStep = document.createElement('span'); state.topbarStep.className = 'rogma-a2__capture-step';
       state.topbarCount = document.createElement('small'); state.topbarCount.className = 'rogma-a2__capture-count';
       stepWrap.append(state.topbarStep, state.topbarCount); topbar.append(brand, stepWrap);
       if (captureView && frameNode) captureView.insertBefore(topbar, frameNode);
       const turnGuide = document.createElement('div'); turnGuide.className = 'rogma-a2__turn-guide'; turnGuide.setAttribute('aria-hidden', 'true');
       const turnTrack = document.createElement('span'); turnTrack.className = 'rogma-a2__turn-guide-track';
       const targetMark = document.createElement('span'); targetMark.className = 'rogma-a2__turn-guide-target';
       const marker = document.createElement('span'); marker.className = 'rogma-a2__turn-guide-marker';
       turnGuide.append(turnTrack,targetMark,marker);targetMark.style.left=`${CONFIG.profileYawMinDeg/40*100}%`;targetMark.style.width=`${(CONFIG.profileYawMaxDeg-CONFIG.profileYawMinDeg)/40*100}%`;state.turnGuide=turnGuide; state.turnGuideMarker = marker; state.turnGuideTarget = targetMark;
       if (frameNode) frameNode.append(turnGuide);
       if (cameraPill) {
         cameraPill.textContent = ''; cameraPill.removeAttribute('aria-hidden'); cameraPill.setAttribute('role', 'status');
         cameraPill.setAttribute('aria-live', 'polite'); cameraPill.setAttribute('aria-atomic', 'true'); state.cameraPillBase = cameraPill;
         cameraPill.textContent = 'Coloca tu rostro en el óvalo'; state.pillText = 'Coloca tu rostro en el óvalo';
       }
       if (frameNode && cameraPill) frameNode.after(cameraPill);
       const guidance = q('[data-a2-guidance]');
       if (guidance) { guidance.removeAttribute('role'); guidance.removeAttribute('aria-live'); guidance.setAttribute('aria-hidden', 'true'); }
       if (message) { message.removeAttribute('role'); message.removeAttribute('aria-live'); message.setAttribute('aria-hidden', 'true'); }
       if (debugPanel) debugPanel.removeAttribute('aria-live');
       if (debugCopyStatus) debugCopyStatus.removeAttribute('aria-live');
       const liveLabel = q('.rogma-a2__live-label');
       if (liveLabel) liveLabel.textContent = '';
       let captureFlash = q('[data-a2-capture-flash]') || q('.rogma-a2__capture-flash');
       if (!captureFlash && frameNode) { captureFlash = document.createElement('div'); captureFlash.className = 'rogma-a2__capture-flash'; captureFlash.setAttribute('aria-hidden', 'true'); frameNode.append(captureFlash); }
       if (captureFlash) { captureFlash.hidden = false; captureFlash.removeAttribute('hidden'); captureFlash.style.display = 'block'; if (frameNode && captureFlash.parentElement !== frameNode) frameNode.append(captureFlash); }
       state.captureFlash = captureFlash;
     }
     function updateOvalState(now, assessment) {
       if (!ovalNode) return;
       const stableFor = assessment && assessment.ok && state.stableSince ? now - state.stableSince : 0;
       ovalNode.classList.toggle('is-ready', ovalColorState(Boolean(assessment && assessment.ok), stableFor, CONFIG.stabilityHoldMs, state.captureGreenHold) === 'green');
       ovalNode.classList.toggle('is-captured-flash', state.captureGreenHold);
     }
     function smoothVisualFace(face, stepName) {
       if (face && [face.centerX, face.centerY, face.width, face.height].every(Number.isFinite)) {
         const previous = state.visualFace; const alpha = 0.4;
         const yaw = Number(face.yawMatrixDeg);
         const yawProgress = Number.isFinite(yaw) ? Math.max(0, Math.min(40, yaw * (stepName === 'perfil_izq' ? -1 : 1))) : 0;
         const visualInput = { ...face, _visualYawProgress: yawProgress };
         state.visualFace = previous ? {
           centerX: previous.centerX + alpha * (visualInput.centerX - previous.centerX),
           centerY: previous.centerY + alpha * (visualInput.centerY - previous.centerY),
           width: previous.width + alpha * (visualInput.width - previous.width),
           height: previous.height + alpha * (visualInput.height - previous.height),
           yawProgress: previous.yawProgress + alpha * (visualInput._visualYawProgress - previous.yawProgress),
         } : { centerX: visualInput.centerX, centerY: visualInput.centerY, width: visualInput.width, height: visualInput.height, yawProgress: visualInput._visualYawProgress };
       }
       const visual = state.visualFace; if (!visual || !frameNode) return;
       const targetHeight = (CONFIG.faceHeightMin + CONFIG.faceHeightMax) / 2;
       const scale = Math.max(0.94, Math.min(1.06, visual.height / targetHeight));
       const offsetX = Math.max(-8, Math.min(8, (visual.centerX - 0.5) * frameNode.clientWidth * 0.12));
       const offsetY = Math.max(-8, Math.min(8, (visual.centerY - 0.5) * frameNode.clientHeight * 0.12));
       state.visualStyle = { scale, offsetX, offsetY };
     }
     function startLongTaskObserver(){if(!debugMode||typeof PerformanceObserver!=='function'||state.longTaskObserver)return;try{state.longTaskObserver=new PerformanceObserver(list=>{list.getEntries().filter(e=>e.duration>50).forEach(()=>{state.longTaskCount++;state.longTaskTimes.push(performance.now())})});state.longTaskObserver.observe({type:'longtask',buffered:true})}catch(_){state.longTaskObserver=null}}
     function shutterNowMs() { return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now(); }
     function recordShutterEvent(event, details = {}, timestamp = shutterNowMs()) {
       if (!debugMode || !state.activeShutterAttempt) return;
       state.activeShutterAttempt.events.push({ event, ms: Number((timestamp - state.activeShutterAttempt.originTime).toFixed(2)), ...details });
     }
     function beginShutterTimeline(step, origin) {
       if (!debugMode) return null;
       const originTime = shutterNowMs();
       let entry = state.shutterTimeline.find((item) => item.step === step);
       if (!entry) { entry = { step, attempts: [] }; state.shutterTimeline.push(entry); }
       const attempt = { origin, originTime, detect_in_progress_at_origin: Boolean(state.detectInProgress), last_detection_end_before_origin_ms: state.lastDetectEndedAt ? Number((state.lastDetectEndedAt - originTime).toFixed(2)) : null, events: [] };
       entry.attempts.push(attempt); state.activeShutterEntry = entry; state.activeShutterAttempt = attempt;
       recordShutterEvent(origin, {}, originTime);
       return attempt;
     }
     function shutterRafProbe(timestamp) {
       state.shutterRafProbeId = 0;
       if (!debugMode || !state.shutterTraceActive) return;
       recordShutterEvent('requestAnimationFrame', { frame_timestamp_ms: Number(timestamp) || shutterNowMs() }, Number(timestamp) || shutterNowMs());
       state.shutterRafProbeId = requestAnimationFrame(shutterRafProbe);
     }
     function startShutterTrace() {
       if (!debugMode) return;
       state.shutterTraceActive = true;
       if (!state.shutterRafProbeId) state.shutterRafProbeId = requestAnimationFrame(shutterRafProbe);
     }
     function finishShutterTrace(reason) {
       if (!debugMode) return;
       recordShutterEvent(reason);
       state.shutterTraceActive = false;
       if (state.shutterRafProbeId) cancelAnimationFrame(state.shutterRafProbeId);
       state.shutterRafProbeId = 0;
     }
     async function debugTimedTakePhoto(options, callName) {
       const startedAt = shutterNowMs();
       let opacity = null;
       try { if (state.captureFlash && typeof getComputedStyle === 'function') opacity = Number(getComputedStyle(state.captureFlash).opacity); } catch (_) {}
       recordShutterEvent('takePhoto_start', { call: callName, detect_in_progress: Boolean(state.detectInProgress), last_detection_end_before_photo_ms: state.lastDetectEndedAt ? Number((state.lastDetectEndedAt - state.activeShutterAttempt.originTime).toFixed(2)) : null, veil_opacity_before: Number.isFinite(opacity) ? opacity : null }, startedAt);
       try {
         const blob = options ? await state.imageCapture.takePhoto(options) : await state.imageCapture.takePhoto();
         recordShutterEvent('takePhoto_end', { call: callName, result: 'success', duration_ms: Number((shutterNowMs() - startedAt).toFixed(2)) });
         return blob;
       } catch (error) {
         recordShutterEvent('takePhoto_end', { call: callName, result: 'error', error: String(error && error.name || 'Error').slice(0, 80), duration_ms: Number((shutterNowMs() - startedAt).toFixed(2)) });
         throw error;
       }
     }
     function performanceSnapshot(){const fs=state.frameDeltas.slice(-60),ds=state.detectDurations.slice(-60).slice().sort((a,b)=>a-b),ts=state.detectTimes.slice(-60),draws=state.drawImageDurations.slice(-60),vts=state.videoFrameTimes.slice(-60),total=fs.reduce((a,b)=>a+b,0),avg=ds.length?ds.reduce((a,b)=>a+b,0)/ds.length:0,p95=ds.length?ds[Math.min(ds.length-1,Math.ceil(ds.length*.95)-1)]:0,rate=ts.length>1?(ts.length-1)*1000/(ts[ts.length-1]-ts[0]):0,settings=readTrackSettings(cameraTrack()),frameWindowMs=total||1000,cutoff=performance.now()-frameWindowMs,longWindow=state.longTaskTimes.filter(t=>t>=cutoff).length,videoFps=vts.length>1?(vts.length-1)*1000/(vts[vts.length-1]-vts[0]):0;return{frames_window:fs.length,ui_fps:total?fs.length*1000/total:0,detections_per_second:rate,detect_average_ms:avg,detect_p95_ms:p95,draw_image_average_ms:draws.length?draws.reduce((a,b)=>a+b,0)/draws.length:0,draw_image_last_ms:state.drawImageLastMs,sample_draw_image_average_ms:state.sampleDrawImageDurations.length?state.sampleDrawImageDurations.reduce((a,b)=>a+b,0)/state.sampleDrawImageDurations.length:0,sample_draw_image_last_ms:state.sampleDrawImageLastMs,detector_input_size:{width:state.detectorSize.width,height:state.detectorSize.height},video_fps:videoFps,long_tasks_over_50ms:longWindow,long_tasks_total:state.longTaskCount,main_thread_occupancy_pct:rate*avg/10,delegate:state.delegate||'no disponible',stream_resolution:{width:settings.width||video.videoWidth||0,height:settings.height||video.videoHeight||0},...(debugMode?{shutter_timeline:state.shutterTimeline||[]}:{})}}
     function pointAnimationFrame(t){state.pointRaf=0;if(!state.active){state.pointLastFrameAt=0;return}const now=Number.isFinite(t)?t:performance.now();if(state.pointLastFrameAt){const dt=Math.max(0,Math.min(100,now-state.pointLastFrameAt));state.frameDeltas.push(dt);if(state.frameDeltas.length>60)state.frameDeltas.shift();if(debugMode)updatePerfPanel()}state.pointLastFrameAt=now;state.pointRaf=requestAnimationFrame(pointAnimationFrame)}
     function startPointInterpolator(){if(state.pointRaf||!state.active)return;state.pointLastFrameAt=0;state.pointRaf=requestAnimationFrame(pointAnimationFrame);startLongTaskObserver()}
     function updatePerfPanel(){if(!debugPanel||!debugMode)return;const now=performance.now();if(now-state.lastPerfPanelUpdateAt<250)return;state.lastPerfPanelUpdateAt=now;const m=performanceSnapshot(),line=`Rendimiento: UI ${m.ui_fps.toFixed(1)} FPS · video ${m.video_fps.toFixed(1)} FPS · detecciones ${m.detections_per_second.toFixed(1)}/s · detector ${m.detector_input_size.width}×${m.detector_input_size.height} · drawImage detector ${m.draw_image_average_ms.toFixed(1)} ms (últ. ${m.draw_image_last_ms.toFixed(1)}) · muestreo ${m.sample_draw_image_average_ms.toFixed(1)} ms · detectForVideo prom ${m.detect_average_ms.toFixed(1)} ms p95 ${m.detect_p95_ms.toFixed(1)} ms · tareas largas ${m.long_tasks_over_50ms} · hilo ${m.main_thread_occupancy_pct.toFixed(1)}% · ${m.delegate} · stream ${m.stream_resolution.width}×${m.stream_resolution.height}`,txt=`${state.diagnosticBaseText} · ${line}`;if(debugPanel.textContent!==txt)debugPanel.textContent=txt}
     function commitVisualFrame(now, assessment, stepName) {
       state.visualCommitRaf = 0;
       if (!state.active && !isSimulation) return;
       const visual = state.pendingVisual || { now, assessment, stepName };
       state.pendingVisual = null;
       const style = state.visualStyle;
       if (style && visualCue) {
         const vars = [['--a2-cue-scale', String(style.scale)], ['--a2-cue-shift-x', `${style.offsetX}px`], ['--a2-cue-shift-y', `${style.offsetY}px`]];
         vars.forEach(([name, value]) => { if (visualCue.style.getPropertyValue(name) !== value) visualCue.style.setProperty(name, value); });
       }
       updateCaptureVisualCue(visual.stepName, visual.assessment);
       updateOvalState(visual.now, visual.assessment);
       updateCameraPillForAssessment(visual.stepName, visual.assessment, visual.now);
     }
     function queueVisualFrame(now, assessment, stepName) {
       state.pendingVisual = { now, assessment, stepName };
       if (state.visualCommitRaf) return;
       state.visualCommitRaf = requestAnimationFrame(() => commitVisualFrame(now, assessment, stepName));
     }
     function setCameraPillText(text, immediate = false) {
       const node = state.cameraPillBase || cameraPill;
       const next = String(text || state.pillText || 'Coloca tu rostro en el óvalo');
       if (!node || state.pillText === next) return;
       state.pillText = next;
       node.classList.toggle('is-positive', ['Perfecto', 'Quédate quieto', 'Capturada ✓'].includes(next));
       if (state.pillSwapTimer) clearTimeout(state.pillSwapTimer);
       if (immediate) { node.textContent = next; node.classList.remove('is-fading'); state.pillSwapTimer = 0; return; }
       node.classList.add('is-fading');
       state.pillSwapTimer = setTimeout(() => { node.textContent = next; node.classList.remove('is-fading'); state.pillSwapTimer = 0; }, 70);
     }
     function setCountdownVisual(text) {
       state.countdownVisual = { text: String(text || '') };
     }
     async function showCaptureFlash() {
       const flash = state.captureFlash;
       if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { resetCaptureFlash(); return false; }
       if (!flash || typeof flash.animate !== 'function') return false;
       try {
         if (state.flashAnimation) state.flashAnimation.cancel();
         flash.style.opacity = '0';
         if (debugMode) { startShutterTrace(); recordShutterEvent('veil_animate_start'); }
         const animation = flash.animate([{ opacity: 0, offset: 0, easing: 'ease-out' }, { opacity: .9, offset: .25, easing: 'ease-in-out' }, { opacity: .35, offset: 1 }], { duration: 240, easing: 'linear', fill: 'forwards' });
         state.flashAnimation = animation;
         if (debugMode) { Promise.resolve(animation.ready).then(() => recordShutterEvent('veil_animation_ready'), () => recordShutterEvent('veil_animation_ready_rejected')); Promise.resolve(animation.finished).then(() => recordShutterEvent('veil_animation_finished'), () => recordShutterEvent('veil_animation_finished_rejected')); }
         let timeoutId = 0;
         await Promise.race([Promise.resolve(animation.finished).catch(() => {}), new Promise((resolve) => { timeoutId = setTimeout(resolve, 320); })]);
         if (timeoutId) clearTimeout(timeoutId);
         if (state.flashAnimation === animation) {
           animation.cancel();
           state.flashAnimation = null;
           flash.style.opacity = '.35';
         }
         if (debugMode) recordShutterEvent('veil_opacity_pinned_0_35');
         await new Promise((resolve) => requestAnimationFrame((timestamp) => { if(debugMode)recordShutterEvent('veil_ready_requestAnimationFrame',{frame_timestamp_ms:Number(timestamp)||shutterNowMs()},Number(timestamp)||shutterNowMs()); resolve(); }));
       } catch (_) { /* el velo es decorativo y no bloquea la captura */ }
       try { if (navigator && typeof navigator.vibrate === 'function') navigator.vibrate(30); } catch (_) { /* vibración opcional */ }
       return true;
     }
     async function hideCaptureFlash() {
       const flash = state.captureFlash;
       if (!flash) return;
       if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof flash.animate !== 'function') { resetCaptureFlash(); return; }
       try {
         if (state.flashAnimation) { state.flashAnimation.cancel(); state.flashAnimation = null; }
         flash.style.opacity = '.35';
         if (debugMode) recordShutterEvent('veil_lower_start');
         const animation = flash.animate([{ opacity: .35 }, { opacity: 0 }], { duration: 250, easing: 'ease-out', fill: 'forwards' });
         state.flashAnimation = animation;
         if (debugMode) Promise.resolve(animation.finished).then(() => recordShutterEvent('veil_lower_finished'), () => recordShutterEvent('veil_lower_finished_rejected'));
         await Promise.resolve(animation.finished).catch(() => {});
         if (state.flashAnimation === animation) { animation.cancel(); state.flashAnimation = null; flash.style.opacity = '0'; }
       } catch (_) { resetCaptureFlash(); }
     }
     function resetCaptureFlash() {
       const flash = state.captureFlash;
       if (state.flashAnimation) { try { state.flashAnimation.cancel(); } catch (_) {} state.flashAnimation = null; }
       if (flash) flash.style.opacity = '0';
     }

     function setVisualCueVisible(visible) {
       if (!visualCue) return;
       if (visible && state.visualCueHideTimer) clearTimeout(state.visualCueHideTimer);
       state.visualCueHideTimer = 0;
       if (visible) {
         const alreadyVisible = !visualCue.hidden && visualCue.classList.contains('is-visible');
         if (!alreadyVisible) {
           if (visualCue.hidden) visualCue.hidden = false;
           visualCue.classList.remove('a2-cue-enter-left', 'a2-cue-enter-right');
           const direction = visualCue.dataset.direction;
           if (state.step > 0 && direction) visualCue.classList.add(direction === 'right' ? 'a2-cue-enter-right' : 'a2-cue-enter-left');
           visualCue.classList.add('is-visible');
         }
       } else {
         if (!visualCue.classList.contains('is-visible') && (visualCue.hidden || state.visualCueHideTimer)) return;
         visualCue.classList.remove('is-visible', 'a2-cue-enter-left', 'a2-cue-enter-right');
         state.visualCueHideTimer = setTimeout(() => { if (!visualCue.hidden) visualCue.hidden = true; state.visualCueHideTimer = 0; }, 180);
       }
     }
     function animateViewEntry(name) {
       if (state.step === 0) return;
       const direction = name === 'perfil_izq' ? 'right' : name === 'perfil_der' ? 'left' : '';
       if (!direction) return;
       const nodes = [q('[data-a2-title]'), q('[data-a2-eyebrow]'), q('[data-a2-intro]')].filter(Boolean);
       nodes.forEach((node) => {
         node.classList.remove('a2-view-enter-left', 'a2-view-enter-right');
         requestAnimationFrame(() => node.classList.add(direction === 'right' ? 'a2-view-enter-right' : 'a2-view-enter-left'));
         setTimeout(() => node.classList.remove('a2-view-enter-left', 'a2-view-enter-right'), 280);
       });
     }
     function saveDeviceCapabilities(track) {
       if (!CONFIG.logDeviceCapabilities || !state.captureMetadata) return;
       state.captureMetadata.device_capabilities = deviceCapabilitiesForLogging(readTrackCapabilities(track), readTrackSettings(track), null);
       if (state.imageCapture && typeof state.imageCapture.getPhotoCapabilities === 'function') {
         Promise.resolve().then(() => state.imageCapture.getPhotoCapabilities()).then((photo) => {
           if (!state.captureMetadata || !CONFIG.logDeviceCapabilities) return;
           state.captureMetadata.device_capabilities.photo_capabilities = sanitizeCameraCapabilities(photo);
         }).catch(() => {});
       }
     }
     function ensureScreenLightOverlay() {
       if (!lightTestMode || state.screenLightOverlay) return state.screenLightOverlay;
       const frame = q('[data-a2-frame]'); const oval = q('[data-a2-oval]');
       if (!frame || typeof document.createElement !== 'function') return null;
       const overlay = document.createElement('div');
       overlay.setAttribute('aria-hidden', 'true');
       overlay.style.cssText = 'position:absolute;inset:0;pointer-events:none;z-index:1;border-radius:inherit;opacity:0;transition:opacity 180ms linear;background:radial-gradient(ellipse at center,rgba(255,246,232,0) 0 34%,rgba(255,246,232,.95) 100%)';
       if (!frame.style.position || frame.style.position === 'static') frame.style.position = 'relative';
       frame.insertBefore(overlay, oval || frame.firstChild);
       state.screenLightOverlay = overlay;
       return overlay;
     }
     function updateScreenLight(face) {
       if (!lightTestMode) return;
       if (!face && !state.screenLightOverlay) return;
       const overlay = ensureScreenLightOverlay();
       if (!overlay) return;
       const opacity = screenLightOpacity(face);
       overlay.style.opacity = String(opacity);
       if (opacity > 0) state.screenLightShown = true;
     }
     async function lockFrontalCameraControls() {
       const track = cameraTrack();
       if (!lightTestMode || !track || typeof track.applyConstraints !== 'function') return;
       const caps = readTrackCapabilities(track); const settings = state.frontCameraSettings || readTrackSettings(track);
       const plan = cameraLockPlan(caps, settings);
       if (plan.exposure) {
         try { await track.applyConstraints({ advanced: [plan.exposure] }); state.exposureLocked = true; state.exposureLockApplied = true; }
         catch (_) { state.exposureLocked = false; }
       }
       if (plan.whiteBalance) {
         try { await track.applyConstraints({ advanced: [plan.whiteBalance] }); state.whiteBalanceLocked = true; state.whiteBalanceLockApplied = true; }
         catch (_) { state.whiteBalanceLocked = false; }
       }
       if (state.captureMetadata) state.captureMetadata.camera_controls = { poi_applied: state.poiApplied, exposure_locked: state.exposureLockApplied, white_balance_locked: state.whiteBalanceLockApplied };
     }
     async function restoreAutomaticCameraModes() {
       const track = cameraTrack();
       if (!lightTestMode || !track || typeof track.applyConstraints !== 'function') return;
      const caps = readTrackCapabilities(track);
      const advanced = automaticCameraModesPlan(caps, { exposure: state.exposureLocked, whiteBalance: state.whiteBalanceLocked });
      if (!advanced) {
        state.exposureLocked = false; state.whiteBalanceLocked = false;
        if (state.captureMetadata) state.captureMetadata.camera_controls = { poi_applied: state.poiApplied, exposure_locked: state.exposureLockApplied, white_balance_locked: state.whiteBalanceLockApplied };
        return;
      }
      try { await track.applyConstraints({ advanced: [advanced] }); } catch (_) { /* el modo automático vuelve al cerrar el track */ }
       state.exposureLocked = false; state.whiteBalanceLocked = false;
       if (state.captureMetadata) state.captureMetadata.camera_controls = { poi_applied: state.poiApplied, exposure_locked: state.exposureLockApplied, white_balance_locked: state.whiteBalanceLockApplied };
     }
    const isSimulation = root.dataset.a2Simulation === 'true';
    const isFlowTest = root.dataset.a2FlowTest === 'true';
    function stopTracks() {
      state.stopping = true;
      if(state.videoFpsCallback&&video&&typeof video.cancelVideoFrameCallback==='function'){try{video.cancelVideoFrameCallback(state.videoFpsCallback)}catch(_){}state.videoFpsCallback=0}
      cancelScheduledLoop();
      if (state.visualCommitRaf) cancelAnimationFrame(state.visualCommitRaf);
      state.visualCommitRaf=0;state.pendingVisual=null;if(state.pointRaf)cancelAnimationFrame(state.pointRaf);state.pointRaf=0;state.pointLastFrameAt=0;if(state.longTaskObserver){try{state.longTaskObserver.disconnect()}catch(_){}state.longTaskObserver=null}
      if(state.timer) clearTimeout(state.timer);
      state.animation = 0; state.timer = 0;
       if (state.stream) {
         const tracks = state.stream.getTracks();
         if (lightTestMode && (state.exposureLocked || state.whiteBalanceLocked)) {
           restoreAutomaticCameraModes().finally(() => tracks.forEach((track) => track.stop()));
         } else tracks.forEach((track) => track.stop());
       }
      state.stream = null; state.imageCapture = null; video.srcObject = null; state.active = false; state.stopping = false;
    }
    function invalidateNormalCountdown(preservePill = false) {
      state.normalCountdownToken += 1; state.countdownActive = false; state.countdownStartedAt = 0;
      if (state.timer) clearTimeout(state.timer);
      state.timer = 0;
      if (countdownNode) { countdownNode.textContent = ''; countdownNode.hidden = true; countdownNode.classList.remove('is-number-visible'); delete countdownNode.dataset.a2CaptureConfirmed; }
      if (!state.captureNoticeLabel && !preservePill) setCountdownVisual('');
    }
    async function showCapturedConfirmation() {
      state.captureGreenHold = true;
      queueVisualFrame(performance.now(), state.currentAssessment, STEP_ORDER[state.step]);
      await new Promise((resolve) => setTimeout(resolve, 250));
      state.captureGreenHold = false;
      queueVisualFrame(performance.now(), state.currentAssessment, STEP_ORDER[state.step]);
    }
    function scheduleLoop() {
      if (!state.active || state.capturing || state.animation) return;
      if (!isSimulation && video && typeof video.requestVideoFrameCallback === 'function') {
        state.animationKind = 'video';
        state.animation = video.requestVideoFrameCallback(() => { state.animation = 0; state.animationKind = ''; loop(); });
      } else {
        state.animationKind = 'raf';
        state.animation = requestAnimationFrame(() => { state.animation = 0; state.animationKind = ''; loop(); });
      }
    }
    function cancelScheduledLoop() {
      if (!state.animation) return;
      if (state.animationKind === 'video') { if (video && typeof video.cancelVideoFrameCallback === 'function') video.cancelVideoFrameCallback(state.animation); }
      else cancelAnimationFrame(state.animation);
      state.animation = 0; state.animationKind = '';
    }
    function clearDebugArtifacts() {
      state.debugThumbnails.forEach((item) => URL.revokeObjectURL(item.url));
      state.debugThumbnails = []; state.debugMetrics = []; state.lastCapturedStep = -1; if(debugMode){state.shutterTimeline=[];state.activeShutterEntry=null;state.activeShutterAttempt=null;state.shutterTraceActive=false;if(state.shutterRafProbeId)cancelAnimationFrame(state.shutterRafProbeId);state.shutterRafProbeId=0;}
      if (debugThumbnails) debugThumbnails.replaceChildren();
      if (debugOutput) { debugOutput.value = ''; debugOutput.hidden = true; }
      if (debugCopyStatus) debugCopyStatus.textContent = '';
      if (countdownNode) { countdownNode.textContent = ''; countdownNode.hidden = true; countdownNode.classList.remove('is-number-visible'); }
    }
    function liveMetric() {
      const step = STEP_ORDER[state.step] || STEP_ORDER[state.lastCapturedStep] || 'frontal';
      const width = isSimulation ? simulated.width : video.videoWidth;
      const height = isSimulation ? simulated.height : video.videoHeight;
      return calibrationMetric(step, state.currentAssessment, width, height, performance.now() - state.startedAt);
    }
    function renderDebugThumbnails() {
      if (!debugMode || !debugThumbnails) return;
      debugThumbnails.replaceChildren();
      state.debugThumbnails.forEach((item) => {
        const figure = document.createElement('figure'); const image = document.createElement('img'); const caption = document.createElement('figcaption');
        image.src = item.url; image.alt = `Miniatura de ${item.step}`; image.width = 120;
        caption.textContent = `${item.step} · muestra ${item.index}`;
        figure.append(image, caption); debugThumbnails.append(figure);
      });
    }
    function debugSnapshotText(){return `${calibrationExport(state.debugMetrics,liveMetric())}\nDEBUG_PERFORMANCE ${JSON.stringify(performanceSnapshot())}`} 
    async function copyDebugMetrics() {
      const text = debugSnapshotText();
      try {
        if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') throw new Error('clipboard_unavailable');
        await navigator.clipboard.writeText(text);
        if (debugCopyStatus) debugCopyStatus.textContent = 'Métricas copiadas.';
        if (debugOutput) debugOutput.hidden = true;
      } catch (_) {
        if (debugOutput) { debugOutput.value = text; debugOutput.hidden = false; debugOutput.focus(); debugOutput.select(); }
        if (debugCopyStatus) debugCopyStatus.textContent = 'No se pudo copiar automáticamente. Selecciona y copia el texto.';
      }
    }
    function clearMessage() { message.hidden = true; retry.hidden = true; retryDetector.hidden = true; }
    function showError(kind, detail) {
      setVisualCueVisible(false);
      stopTracks();
      const copy = detail || classifyCameraError(kind, window.isSecureContext);
      messageTitle.textContent = copy.title; messageText.textContent = copy.text; message.hidden = false;
      retry.hidden = copy.code === 'detector_unavailable'; retryDetector.hidden = copy.code !== 'detector_unavailable';
      if (debugMode && manual) manual.disabled = true;
      q('[data-a2-guidance]').hidden = false;
      guideIcon.textContent = 'ℹ'; guideText.textContent = `${copy.title}. ${copy.text}`;
      setCameraPillText(copy.code === 'permission_denied' ? 'Permite la cámara' : copy.code === 'detector_unavailable' ? 'Revisa la guía' : 'Revisa la cámara');
    }
    function guide(icon, text) {
      const key = `${icon}\u0000${text}`;
      if (key === state.currentGuide || key === state.pendingGuide) return;
      if (state.guideTimer) clearTimeout(state.guideTimer);
      if (state.guidanceSwapTimer) { clearTimeout(state.guidanceSwapTimer); state.guidanceSwapTimer = 0; }
      state.pendingGuide = key;
      state.guideTimer = setTimeout(() => {
        if (state.pendingGuide !== key) return;
        const guidance = q('[data-a2-guidance]');
        const applyText = () => {
          guideIcon.textContent = icon; guideText.textContent = text;
          root.dataset.a2UiState = icon === '●' ? 'ready' : 'guiding';
          if (guidance) guidance.classList.remove('is-fading');
        };
        if (guidance && !guidance.hidden) {
          guidance.classList.add('is-fading');
          if (state.guidanceSwapTimer) clearTimeout(state.guidanceSwapTimer);
          state.guidanceSwapTimer = setTimeout(() => { applyText(); state.guidanceSwapTimer = 0; }, 90);
        } else applyText();
      if (text === 'La luz llega más de un lado. Ponte de frente a la luz.') state.lightingGuideShown = true;
        if (text === 'La luz es muy amarilla. Si puedes, acércate a una ventana o a una luz blanca.') state.warmCueShown = true;
        if (text === 'Hay luz de distinto color a cada lado. Ponte de frente a una sola luz.') state.mixedCueShown = true;
        state.currentGuide = key; state.pendingGuide = ''; state.guideTimer = 0;
      }, CONFIG.debounceGuidanceMs);
    }
    function updateCaptureVisualCue(stepName, assessment) {
      if (stepName === 'frontal') {
        if (visualCue) setVisualCueVisible(false);
        if (state.turnGuide) state.turnGuide.classList.remove('is-visible', 'is-target', 'is-overshot');
        return;
      }
      const direction = stepName === 'perfil_izq' ? 'right' : 'left';
      const yawProgress = assessment && assessment.face && state.visualFace ? state.visualFace.yawProgress : null;
      const overshot = Number.isFinite(yawProgress) && yawProgress > CONFIG.profileYawMaxDeg;
      const arrowDirection = overshot ? (direction === 'right' ? 'left' : 'right') : direction;
      if (visualCue && visualCue.dataset.direction !== arrowDirection) visualCue.dataset.direction = arrowDirection;
      if (visualCue && visualCue.dataset.turnSide !== direction) visualCue.dataset.turnSide = direction;
      if (state.chevrons) state.chevrons.querySelectorAll('span').forEach((node) => { const glyph = arrowDirection === 'right' ? '›' : '‹'; if (node.textContent !== glyph) node.textContent = glyph; });
      if (state.turnGuide && state.turnGuideMarker && state.turnGuideTarget) {
        const value = Number.isFinite(yawProgress) ? yawProgress : 0;
        const target = value >= CONFIG.profileYawMinDeg && value <= CONFIG.profileYawMaxDeg;
        state.turnGuide.dataset.direction = direction;
        state.turnGuide.classList.toggle('is-target', target);
        state.turnGuide.classList.toggle('is-overshot', overshot);
        state.turnGuide.classList.add('is-visible');
        state.pointTargetYaw=value;
        if (state.pointLastDetectionAt !== state.lastDetectionAt) {
          state.pointLastDetectionAt = state.lastDetectionAt;
          const width = state.turnGuideWidth || (state.turnGuideWidth = state.turnGuide.getBoundingClientRect().width || 140);
          const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const deltaYaw = value - state.pointFilteredYaw;
          if (reduced) state.pointFilteredYaw = value;
          else if (Math.abs(deltaYaw) >= .35) state.pointFilteredYaw += (1 - Math.exp(-Math.max(66, state.nextDetectionDelayMs) / 180)) * deltaYaw;
          const targetPx = Math.max(0, Math.min(40, state.pointFilteredYaw)) / 40 * width - width / 2;
          const now = performance.now();
          const previous = state.markerAnimationPlan;
          const plan = markerAnimationPlan(previous, now, targetPx, Math.max(80, Math.min(220, state.nextDetectionDelayMs * 1.15)));
          const thresholdPx = width * .0015;
          if (!previous || Math.abs(plan.to - plan.from) >= thresholdPx || reduced) {
            if (state.markerAnimation) { state.markerAnimation.cancel(); state.markerAnimation = null; }
            const transform = (x) => `translate3d(${x.toFixed(2)}px,0,0) translate(-50%,-50%)`;
            state.turnGuideMarker.style.transform = transform(plan.from);
            state.markerAnimationPlan = plan;
            if (reduced || !state.turnGuideMarker.animate) state.turnGuideMarker.style.transform = transform(plan.to);
            else state.markerAnimation = state.turnGuideMarker.animate([{ transform: transform(plan.from) }, { transform: transform(plan.to) }], { duration: plan.duration, easing: 'linear', fill: 'forwards' });
            state.lastPointTransform = transform(plan.to);
          }
        }
      }
      const yawInTarget = Number.isFinite(yawProgress) && yawProgress >= CONFIG.profileYawMinDeg && yawProgress <= CONFIG.profileYawMaxDeg;
      if (visualCue) setVisualCueVisible(!yawInTarget);
    }
    function updateCameraPillForAssessment(stepName, assessment, now = performance.now()) {
      if (!cameraPill) return;
      if (!assessment) return; // conserva la instrucción hasta la primera detección real
      if (state.retryPhotoMessage) { setCameraPillText('Repitamos esta foto'); return; }
      if (state.captureNoticeLabel) { setCameraPillText('Capturada ✓'); return; }
      if (state.countdownActive) {
        setCameraPillText('Quédate quieto'); return;
      }
      if (message && !message.hidden) return;
      const code = assessment && assessment.experimentalLighting && assessment.experimentalLighting.cueCode || assessment && assessment.code;
      const yaw = state.visualFace && state.visualFace.yawProgress;
      const quiet = Boolean(assessment && assessment.ok && state.stableSince && now - state.stableSince >= CONFIG.stabilityHoldMs);
      setCameraPillText(capturePillMessage(stepName, code, yaw, quiet));
    }
    function updateStep() {
      state.pointTargetYaw=0;state.pointCurrentYaw=0;state.pointFilteredYaw=0;state.pointLastDetectionAt=-1;state.markerAnimationPlan=null;if(state.markerAnimation){state.markerAnimation.cancel();state.markerAnimation=null}if(state.turnGuideMarker)state.turnGuideMarker.style.transform='translate3d(0px,0,0) translate(-50%,-50%)';state.lastPointTransform='';
      const name = STEP_ORDER[state.step]; const meta = STEP_META[name];
      state.captureNoticeLabel = false;
      if (name) setCameraPillText(captureInstructionForStep(name), true);
      root.dataset.a2UiState = 'guiding';
      if (state.topbarStep) state.topbarStep.textContent = name === 'frontal' ? 'Frente' : name === 'perfil_izq' ? 'Giro a tu derecha' : 'Giro a tu izquierda';
      if (state.topbarCount) state.topbarCount.textContent = `${state.step + 1} de 3`;
      const stepWrap = q('.rogma-a2__capture-step-wrap');
      if (stepWrap) { stepWrap.classList.add('is-transitioning'); setTimeout(() => stepWrap.classList.remove('is-transitioning'), 220); }
      root.classList.add('is-camera-active');
      setVisualCueVisible(false);
      state.visualFace = null; state.visualStyle = null; state.currentAssessment = null; state.stableSince = 0; setCountdownVisual('');
      queueVisualFrame(performance.now(), null, name);
      q('[data-a2-title]').textContent = meta.title;
      q('[data-a2-eyebrow]').textContent = meta.eyebrow;
      const intro = q('[data-a2-intro]');
      if (intro) intro.textContent = meta.intro;
      root.querySelectorAll('[data-a2-step-label]').forEach((node) => {
        if (node.dataset.a2StepLabel === name) node.setAttribute('aria-current', 'step'); else node.removeAttribute('aria-current');
      });
    }
    function updateCounts() {
      root.querySelectorAll('[data-a2-capture-status]').forEach((node) => {
        const name = node.dataset.a2CaptureStatus; node.textContent = `${name === 'frontal' ? 'Frontal' : name === 'perfil_izq' ? 'Izquierda' : 'Derecha'}: ${state.captures[name] ? 'lista' : 'pendiente'}`;
        node.dataset.a2Done = state.captures[name] ? 'true' : 'false';
        const step = root.querySelector(`[data-a2-step-label=\"${name}\"]`); if (step) step.dataset.a2Captured = state.captures[name] ? 'true' : 'false';
      });
    }
    function assessCurrentFrame(face, step, now = performance.now()) {
      const base = assessFrame(face, step, captureConfig);
      if (lightTestMode) {
        if (step === 'frontal' && face) updateScreenLight(face);
        else if (state.screenLightOverlay) updateScreenLight(null);
      }
      if (step === 'frontal' && face && lightTestMode) {
        if (!state.poiAttempted && face.facePointOfInterest) {
          state.poiAttempted = true;
          state.poiPromise = applyFacePointsOfInterest(cameraTrack(), face.facePointOfInterest, state.cameraCapabilities).then((applied) => {
            state.poiApplied = applied;
            if (state.captureMetadata) state.captureMetadata.camera_controls = { poi_applied: applied, exposure_locked: state.exposureLockApplied, white_balance_locked: state.whiteBalanceLockApplied };
          });
        }
      }
      if (step !== 'frontal' || !base.face) {
        state.lightingUnevenSince = 0;
        state.lightingTestSince = 0;
        return base;
      }
      const probe = evaluateCheekLighting(base.face.cheekLeftLuminance, base.face.cheekRightLuminance, 0);
      if (!probe.measurable || probe.deltaRatio <= CONFIG.cheekLightDeltaMax) state.lightingUnevenSince = 0;
      else if (!state.lightingUnevenSince) state.lightingUnevenSince = now;
      const unevenElapsed = state.lightingUnevenSince ? now - state.lightingUnevenSince : 0;
      const current = applyFrontalLightingAssessment(base, step, unevenElapsed);
      if (!lightTestMode) return current;
      const initial = experimentalLightingForSearch(window.location && window.location.search, base.face, 0);
      if (!initial.measurable || (!initial.warm && !initial.mixed)) state.lightingTestSince = 0;
      else if (!state.lightingTestSince) state.lightingTestSince = now;
      const elapsed = state.lightingTestSince ? now - state.lightingTestSince : 0;
      const experiment = experimentalLightingForSearch(window.location && window.location.search, base.face, elapsed);
      if (!experiment.cue || !['ready', 'uneven_cheek_light', 'more_light'].includes(current.code)) return { ...current, experimentalLighting: experiment };
      return { ...current, ok: false, code: experiment.cueCode, experimentalLighting: experiment };
    }
    function beginCaptureMetadata(focusModes = []) {
      state.lightingGuideShown = false;
      if (!state.captureMetadata) {
        state.captureMetadata = { browser_device_family: browserDeviceFamilyFromUserAgent(navigator.userAgent), captures: Object.create(null) };
      }
      state.captureMetadata.distance_mode = distanceMode;
      state.captureMetadata.focus_modes = [...focusModesFromCapabilities({ focusMode: focusModes })];
      state.captureMetadata.luz_prueba = lightTestMode;
      if(state.delegate)state.captureMetadata.delegate=state.delegate;
      state.captureMetadata.camera_controls = { poi_applied: state.poiApplied, exposure_locked: state.exposureLockApplied, white_balance_locked: state.whiteBalanceLockApplied };
    }
    function recordCaptureMetadata(name, image, assessmentOverride = null) {
      if (!state.captureMetadata) beginCaptureMetadata();
      const method = image.metrics && image.metrics.method || 'unknown';
      const track = state.stream && state.stream.getVideoTracks ? state.stream.getVideoTracks()[0] : null;
      const item = {
        requested_mode: 'foto',
        mode: method === 'video_frame_fallback' ? 'video' : 'foto',
        method,
        fallback: method === 'video_frame_fallback',
        track_settings: reducedTrackSettings(track),
        jpeg: { width: image.width, height: image.height, bytes: image.blob && image.blob.size },
        mirror_corrected: image.metrics && image.metrics.mirrorCorrected !== undefined ? image.metrics.mirrorCorrected : false,
        take_photo_options_used: image.metrics && image.metrics.takePhotoOptionsUsed === true,
        take_photo_options: image.metrics && image.metrics.takePhotoOptionsUsed === true ? { ...(image.metrics.takePhotoOptions || {}) } : null,
      };
      if (image.metrics && image.metrics.fallbackReason) item.fallback_reason = image.metrics.fallbackReason;
      if (name === 'frontal') {
        const assessment = assessmentOverride || state.currentAssessment;
        const face = assessment && assessment.face;
        const lighting = assessment && assessment.lighting;
        const hasColor = face && [face.cheekLeftAStar, face.cheekLeftBStar, face.cheekRightAStar, face.cheekRightBStar].some((value) => Number.isFinite(value));
        if (lighting || hasColor) item.lighting = {
          ...(lighting && lighting.measurable ? {
            cheek_left_luminance: lighting.leftLuminance,
            cheek_right_luminance: lighting.rightLuminance,
            cheek_delta_ratio: lighting.deltaRatio,
            cue_shown: state.lightingGuideShown,
            accepted_asymmetric_after_wait: lighting.acceptedAsymmetric,
          } : {}),
          ...(hasColor ? { cheek_left_a_star: face.cheekLeftAStar, cheek_left_b_star: face.cheekLeftBStar, cheek_right_a_star: face.cheekRightAStar, cheek_right_b_star: face.cheekRightBStar } : {}),
          warm_light_cue_shown: state.warmCueShown,
          mixed_light_cue_shown: state.mixedCueShown,
          screen_light_shown: state.screenLightShown,
        };
      }
      state.captureMetadata.captures[name] = item;
    }
    function detectorError() {
      showError(null, { code: 'detector_unavailable', title: 'La guía de captura no está disponible', text: 'No pudimos iniciar los archivos locales del detector. Revisa los assets del tema y vuelve a intentar.' });
    }
    function detectorLoadPromise() {
      if (state.landmarker) return Promise.resolve(state.landmarker);
      if (state.detectorPromise) return state.detectorPromise;
      if (root.dataset.a2FlowTest === 'true' && window.RogmaA2FlowTestDetector) {
        state.landmarker = window.RogmaA2FlowTestDetector;
        return Promise.resolve(state.landmarker);
      }
      if (!window.RogmaMediaPipeLoader) return Promise.reject(new Error('loader_unavailable'));
      state.detectorPromise = Promise.race([
        window.RogmaMediaPipeLoader.createFaceLandmarker(root, { outputFacialTransformationMatrixes: true, minFaceDetectionConfidence: CONFIG.minFaceDetectionConfidence, minFacePresenceConfidence: CONFIG.minFacePresenceConfidence, minTrackingConfidence: CONFIG.minTrackingConfidence }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('detector_timeout')), CONFIG.detectorTimeoutMs)),
      ]).then((result)=>{state.landmarker=result.landmarker;state.delegate=result.delegate||null;if(state.captureMetadata&&state.delegate)state.captureMetadata.delegate=state.delegate;return state.landmarker}).catch((error)=>{state.detectorPromise=null;throw error});
      return state.detectorPromise;
    }
    function startVideoFpsMonitor(){if(!video||typeof video.requestVideoFrameCallback!=='function'||state.videoFpsCallback)return;const tick=(ts,metadata)=>{state.videoFpsCallback=0;if(!state.active)return;state.videoFrameTimes.push(Number(ts)||performance.now());if(debugMode&&state.shutterTraceActive)recordShutterEvent('requestVideoFrameCallback',{video_timestamp_ms:Number(ts)||null,media_time_ms:metadata&&Number.isFinite(metadata.mediaTime)?Number((metadata.mediaTime*1000).toFixed(2)):null,presented_frames:metadata&&Number.isFinite(metadata.presentedFrames)?metadata.presentedFrames:null},Number(ts)||shutterNowMs());if(state.videoFrameTimes.length>60)state.videoFrameTimes.shift();state.videoFpsCallback=video.requestVideoFrameCallback(tick)};state.videoFpsCallback=video.requestVideoFrameCallback(tick)}
    async function preloadDetector(){if(isSimulation)return;try{const lm=await detectorLoadPromise();if(state.warmedLandmarker===lm)return;const canvas=document.createElement('canvas');canvas.width=16;canvas.height=16;try{lm.detectForVideo(canvas,0);state.warmedLandmarker=lm}catch(_){}}catch(_){/* precarga silenciosa */}}
    async function startDetector() {
      if (isSimulation) return;
      await detectorLoadPromise();
    }
    function fitCurrentOval() {
      if (!state.active && !isSimulation) return;
      const media = isSimulation ? simulated : video;
      if ((media && (isSimulation || media.videoWidth !== 0)) && (isSimulation || media.videoHeight !== 0)) {
        fitOval(media, q('[data-a2-frame]'), q('[data-a2-oval]'), captureConfig);
        if (visualCue && ovalNode) visualCue.style.setProperty('--a2-cue-oval-half-width', `${ovalNode.getBoundingClientRect().width / 2}px`);
      }
    }
    window.addEventListener('resize', fitCurrentOval, { passive: true });
    window.addEventListener('orientationchange', fitCurrentOval, { passive: true });
    video.addEventListener('resize', fitCurrentOval);
    const cameraContainer = q('[data-a2-frame]') && q('[data-a2-frame]').parentElement;
    if (cameraContainer && typeof ResizeObserver === 'function') {
      let cameraResizeRaf = 0;
      const cameraResizeObserver = new ResizeObserver(() => {
        if (cameraResizeRaf) return;
        cameraResizeRaf = requestAnimationFrame(() => { cameraResizeRaf = 0; fitCurrentOval(); });
      });
      cameraResizeObserver.observe(cameraContainer);
    }
    async function startCamera() {
      restoreCameraCard();
      resetCaptureFlash();
      if (state.active && state.stream) { scheduleLoop(); return; }
      clearMessage(); q('[data-a2-guidance]').hidden = false; updateStep(); updateCounts(); state.previousFace = null; state.stabilityReference = null; state.faceDetectedAt = 0; state.pauseUntil = 0; state.stableSince = 0; state.cachedBrightness = null; state.cachedCheekLight = null; state.lastBrightnessAt = 0; state.lastCheekLightAt = 0; state.startedAt=performance.now();state.lastAutoCapture=0;state.lastDetectionAt=0;state.nextDetectionDelayMs=66;state.detectDurations=[];state.detectTimes=[];state.frameDeltas=[];state.longTaskCount=0;state.longTaskTimes=[];state.visualFace=null;
      const noA3Message = q('[data-a2-no-a3]'); if (noA3Message) noA3Message.hidden = true;
      if (!isSimulation && !window.isSecureContext) { showError(null, classifyCameraError(null, false)); return; }
      if (!isSimulation && (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) { showError(null, { code: 'no_camera_api', title: 'La cámara no está disponible en este navegador', text: 'Abre la experiencia en un navegador compatible y vuelve a intentarlo.' }); return; }
      try {
        if (!isSimulation && !state.landmarker) await startDetector();
      } catch (_) { detectorError(); return; }
      try {
        if (isSimulation) {
          simulated.hidden=false;video.hidden=true;state.startedAt=performance.now();state.active=true;startPointInterpolator();startSimulation();return;
        }
        video.hidden = false; simulated.hidden = true;
        const mediaRequest = navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'user', width: { ideal: 1920 }, height: { ideal: 1440 } } });
        let permissionTimer = 0;
        const stream = await Promise.race([
          mediaRequest,
          new Promise((_, reject) => { permissionTimer = setTimeout(() => reject(new Error('camera_permission_timeout')), CONFIG.cameraPermissionTimeoutMs); }),
        ]).finally(() => clearTimeout(permissionTimer)).catch((error) => {
          if (error && error.message === 'camera_permission_timeout') mediaRequest.then((lateStream) => lateStream.getTracks().forEach((track) => track.stop())).catch(() => {});
          throw error;
        });
        state.stream = stream; state.stopping = false; video.srcObject = stream;
        await Promise.race([video.play(), new Promise((_, reject) => setTimeout(() => reject(new Error('camera_timeout')), CONFIG.cameraStartTimeoutMs))]);
        state.startedAt = performance.now();
        state.active=true;startPointInterpolator();
        state.cachedBrightness = null; state.cachedCheekLight = null; state.lastBrightnessAt = 0; state.lastCheekLightAt = 0;
        fitCurrentOval();
        const track = stream.getVideoTracks()[0];
        let focusModes = []; let capabilities = null;
        try {
          capabilities = track && typeof track.getCapabilities === 'function' ? track.getCapabilities() : null;
          focusModes = focusModesFromCapabilities(capabilities);
        } catch (_) { focusModes = []; }
        beginCaptureMetadata(focusModes);
        if (typeof window.ImageCapture === 'function') { try { state.imageCapture = new window.ImageCapture(track); if (state.imageCapture && typeof state.imageCapture.getPhotoCapabilities === 'function') { state.photoCapabilitiesPromise = Promise.resolve(state.imageCapture.getPhotoCapabilities()).then((caps) => { state.photoCaptureOptions = photoCaptureOptionsFromCapabilities(caps); return state.photoCaptureOptions; }).catch(() => { state.photoCaptureOptions = null; return null; }); } else { state.photoCaptureOptions = null; state.photoCapabilitiesPromise = Promise.resolve(null); } } catch (_) { state.imageCapture = null; state.photoCaptureOptions = null; state.photoCapabilitiesPromise = Promise.resolve(null); } }
        state.cameraCapabilities = capabilities || readTrackCapabilities(track);
        saveDeviceCapabilities(track);
        track.addEventListener('ended', () => { if (!state.stopping && state.active) showError({ name: 'AbortError' }); }, { once: true });
        if(typeof video.requestVideoFrameCallback==='function')startVideoFpsMonitor();
        scheduleLoop();
      } catch (error) { showError(error); }
    }
    function detectedFace(now = performance.now()) {
      if (isSimulation) return faceFromLandmarks(simulatedLandmarks(state.simulatedFace), state.simulatedFace ? state.simulatedFace.brightness : .5, simulatedMatrix(state.simulatedFace && state.simulatedFace.yawDeg), simulated.width, simulated.height);
      if (!video.videoWidth || !video.videoHeight || !state.landmarker) return null;
      const dimensions = detectionDimensions(video.videoWidth, video.videoHeight, 640);
      if (!state.detectorCanvas) { state.detectorCanvas = document.createElement('canvas'); state.detectorContext = state.detectorCanvas.getContext('2d'); }
      if (!state.detectorContext || !dimensions.width || !dimensions.height) return null;
      if (state.detectorCanvas.width !== dimensions.width || state.detectorCanvas.height !== dimensions.height) { state.detectorCanvas.width = dimensions.width; state.detectorCanvas.height = dimensions.height; state.detectorSize = dimensions; }
      const drawStartedAt=performance.now();state.detectorContext.drawImage(video,0,0,dimensions.width,dimensions.height);state.drawImageLastMs=Math.max(0,performance.now()-drawStartedAt);if(debugMode){state.drawImageDurations.push(state.drawImageLastMs);if(state.drawImageDurations.length>60)state.drawImageDurations.shift()}
      const shouldSample=!state.countdownActive&&(state.cachedBrightness===null||now-state.lastBrightnessAt>=500||!state.cachedCheekLight||now-state.lastCheekLightAt>=500);
      let sampledPixels=null;const sampleWidth=96,sampleHeight=96;
      if(shouldSample){try{if(!state.sampleCanvas){state.sampleCanvas=document.createElement('canvas');state.sampleContext=state.sampleCanvas.getContext('2d',{willReadFrequently:true})}if(state.sampleContext){state.sampleCanvas.width=sampleWidth;state.sampleCanvas.height=sampleHeight;const sampleDrawStartedAt=performance.now();state.sampleContext.drawImage(state.detectorCanvas,0,0,sampleWidth,sampleHeight);state.sampleDrawImageLastMs=Math.max(0,performance.now()-sampleDrawStartedAt);if(debugMode){state.sampleDrawImageDurations.push(state.sampleDrawImageLastMs);if(state.sampleDrawImageDurations.length>60)state.sampleDrawImageDurations.shift()}sampledPixels=state.sampleContext.getImageData(0,0,sampleWidth,sampleHeight).data}}catch(_){sampledPixels=null}}
      if (isFlowTest && Number.isFinite(window.RogmaA2FlowTestDetector.brightness)) state.cachedBrightness = window.RogmaA2FlowTestDetector.brightness;
      else if(!state.countdownActive&&(state.cachedBrightness===null||now-state.lastBrightnessAt>=500)){state.cachedBrightness=sampledPixels?brightnessFromPixels(sampledPixels,sampleWidth,sampleHeight,24,24):.5;state.lastBrightnessAt=now;}
      const detectStartedAt=performance.now();let result;if(debugMode){state.detectInProgress=true;recordShutterEvent('detectForVideo_start')}try{result=state.landmarker.detectForVideo(state.detectorCanvas,now)}finally{if(debugMode){state.lastDetectEndedAt=performance.now();state.detectInProgress=false;recordShutterEvent('detectForVideo_end',{duration_ms:Number((state.lastDetectEndedAt-detectStartedAt).toFixed(2))},state.lastDetectEndedAt)}}const detectElapsedMs=Math.max(0,performance.now()-detectStartedAt);state.lastDetectDurationMs=detectElapsedMs;if(debugMode){state.detectTimes.push(now);if(state.detectTimes.length>60)state.detectTimes.shift()}state.nextDetectionDelayMs=Math.min(140,Math.max(66,detectElapsedMs*2.2));if(debugMode){state.detectDurations.push(detectElapsedMs);if(state.detectDurations.length>60)state.detectDurations.shift()}
      const landmarks = result && result.faceLandmarks && result.faceLandmarks[0];
      const matrix = result && result.facialTransformationMatrixes && result.facialTransformationMatrixes[0];
      const face = faceFromLandmarks(landmarks,state.cachedBrightness===null?.5:state.cachedBrightness,matrix,video.videoWidth,video.videoHeight);
      if (!face || !Array.isArray(landmarks)) return face;
      if(!state.countdownActive&&(!state.cachedCheekLight||now-state.lastCheekLightAt>=500)){
        const boxes=cheekBoxesFromLandmarks(landmarks);
        state.cachedCheekLight=sampledPixels&&boxes?{...cheekLuminanceFromPixels(sampledPixels,sampleWidth,sampleHeight,boxes),...cheekColorFromPixels(sampledPixels,sampleWidth,sampleHeight,boxes)}:{cheekLeftLuminance:null,cheekRightLuminance:null};
        state.lastCheekLightAt=now;
      }
      return { ...face, ...(state.cachedCheekLight || {}), facePointOfInterest: facePointOfInterest(landmarks) };
    }
    function updateDiagnostics(assessment, step, stableFor = 0) {
      if (!debugPanel) return;
      debugPanel.hidden = !debugMode;
      if (!debugMode) return;
      const face = assessment && assessment.face;
      const cheek = targetCheekShare(face, step);
      const opposite = step === 'perfil_izq' ? face && face.cheekRightShare : step === 'perfil_der' ? face && face.cheekLeftShare : null;
      const cheekText = cheek === null ? 'no disponible' : `${(cheek * 100).toFixed(1)}% lado pedido / ${opposite === null || opposite === undefined ? 'no disponible' : `${(opposite * 100).toFixed(1)}% lado opuesto`} (solo diagnóstico)`;
      const number = (value, digits = 1) => value === null || value === undefined ? '—' : Number(value).toFixed(digits);
      state.diagnosticBaseText = [
        `Yaw heurístico: ${face ? `${number(face.yawHeuristicDeg)}°` : '—'}`,
        `Yaw matriz (criterio activo): ${face ? `${number(face.yawMatrixDeg)}°` : '—'}`,
        `Rostro / alto visible: ${face ? `${(face.height * 100).toFixed(1)}%` : '—'}`,
        `Distancia entre ojos: ${face && face.eyeDistancePx !== null ? `${number(face.eyeDistancePx)} px; ${number(face.eyeDistanceHeightRatio * 100)}% alto; ${number(face.eyeDistanceWidthRatio * 100)}% ancho` : '—'}`,
        `Centro: ${face ? `${number(face.centerX * 100)}% × ${number(face.centerY * 100)}%` : '—'} · brillo: ${face ? number(face.brightness, 3) : '—'}`,
        `Mejillas (${step}): ${cheekText}`,
        `Análisis medio: ${state.analysisCount ? (state.analysisTotalMs / state.analysisCount).toFixed(1) : '0.0'} ms`,
        `Evaluación: ${assessment ? assessment.code : 'no_face'}`,
        `Captura: ${diagnosticReason(assessment, step, stableFor)}`,
      ].join(' · ');
      updatePerfPanel();
    }
    async function captureFinalImage(step) {
      let nativeBlob = null; let nativeError = null; let fallbackReason = '';
      let keepShutter = false; let shutterLowered = false; let takePhotoOptionsUsed = false; let usedOptions = null;
      const isLastStep = step === STEP_ORDER[STEP_ORDER.length - 1];
      const imageCaptureAvailable = state.imageCapture && typeof state.imageCapture.takePhoto === 'function';
      if (!imageCaptureAvailable) fallbackReason = 'takePhoto_unavailable';
      if (imageCaptureAvailable) {
        if (state.photoCapabilitiesPromise) await state.photoCapabilitiesPromise.catch(() => null);
        usedOptions = state.photoOptionsUnsupported ? null : state.photoCaptureOptions;
      }
      await showCaptureFlash();
      try {
        if (imageCaptureAvailable) {
          if (usedOptions) {
            try { nativeBlob = debugMode ? await debugTimedTakePhoto({ ...usedOptions }, 'with_options') : await state.imageCapture.takePhoto({ ...usedOptions }); takePhotoOptionsUsed = true; }
            catch (error) {
              if (error && error.name === 'NotSupportedError') state.photoOptionsUnsupported = true;
              nativeError = String(error && error.name || 'Error').slice(0, 80);
              try { nativeBlob = debugMode ? await debugTimedTakePhoto(null, 'retry_without_options') : await state.imageCapture.takePhoto(); usedOptions = null; fallbackReason = 'takePhoto_options_failed_retry_without_options'; }
              catch (retryError) { nativeError = String(retryError && retryError.name || nativeError || 'Error').slice(0, 80); fallbackReason = 'takePhoto_failed'; }
            }
          } else {
            try { nativeBlob = debugMode ? await debugTimedTakePhoto(null, 'without_options') : await state.imageCapture.takePhoto(); }
            catch (error) { nativeError = String(error && error.name || 'Error').slice(0, 80); fallbackReason = 'takePhoto_failed'; }
          }
          if (debugMode) finishShutterTrace('takePhoto_sequence_end');
          if (nativeBlob) fitCurrentOval();
          if (nativeBlob && !isLastStep) { await hideCaptureFlash(); shutterLowered = true; }
        }
        if (nativeBlob) {
          const snapshot = document.createElement('canvas');
          const width = Number(video.videoWidth) || 1; const height = Number(video.videoHeight) || 1;
          const snapshotSize = detectionDimensions(width, height, 640);
          snapshot.width = snapshotSize.width; snapshot.height = snapshotSize.height;
          const snapshotContext = snapshot.getContext('2d');
          if (snapshotContext) snapshotContext.drawImage(video, 0, 0, snapshot.width, snapshot.height);
          const brightness = state.currentAssessment && state.currentAssessment.face ? state.currentAssessment.face.brightness : 0.5;
          const validationPromise = new Promise((resolve) => {
            const run = async () => {
              try {
                const mirrorCheck = await comparePhotoToVideo(nativeBlob, snapshotContext ? snapshot : video);
                const shouldMirror = mirrorCheck.mirrorCorrected === true;
                const nativeImage = await validateAndEncodePhoto(nativeBlob, state.landmarker, step, brightness, CONFIG, undefined, undefined, true, shouldMirror);
                if (!nativeImage.ok) { resolve({ ok: false, code: nativeImage.code }); return; }
                resolve({ ok: true, image: {
                  blob: nativeImage.blob, width: nativeImage.width, height: nativeImage.height, mimeType: nativeImage.mimeType,
                  metrics: Object.freeze({ method: 'imagecapture_takePhoto', sourceWidth: nativeImage.sourceWidth, sourceHeight: nativeImage.sourceHeight, width: nativeImage.width, height: nativeImage.height, bytes: nativeImage.blob.size, mirrorCorrected: mirrorCheck.mirrorCorrected, nativeError, fallbackReason: fallbackReason || null, takePhotoOptionsUsed, takePhotoOptions: takePhotoOptionsUsed ? usedOptions : null }),
                } });
              } catch (_) { resolve({ ok: false, code: 'photo_validation_failed' }); }
              finally { snapshot.width = 1; snapshot.height = 1; }
            };
            if (isLastStep) run();
            else if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(() => { run(); }, { timeout: 500 });
            else setTimeout(run, 0);
          });
          keepShutter = isLastStep;
          return { pendingValidation: true, rawBlob: nativeBlob, validationPromise };
        }
        if (debugMode && !imageCaptureAvailable) recordShutterEvent('takePhoto_unavailable_video_fallback');
        const videoImage = await pixelOrientedJpeg(video);
        if (debugMode && !imageCaptureAvailable) finishShutterTrace('video_frame_read_end');
        if (!isLastStep) { await hideCaptureFlash(); shutterLowered = true; }
        const encodedVideo = await validateAndEncodePhoto(videoImage.blob, state.landmarker, step, state.currentAssessment && state.currentAssessment.face ? state.currentAssessment.face.brightness : 0.5, CONFIG, undefined, undefined, false);
        if (!encodedVideo.ok) {
          if (['look_front', 'turn_left', 'turn_right', 'no_face', 'matrix_yaw_unavailable'].includes(encodedVideo.code)) return { retryablePose: true, code: encodedVideo.code };
          throw new Error(`video_fallback_invalid:${encodedVideo.code}`);
        }
        keepShutter = isLastStep;
        return {
          blob: encodedVideo.blob, width: encodedVideo.width, height: encodedVideo.height, mimeType: encodedVideo.mimeType,
          metrics: Object.freeze({ method: 'video_frame_fallback', sourceWidth: encodedVideo.sourceWidth, sourceHeight: encodedVideo.sourceHeight, width: encodedVideo.width, height: encodedVideo.height, bytes: encodedVideo.blob.size, nativeError, fallbackReason: fallbackReason || 'native_photo_unavailable', mirrorCorrected: false, takePhotoOptionsUsed: false, takePhotoOptions: null }),
        };
      } finally { if (!keepShutter && !shutterLowered) await hideCaptureFlash(); }
    }

    function recoverPoseCapture(code, step) {
      if (state.photoPoseRetryStep !== state.step) { state.photoPoseRetryStep = state.step; state.photoPoseRetryCount = 0; }
      state.photoPoseRetryCount += 1;
      state.capturing = false;
      state.faceDetectedAt = 0; state.stabilityReference = null; state.previousFace = null; state.stableSince = 0;
      if (state.photoPoseRetryCount > CONFIG.maxPhotoPoseRetries) {
        showError(null, { code: 'capture_error', title: 'No pudimos confirmar esta vista', text: 'La pose cambió durante la foto. Vuelve a intentarlo para continuar.' });
        return false;
      }
      const guidance = {
        turn_left: 'Mantén el giro; tomaremos la foto.',
        turn_right: 'Mantén el giro; tomaremos la foto.',
        look_front: 'Mira de nuevo al frente y mantén la posición.',
        no_face: 'Mantén el rostro visible dentro del óvalo.',
        matrix_yaw_unavailable: 'Mantén la posición mientras verificamos el giro.',
      };
      guide('↻', guidance[code] || guideForAssessment({ code, face: state.currentAssessment && state.currentAssessment.face }, step)[1]);
      scheduleLoop();
      return false;
    }
    function fadeCameraCardOut() {
      const frame = q('[data-a2-frame]') || q('.rogma-a2__camera-frame');
      if (!frame) return null;
      if (state.cameraExitAnimation) { state.cameraExitAnimation.cancel(); state.cameraExitAnimation = null; }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof frame.animate !== 'function') { frame.style.opacity = '0'; return null; }
      state.cameraExitAnimation = frame.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, easing: 'ease-out', fill: 'forwards' });
      return state.cameraExitAnimation;
    }
    function restoreCameraCard() { const frame=q('[data-a2-frame]')||q('.rogma-a2__camera-frame');if(state.cameraExitAnimation){state.cameraExitAnimation.cancel();state.cameraExitAnimation=null}if(frame)frame.style.opacity=''; }
    function requestPhotoRetry(name) {
      restoreCameraCard();
      resetCaptureFlash();
      if (!state.active) return;
      state.captures[name] = null;
      delete state.pendingValidations[name];
      state.step = STEP_ORDER.indexOf(name);
      state.capturing = false;
      state.startedAt = performance.now(); state.pauseUntil = 0;
      state.captureGreenHold = false; state.captureNoticeLabel = false; invalidateNormalCountdown(true);
      state.previousFace = null; state.stabilityReference = null; state.faceDetectedAt = 0; state.stableSince = 0; state.currentAssessment = null;
      captureView.hidden = false; completeView.hidden = true;
      state.retryPhotoMessage = true;
      if (state.retryMessageTimer) clearTimeout(state.retryMessageTimer);
      updateStep(); updateCounts(); setCameraPillText('Repitamos esta foto');
      state.retryMessageTimer = setTimeout(() => { state.retryPhotoMessage = false; state.retryMessageTimer = 0; }, 1400);
      scheduleLoop();
    }
    function storeValidatedCapture(name, image, metric, assessmentSnapshot = null) {
      const capture = Object.freeze({ ...image, capturedAt: Date.now(), validated: true, pending: false });
      state.captures[name] = capture;
      if (!isSimulation) recordCaptureMetadata(name, capture, assessmentSnapshot);
      if (debugMode) {
        state.debugMetrics.push(Object.freeze({ ...metric, capture: capture.metrics })); state.lastCapturedStep = STEP_ORDER.indexOf(name);
        state.debugThumbnails.push({ url: URL.createObjectURL(capture.blob), step: name, index: state.debugThumbnails.length + 1 });
        renderDebugThumbnails();
      }
      updateCounts();
      return capture;
    }
    function attachBackgroundValidation(name, pending, metric, assessmentSnapshot) {
      const token = {};
      state.captures[name] = { blob: pending.rawBlob, pending: true, validated: false, metrics: null };
      const promise = pending.validationPromise.then((result) => {
        if (state.pendingValidations[name] !== token) return;
        delete state.pendingValidations[name];
        if (!result || !result.ok) {
          delete state.captures[name]; updateCounts();
          if (state.capturing) state.retryRequested = name; else requestPhotoRetry(name);
          return;
        }
        storeValidatedCapture(name, result.image, metric, assessmentSnapshot);
      }).catch(() => {
        if (state.pendingValidations[name] !== token) return;
        delete state.pendingValidations[name]; delete state.captures[name]; updateCounts();
        if (state.capturing) state.retryRequested = name; else requestPhotoRetry(name);
      });
      state.pendingValidations[name] = token;
      state.pendingValidations[`promise_${name}`] = promise;
    }
    async function takeCapture(source = 'auto') {
      if (!state.active || state.capturing || !state.currentAssessment || performance.now() - state.lastAutoCapture < 500) return false;
      const name = STEP_ORDER[state.step];
      if (debugMode && !state.activeShutterAttempt) beginShutterTimeline(name, source === 'debug' ? 'debug_touch' : 'countdown_end');
      if (debugMode) recordShutterEvent('capture_pipeline_start', { source });
      if (source === 'auto') {
        let freshAssessment;
        try { const captureCheckAt = performance.now(); freshAssessment = assessCurrentFrame(detectedFace(captureCheckAt), name, captureCheckAt); }
        catch (_) { detectorError(); return false; }
        state.currentAssessment = freshAssessment;
        if (!freshAssessment.ok) {
          state.faceDetectedAt = 0; state.stabilityReference = null; state.previousFace = null; state.stableSince = 0; state.captureGreenHold = false; setCountdownVisual('');
          guide(...guideForAssessment(freshAssessment, name));
          return false;
        }
      }
      if (source === 'auto' && !state.currentAssessment.ok) return false;
      invalidateNormalCountdown(true);
      state.captureNoticeLabel = false;
      cancelScheduledLoop();
      if (state.visualCommitRaf) cancelAnimationFrame(state.visualCommitRaf);
      state.visualCommitRaf = 0; state.pendingVisual = null;
      state.capturing = true;
      try {
      const metric = debugMode ? liveMetric() : null;
        if (name !== 'frontal' && state.cameraControlsLockPromise) await state.cameraControlsLockPromise;
        state.captureNoticeLabel = true;
        setCameraPillText('Capturada ✓', true);
        queueVisualFrame(performance.now(), state.currentAssessment, STEP_ORDER[state.step]);
        const image = isSimulation ? { blob: new Blob(['simulated image frame'], { type: 'image/jpeg' }), width: 360, height: 480, mimeType: 'image/jpeg', metrics: Object.freeze({ method: 'simulation', sourceWidth: 360, sourceHeight: 480, width: 360, height: 480, bytes: 21, nativeError: null, fallbackReason: null }) } : await captureFinalImage(name);
        if (image.retryablePose) return recoverPoseCapture(image.code, name);
        if (name === 'frontal' && lightTestMode && !isSimulation) {
          state.cameraControlsLockPromise = (async () => {
            if (state.poiPromise) await state.poiPromise;
            state.frontCameraSettings = readTrackSettings(cameraTrack());
            await lockFrontalCameraControls();
          })().catch(() => {});
        }
        const assessmentSnapshot = state.currentAssessment ? { ...state.currentAssessment, face: state.currentAssessment.face ? { ...state.currentAssessment.face } : null, lighting: state.currentAssessment.lighting ? { ...state.currentAssessment.lighting } : null } : null;
        if (state.retryMessageTimer) { clearTimeout(state.retryMessageTimer); state.retryMessageTimer = 0; }
        state.retryPhotoMessage = false;
        if (image.pendingValidation) attachBackgroundValidation(name, image, metric, assessmentSnapshot);
        else storeValidatedCapture(name, image, metric, assessmentSnapshot);
        invalidateNormalCountdown(true);
        await showCapturedConfirmation();
        if (!state.active) { state.capturing = false; return false; }
        state.lastAutoCapture = performance.now(); updateCounts();
        if (state.retryRequested) { const retryName = state.retryRequested; state.retryRequested = ''; requestPhotoRetry(retryName); return true; }
        let nextStep = state.step + 1;
        while (nextStep < STEP_ORDER.length && state.captures[STEP_ORDER[nextStep]] && state.captures[STEP_ORDER[nextStep]].validated === true) nextStep += 1;
        state.step = nextStep; state.photoPoseRetryStep = state.step; state.photoPoseRetryCount = 0; state.previousFace = null; state.stableSince = 0;
        if (state.step >= STEP_ORDER.length) {
          fadeCameraCardOut();
          const pendingPromises = STEP_ORDER.map((key) => state.pendingValidations[`promise_${key}`]).filter(Boolean);
          if (pendingPromises.length) {
            state.capturing = false;
            await Promise.allSettled(pendingPromises);
            if (state.retryPhotoMessage) return false;
            if (STEP_ORDER.some((key) => !state.captures[key] || state.captures[key].validated !== true)) {
              const failed = STEP_ORDER.find((key) => !state.captures[key] || state.captures[key].validated !== true);
              if (failed) requestPhotoRetry(failed);
              return false;
            }
            state.capturing = true;
          }
          root.classList.remove('is-camera-active');
          if (debugMode) cancelScheduledLoop();
          else { await restoreAutomaticCameraModes(); stopTracks(); }
          if(state.pointRaf)cancelAnimationFrame(state.pointRaf);state.pointRaf=0;state.pointLastFrameAt=0;if(state.longTaskObserver){try{state.longTaskObserver.disconnect()}catch(_){}state.longTaskObserver=null;} captureView.hidden = true; completeView.hidden = false; if (debugTools) debugTools.hidden = !debugMode; completeView.querySelector('h1').focus({ preventScroll: true });
          if (debugMode) { const done = q('[data-a2-debug-complete]'); if (done) done.hidden = false; state.capturing = false; return true; }
          const a3Root = document.querySelector('[data-a3-root]'); if (a3Root) a3Root.classList.add('is-entering');
          document.dispatchEvent(new CustomEvent('rogma:a2-captures-ready', { detail: { imagenes_multivista: Object.fromEntries(STEP_ORDER.map((key) => [key, state.captures[key].blob])), imagenes_en_pixeles: true, consentimientos: state.consents, edad: state.age, capture_metadata: state.captureMetadata } }));
          if (a3Root) requestAnimationFrame(() => requestAnimationFrame(() => a3Root.classList.remove('is-entering')));
          const a3Ready = Boolean(window.RogmaA3 && document.querySelector('[data-a3-root]'));
          const noA3Message = q('[data-a2-no-a3]');
          if (a3Ready) root.hidden = true;
          else { root.hidden = false; if (noA3Message) noA3Message.hidden = false; }
          state.capturing = false;
          return true;
        }
        updateStep(); state.startedAt = performance.now(); state.faceDetectedAt = 0; state.stabilityReference = null; state.previousFace = null; state.stableSince = 0; if (debugMode && manual) manual.disabled = false;
        if (!debugMode && CONFIG.normalFlowV2Enabled) {
          state.pauseUntil = performance.now() + CONFIG.postCapturePauseMs;
          const next = STEP_ORDER[state.step];
          guide('✓', `Foto lista ✓ · ahora gira ${next === 'perfil_izq' ? 'a tu derecha para mostrar tu mejilla izquierda' : 'a tu izquierda para mostrar tu mejilla derecha'}`);
        } else guide('✓', 'Foto lista. Ahora sigue la siguiente vista.');
        state.capturing = false;
        scheduleLoop();
        return true;
      } catch (_) { state.capturing = false; showError(null, { code: 'capture_error', title: 'No se pudo tomar la foto', text: 'Conservamos las capturas anteriores en memoria. Vuelve a intentarlo.' }); return false; }
    }
    function simulatedMatrix(yawDeg = 0) {
      const angle = finite(yawDeg) * Math.PI / 180;
      const matrix = new Array(16).fill(0);
      matrix[0] = Math.cos(angle); matrix[2] = -Math.sin(angle); matrix[5] = 1;
      matrix[8] = Math.sin(angle); matrix[10] = Math.cos(angle); matrix[15] = 1;
      return { data: matrix };
    }
    function loop() {
      if (!state.active) return;
      state.animation = 0;
      if (state.capturing) return;
      if (isSimulation) renderSimulationFrame();
      const now = performance.now();
      if(!isSimulation&&now-state.lastDetectionAt<state.nextDetectionDelayMs){
        queueVisualFrame(now, state.currentAssessment, STEP_ORDER[state.step]);
        scheduleLoop(); return;
      }
      if (!isSimulation) state.lastDetectionAt = now;
      if (!debugMode && CONFIG.normalFlowV2Enabled && now < state.pauseUntil) {
        const next = STEP_ORDER[state.step];
        guide('✓', `Foto lista ✓ · ahora gira ${next === 'perfil_izq' ? 'a tu derecha para mostrar tu mejilla izquierda' : 'a tu izquierda para mostrar tu mejilla derecha'}`);
        scheduleLoop(); return;
      }
      let face = null; let quality = null;
      const analysisStartedAt = performance.now();
      try { face = detectedFace(now); quality = assessCurrentFrame(face, STEP_ORDER[state.step], now); }
      catch (_) { detectorError(); return; }
      if (debugMode) { state.analysisTotalMs += performance.now() - analysisStartedAt; state.analysisCount += 1; }
      state.currentAssessment = quality;
      const stepName = STEP_ORDER[state.step];
      smoothVisualFace(quality && quality.face, stepName);
      if (debugMode && manual) manual.disabled = (!state.active || state.capturing || state.countdownActive);
      const elapsedStable = quality && quality.ok && state.stableSince ? now - state.stableSince : 0;
      updateDiagnostics(quality, stepName, elapsedStable);
      if (debugMode || !CONFIG.normalFlowV2Enabled) {
        if (quality && quality.ok && (!state.previousFace || stableEnough(state.previousFace, quality.face))) {
          if (!state.stableSince) state.stableSince = now;
          guide(...guideFor('ready', STEP_ORDER[state.step]));
          const stableFor = now - state.stableSince;
          if (!debugMode && stableFor >= CONFIG.stabilityHoldMs && now - state.lastAutoCapture > 1000) {
            takeCapture('auto').then((captured) => { if (!captured && state.active) scheduleLoop(); });
            return;
          }
        } else {
          state.stableSince = 0;
          const copy = guideForAssessment(quality || { code: 'no_face' }, STEP_ORDER[state.step]); guide(...copy);
        }
        state.previousFace = quality && quality.face ? quality.face : null;
      } else {
        if (!face) { state.faceDetectedAt = 0; state.stabilityReference = null; state.stableSince = 0; state.previousFace = null; invalidateNormalCountdown(); }
        else if (!state.faceDetectedAt) state.faceDetectedAt = now;
        const evaluationAllowed = Boolean(face && state.faceDetectedAt && now - state.faceDetectedAt >= CONFIG.faceEvaluationGraceMs);
        let stableAgainstReference = false;
        if (evaluationAllowed && quality && quality.ok) {
          if (!state.stabilityReference) { state.stabilityReference = quality.face; state.stableSince = now; }
          if (stableEnough(state.stabilityReference, quality.face)) stableAgainstReference = true;
          else { state.stabilityReference = quality.face; state.stableSince = now; invalidateNormalCountdown(); }
          if (stableAgainstReference) guide(...guideFor('ready', STEP_ORDER[state.step]));
        } else {
          state.stabilityReference = null; state.stableSince = 0; invalidateNormalCountdown();
          const copy = guideForAssessment(quality || { code: 'no_face' }, STEP_ORDER[state.step]); guide(...copy);
        }
        const stableFor = stableAgainstReference ? now - state.stableSince : 0;
        if (stableAgainstReference && stableFor >= CONFIG.stabilityHoldMs && !state.countdownActive && now - state.lastAutoCapture > 1000) startNormalCountdown();
        state.previousFace = face || null;
      }
      queueVisualFrame(now, quality, stepName);
      scheduleLoop();
    }
    function startNormalCountdown() {
      const token = ++state.normalCountdownToken;
      state.countdownActive = true;
      state.countdownStartedAt = performance.now();
      state.captureNoticeLabel = false;
      let remaining = CONFIG.countdownSeconds;
      const tick = () => {
        if (!state.active || token !== state.normalCountdownToken) return;
        if (remaining <= 0) {
          if(debugMode)beginShutterTimeline(STEP_ORDER[state.step], 'countdown_end');
          state.captureNoticeLabel = false;
          state.countdownStartedAt = performance.now() - CONFIG.countdownSeconds * 1000;
          queueVisualFrame(performance.now(), state.currentAssessment, STEP_ORDER[state.step]);
          state.timer = requestAnimationFrame(() => {
            if (!state.active || token !== state.normalCountdownToken) return;
            state.timer = 0;
            state.countdownActive = false;
            takeCapture('auto').then((captured) => { state.captureNoticeLabel = false; if (!captured && state.active) scheduleLoop(); });
          });
          return;
        }
        const label = String(remaining);
        setCountdownVisual(label);
        if (countdownNode) { countdownNode.textContent = label; countdownNode.hidden = false; countdownNode.classList.remove('is-number-visible'); requestAnimationFrame(() => countdownNode.classList.add('is-number-visible')); }
        remaining -= 1;
        state.timer = setTimeout(tick, 1000);
      };
      tick();
    }
    function startSimulation() {
      simulated.width = 360; simulated.height = 480;
      state.simulatedFace = { x: .25, y: .225, width: .5, height: .55, centerX: .5, centerY: .5, rollDeg: 0, yawDeg: 0, brightness: .55 };
      fitCurrentOval();
      renderSimulationFrame(); loop();
    }
    function renderSimulationFrame() {
      const ctx = simulated.getContext('2d');
      ctx.fillStyle = '#b9a18a'; ctx.fillRect(0, 0, 360, 480);
      ctx.fillStyle = '#d9b49b'; ctx.beginPath(); ctx.ellipse(180, 225, 92, 128, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#37332f'; ctx.fillRect(130, 190, 18, 6); ctx.fillRect(212, 190, 18, 6);
      ctx.strokeStyle = '#805d4c'; ctx.lineWidth = 4; ctx.beginPath(); ctx.arc(180, 260, 32, .2, Math.PI - .2); ctx.stroke();
    }
    function leave() {
      stopTracks(); root.classList.remove('is-camera-active'); clearDebugArtifacts(); state.captures = Object.create(null); state.pendingValidations = Object.create(null); state.captureMetadata = null; state.lightingGuideShown = false; state.age = null; state.consents = null; root.hidden = true;
      const a1 = document.querySelector('[data-rogma-a1]'); if (a1) a1.hidden = false;
      document.dispatchEvent(new CustomEvent('rogma:a2-exit'));
      const target = document.querySelector('[data-screen="3"] h1, [data-screen="3"] h2'); if (target) target.focus({ preventScroll: true });
    }
    if (debugMode && manual) manual.addEventListener('click', debugCountdownCapture);
    if (debugTools) debugTools.hidden = !debugMode;
    if (debugMode) {
      q('[data-a2-debug-copy]').addEventListener('click', copyDebugMetrics);
      q('[data-a2-debug-repeat]').addEventListener('click', () => {
        state.step = state.active && state.step < STEP_ORDER.length
          ? state.step
          : (state.lastCapturedStep >= 0 ? state.lastCapturedStep : Math.min(state.step, STEP_ORDER.length - 1));
        state.startedAt = performance.now(); state.previousFace = null; state.stableSince = 0; state.currentAssessment = null;
        captureView.hidden = false; completeView.hidden = true;
        const done = q('[data-a2-debug-complete]'); if (done) done.hidden = true;
        updateStep(); updateCounts();
        if (state.active) { if (manual) manual.disabled = false; startPointInterpolator(); scheduleLoop(); } else startCamera();
      });
    }
    async function debugCountdownCapture() {
      if (!debugMode || !state.active || state.capturing || state.countdownActive) return;
      beginShutterTimeline(STEP_ORDER[state.step], 'debug_touch');
      state.countdownActive = true; if (manual) manual.disabled = true;
      try {
        for (const value of ['3', '2', '1']) {
          if (!state.active) return;
          if (countdownNode) { countdownNode.textContent = value; countdownNode.hidden = false; }
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        if (countdownNode) { countdownNode.textContent = ''; countdownNode.hidden = true; }
        if (state.active) await takeCapture('debug');
      } finally {
        state.countdownActive = false;
        if (countdownNode) { countdownNode.textContent = ''; countdownNode.hidden = true; }
        if (state.active && manual) manual.disabled = false;
      }
    }
    q('[data-a2-retry]').addEventListener('click', () => startCamera());
    q('[data-a2-retry-detector]').addEventListener('click', () => { state.landmarker = null; state.detectorPromise = null; startCamera(); });
    root.querySelectorAll('[data-a2-exit], [data-a2-exit-complete]').forEach((button) => button.addEventListener('click', leave));
    document.addEventListener('rogma:a1-prepare-detector', preloadDetector);
    document.addEventListener('rogma:a1-ready-for-capture', (event) => {
      const a1 = document.querySelector('[data-rogma-a1]'); if (a1) a1.hidden = true;
      root.hidden = false; captureView.hidden = false; completeView.hidden = true; if (debugTools) debugTools.hidden = !debugMode; clearDebugArtifacts(); state.step = 0; state.lastDetectionAt = 0; state.visualFace = null; state.captures = Object.create(null); state.pendingValidations = Object.create(null); state.cameraControlsLockPromise = null; state.retryPhotoMessage = false; state.retryRequested = ''; state.poiAttempted = false; state.poiPromise = null; state.poiApplied = false; state.exposureLocked = false; state.whiteBalanceLocked = false; state.exposureLockApplied = false; state.whiteBalanceLockApplied = false; state.frontCameraSettings = null; state.warmCueShown = false; state.mixedCueShown = false; state.screenLightShown = false; beginCaptureMetadata(); state.lightingUnevenSince = 0; state.lightingTestSince = 0; state.age = event.detail && event.detail.edad || null; state.consents = event.detail && event.detail.consentimientos || null; updateCounts(); startCamera();
    });
    // A3 can request one replacement while retaining the other in-memory captures.
    document.addEventListener('rogma:a2-repeat-capture', (event) => {
      const detail = event.detail || {};
      const step = STEP_ORDER.indexOf(detail.step);
      if (step < 0 || !detail.imagenes_multivista) return;
      stopTracks();
      STEP_ORDER.forEach((key) => {
        const blob = detail.imagenes_multivista[key];
        if (blob instanceof Blob) state.captures[key] = Object.freeze({ blob, width: 0, height: 0, mimeType: blob.type || 'image/jpeg', capturedAt: Date.now() });
        else delete state.captures[key];
      });
      state.captureMetadata = detail.capture_metadata && typeof detail.capture_metadata === 'object' ? detail.capture_metadata : state.captureMetadata;
      if (detail.consentimientos && typeof detail.consentimientos === 'object') state.consents = { ...detail.consentimientos };
      state.step = step;
      root.hidden = false; captureView.hidden = false; completeView.hidden = true;
      state.previousFace = null; state.stableSince = 0; state.currentAssessment = null;
      state.startedAt = performance.now(); state.lastDetectionAt = 0; state.visualFace = null; updateCounts(); updateStep(); startCamera();
    });
    document.addEventListener('rogma:a3-cancelled', leave);
    window.addEventListener('pagehide', () => { stopTracks(); clearDebugArtifacts(); state.captures = Object.create(null); state.captureMetadata = null; state.age = null; state.consents = null; }, { once: true });
    if (isSimulation) {
      window.RogmaA2Test = Object.freeze({
        setFace(face) { state.simulatedFace = face; },
        setStep(name) { state.step = STEP_ORDER.indexOf(name); updateStep(); },
        triggerError(name) { showError({ name }); },
        triggerInsecureError() { showError(null, classifyCameraError(null, false)); },
        triggerDetectorError: detectorError,
        runAnalysisCycle(face) {
          simulated.width = 360; simulated.height = 480;
          state.active = true; state.startedAt = performance.now(); state.lastDetectionAt = 0;
          state.faceDetectedAt = 0; state.stabilityReference = null; state.previousFace = null; state.stableSince = 0;
          state.currentAssessment = null; state.simulatedFace = face;
          if (message) message.hidden = true;
          loop();
          return { active: state.active, assessment: state.currentAssessment };
        },
        loseCamera() { showError({ name: 'AbortError' }); },
        captures: () => Object.keys(state.captures),
        start: () => startCamera(),
        stop: () => stopTracks(),
        config: CONFIG,
      });
    }
    if (isFlowTest) {
      window.RogmaA2FlowTest = Object.freeze({
        captures: () => STEP_ORDER.filter((key) => state.captures[key]).map((key) => ({ name: key, at: state.captures[key].capturedAt, metrics: state.captures[key].metrics })),
        step: () => STEP_ORDER[state.step] || 'complete',
        isCapturing: () => state.capturing,
        pauseActive: () => performance.now() < state.pauseUntil,
        countdownVisible: () => Boolean(countdownNode && !countdownNode.hidden),
        currentYaw: () => state.currentAssessment && state.currentAssessment.face ? state.currentAssessment.face.yawMatrixDeg : null,
        getStream: () => state.stream,
        isActive: () => state.active,
        manualEnabled: () => Boolean(debugMode && manual && !manual.disabled),
        debugSnapshot: () => JSON.parse(debugSnapshotText()),
        debugMode: () => debugMode,
        debugThumbnailCount: () => state.debugThumbnails.length,
        debugMetricCount: () => state.debugMetrics.length,
        copyDebugMetrics,
        start: () => document.dispatchEvent(new CustomEvent('rogma:a1-ready-for-capture', { detail: { edad: 24, consentimientos: { procesar_imagenes: true } } })),
      });
    }
  }
  window.RogmaA2 = Object.freeze({ ...API, install });
  document.querySelectorAll('[data-a2-root]').forEach(install);
})();
/* RŌGMA A3 — local review/send stage. Images stay as Blob objects in memory. */
(() => {
  'use strict';
  const CONFIG = Object.freeze({ requestTimeoutMs: 120000, maxImageBytes: 8 * 1024 * 1024, maxBodyBytes: 20 * 1024 * 1024 });
  const ORDER = Object.freeze(['frontal', 'perfil_izq', 'perfil_der']);
  const LABEL = Object.freeze({ frontal: 'Frontal', perfil_izq: 'Izquierda', perfil_der: 'Derecha' });
  const REVIEW_VIEW = Object.freeze({
    frontal: { number: '01', step: 'FRENTE', title: 'Vista frontal', detail: 'Rostro al centro' },
    perfil_izq: { number: '02', step: 'GIRO A TU DERECHA', title: 'Vista al girar a la derecha', detail: 'Mejilla izquierda · giro suave a tres cuartos' },
    perfil_der: { number: '03', step: 'GIRO A TU IZQUIERDA', title: 'Vista al girar a la izquierda', detail: 'Mejilla derecha · giro suave a tres cuartos' },
  });
  const state = { captures: null, captureMetadata: null, age: null, consents: null, sending: false, cancelled: false, controller: null, urls: [], success: null, improveConsentPrompted: false, improveConsentChoice: false };
  const q = (s) => document.querySelector(s);
  const root = () => q('[data-a3-root]');
  function configFor(node = (typeof document !== 'undefined' ? root() : null)) {
    const positive = (value, fallback) => Number.isFinite(Number(value)) && Number(value) > 0 ? Math.floor(Number(value)) : fallback;
    return Object.freeze({
      requestTimeoutMs: positive(node && node.dataset.requestTimeoutMs, CONFIG.requestTimeoutMs),
      maxImageBytes: positive(node && node.dataset.maxImageBytes, CONFIG.maxImageBytes),
      maxBodyBytes: positive(node && node.dataset.maxBodyBytes, CONFIG.maxBodyBytes),
      sendConsentsToBackend: !!(node && node.dataset.sendConsentsToBackend === 'true'),
    });
  }
  function base64FromBytes(bytes) {
    let binary = '';
    const chunk = 0x8000;
    for (let offset = 0; offset < bytes.length; offset += chunk) {
      binary += String.fromCharCode(...bytes.subarray(offset, Math.min(offset + chunk, bytes.length)));
    }
    return btoa(binary);
  }
  async function blobToBase64(blob) {
    return base64FromBytes(new Uint8Array(await blob.arrayBuffer()));
  }
  async function defaultSerializeRequest(request) {
    const images = {};
    for (const key of ORDER) images[key] = await blobToBase64(request.imagenes_multivista[key]);
    const payload = { edad: request.edad, rostro: images.frontal, imagenes_multivista: images };
    if (request.capture_metadata && typeof request.capture_metadata === 'object') payload.capture_metadata = request.capture_metadata;
    if (request.es_sujeto_control === true) payload.es_sujeto_control = true;
    if (request.send_consents_to_backend === true && request.consentimientos && typeof request.consentimientos === 'object') {
      payload.consentimientos = {
        procesar_imagenes: request.consentimientos.procesar_imagenes === true,
        mejora_sistema: request.consentimientos.mejora_sistema === true,
      };
    }
    return payload;
  }
  async function serializeRequest(request) {
    const testOverride = typeof window !== 'undefined' && typeof window.RogmaA3SerializeRequest === 'function' ? window.RogmaA3SerializeRequest : defaultSerializeRequest;
    return testOverride(request);
  }
  function formatMiB(bytes) { return `${(bytes / (1024 * 1024)).toFixed(0)} MiB`; }
  function revokePreviews() { state.urls.forEach((url) => URL.revokeObjectURL(url)); state.urls = []; }
  function clearImages() { revokePreviews(); state.captures = null; state.captureMetadata = null; state.age = null; state.consents = null; state.success = null; }
  function friendly(status, detail, online = (typeof navigator === 'undefined' || navigator.onLine)) {
    if (!online) return 'No hay conexión. Tus capturas siguen disponibles para reintentar aquí.';
    if (status === 422) return typeof detail === 'string' ? detail : 'No se pudo iniciar una lectura con estas capturas. Revisa el mensaje e inténtalo de nuevo.';
    if (status === 413) return 'Las imágenes superan el tamaño permitido. Conservamos las capturas para que puedas volver a intentarlo.';
    if (status === 429) return 'Hay muchas solicitudes en este momento. Espera un poco y vuelve a intentar.';
    if (status >= 500 || status === 503) return 'El servicio no está disponible por ahora. Puedes reintentar sin volver a tomar las fotos.';
    return 'No se pudo completar la lectura. Tus capturas siguen disponibles para reintentar.';
  }
  async function postJson(endpoint, body, signal, fetchImpl = (...args) => fetch(...args)) {
    try {
      return await fetchImpl(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, signal, cache: 'no-store' });
    } catch (error) {
      if (error && error.name === 'AbortError') throw error;
      throw Object.assign(new Error(friendly(0, null, false)), { code: 'network_error' });
    }
  }
  function showError(message, code) { const box = q('[data-a3-error]'); box.hidden = false; box.textContent = message; box.dataset.code = code || 'request_error'; q('[data-a3-status]').textContent = ''; }
  function fileMeta(blob) { return `${blob.type || 'tipo desconocido'} · ${(blob.size / 1024).toFixed(0)} KB`; }
  function renderReview(detail) {
    const r = root(); if (!r) return;
    const images = detail && detail.imagenes_multivista;
    if (!images || !ORDER.every((key) => images[key] instanceof Blob)) { showError('No llegaron las tres capturas. Vuelve a la captura para completarlas.', 'missing_captures'); return; }
    clearImages(); state.captures = Object.fromEntries(ORDER.map((key) => [key, images[key]]));
    state.captureMetadata = detail.capture_metadata && typeof detail.capture_metadata === 'object' ? detail.capture_metadata : null;
    state.age = Number.isInteger(Number(detail.edad)) ? Number(detail.edad) : null;
    state.consents = detail.consentimientos || detail.consents || {};
    if (state.improveConsentPrompted) state.consents = { ...state.consents, mejora_sistema: state.improveConsentChoice };
    const consent = state.consents || {};
    const consentsConfigured = configFor(r).sendConsentsToBackend;
    q('[data-a3-consent-summary]').textContent = `Consentimientos: procesar imágenes ${consent.procesar_imagenes === true ? 'sí' : 'no'} · mejora del sistema ${consent.mejora_sistema === true ? 'sí' : 'no'}. ${consentsConfigured ? 'Se incluirán en el envío.' : 'No se enviarán al backend hasta activar el ajuste tras instalar su soporte.'}`;
    q('[data-a3-age-summary]').textContent = state.age ? `Edad indicada: ${state.age}` : 'Edad: no disponible';
    const grid = q('[data-a3-previews]'); grid.replaceChildren();
    ORDER.forEach((key) => {
      const blob = state.captures[key]; const url = URL.createObjectURL(blob); state.urls.push(url);
      const view = REVIEW_VIEW[key];
      const card = document.createElement('figure'); card.className = 'rogma-a3__photo';
      const img = document.createElement('img'); img.src = url; img.alt = `Captura ${view.title.toLowerCase()} sin espejo`; img.decoding = 'async';
      const caption = document.createElement('figcaption');
      const step = document.createElement('span'); step.className = 'rogma-a3__photo-step'; step.textContent = `${view.number} · ${view.step}`;
      const title = document.createElement('strong'); title.className = 'rogma-a3__photo-title'; title.textContent = view.title;
      const description = document.createElement('span'); description.className = 'rogma-a3__photo-detail'; description.textContent = view.detail;
      const captured = document.createElement('span'); captured.className = 'rogma-a3__photo-captured'; captured.textContent = 'Capturada';
      caption.append(step, title, description, captured);
      card.append(img, caption); grid.append(card);
    });
    q('[data-a3-error]').hidden = true; q('[data-a3-send]').disabled = false; r.hidden = false;
    q('[data-a3-size-summary]').textContent = `JPEG/imagen: ${ORDER.map((key) => `${LABEL[key]} ${fileMeta(state.captures[key])}`).join(' · ')}. Total: ${ORDER.reduce((sum, key) => sum + state.captures[key].size, 0)} bytes.`;
    r.querySelector('h1').focus({ preventScroll: true });
    if (r.classList.contains('is-entering')) requestAnimationFrame(() => requestAnimationFrame(() => r.classList.remove('is-entering')));
  }
  function normalizeResponse(payload) {
    const nested = payload && payload.client_view;
    if (nested && typeof nested === 'object' && nested.contract_version === 'rogma_findings_screen_v1') return nested;
    if (payload && typeof payload === 'object' && payload.contract_version === 'rogma_findings_screen_v1') return payload;
    return null;
  }
  function safeScanId(value) {
    return typeof value === 'string' && value.length <= 80 && /^[A-Za-z0-9_-]+$/.test(value) ? value : '';
  }
  function terminalError(error) {
    return error.code === 'consent_required' || error.code === 'client_view_missing' || error.code === 'client_view_invalid' ||
      (Number.isInteger(error.status) && error.status >= 400 && error.status < 500 && error.status !== 429);
  }
  function validateSizes() {
    const sizes = ORDER.map((key) => state.captures[key].size);
    const total = sizes.reduce((a, b) => a + b, 0);
    const config = configFor();
    if (sizes.some((size) => size > config.maxImageBytes)) return `Una imagen supera el máximo configurado de ${formatMiB(config.maxImageBytes)}.`;
    if (total > config.maxBodyBytes) return `Las tres imágenes superan el máximo binario previo al envío de ${formatMiB(config.maxBodyBytes)}.`;
    return '';
  }
  async function submit() {
    if (!state.captures || state.sending) return;
    if (!state.consents || state.consents.procesar_imagenes !== true) {
      showError('Para enviar las capturas, vuelve a la preparación y acepta el consentimiento para procesar imágenes.', 'consent_required');
      return;
    }
    const r = root(); const endpoint = r.dataset.apiUrl;
    if (!endpoint) return showError('Falta configurar la URL de análisis en la sección Liquid.', 'endpoint_missing');
    const sizeError = validateSizes(); if (sizeError) return showError(sizeError, 'size_limit');
    state.sending = true; state.cancelled = false; state.controller = new AbortController();
    const button = q('[data-a3-send]'); button.disabled = true; q('[data-a3-error]').hidden = true;
    q('[data-a3-status]').textContent = 'Analizando, puede tardar hasta 2 minutos.';
    const requestConfig = configFor();
    const timeout = setTimeout(() => state.controller && state.controller.abort(), requestConfig.requestTimeoutMs);
    let request = null; let encodedPayload = null; let requestJson = null;
    try {
      request = { edad: state.age, rostro: state.captures.frontal, imagenes_multivista: { ...state.captures }, capture_metadata: state.captureMetadata };
      if (r.dataset.controlSubject === 'true') request.es_sujeto_control = true;
      if (requestConfig.sendConsentsToBackend) {
        request.send_consents_to_backend = true;
        request.consentimientos = { ...state.consents };
      }
      encodedPayload = await serializeRequest(request);
      requestJson = JSON.stringify(encodedPayload);
      const jsonBytes = new TextEncoder().encode(requestJson).byteLength;
      if (jsonBytes > requestConfig.maxBodyBytes) throw Object.assign(new Error(`El cuerpo de la solicitud supera el máximo configurado de ${formatMiB(requestConfig.maxBodyBytes)}.`), { code: 'size_limit' });
      if (!state.consents || state.consents.procesar_imagenes !== true) {
        throw Object.assign(new Error('Para enviar las capturas, vuelve a la preparación y acepta el consentimiento para procesar imágenes.'), { code: 'consent_required' });
      }
      const analysisView = r.querySelector('[data-a3-analysis]');
      if (analysisView) {
        analysisView.hidden = false;
        r.classList.add('rogma-a3--analyzing');
        window.scrollTo(0, 0);
      }
      const response = await postJson(endpoint, requestJson, state.controller.signal);
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw Object.assign(new Error(friendly(response.status, payload.detail || payload.mensaje)), { status: response.status });
      const view = normalizeResponse(payload);
      if (!view) throw Object.assign(new Error('El servicio respondió sin una lectura compatible. No mostraremos datos heredados.'), { code: 'client_view_missing' });
      const publicResponse = { client_view: view };
      const scanId = safeScanId((payload && payload.scan_id) || view.scan_id);
      let feedbackUrl = '';
      try { feedbackUrl = new URL('/api/feedback', endpoint).href; } catch (_) { /* endpoint was already checked before fetch */ }
      state.success = publicResponse;
      document.dispatchEvent(new CustomEvent('rogma:a3-result-ready', { detail: { response: publicResponse, scan_id: scanId, feedback_url: feedbackUrl } }));
      q('[data-a3-status]').textContent = 'Lectura recibida.'; clearImages(); r.hidden = true;
    } catch (error) {
      if (state.cancelled) return;
      const timeoutSeconds = Math.round(requestConfig.requestTimeoutMs / 1000);
      const message = error.name === 'AbortError' ? `El análisis superó el límite de ${timeoutSeconds} segundos. Tus capturas siguen aquí para reintentar.` : (typeof navigator !== 'undefined' && !navigator.onLine) ? friendly(0, null, false) : error.message || friendly(error.status || 0);
      showError(message, error.code || (error.name === 'AbortError' ? 'timeout' : 'request_error'));
      if (terminalError(error)) {
        clearImages(); q('[data-a3-previews]').replaceChildren(); q('[data-a3-send]').disabled = true;
        q('[data-a3-size-summary]').textContent = ''; q('[data-a3-status]').textContent = 'Inicia una nueva evaluación para volver a intentarlo.';
      } else button.disabled = false;
    } finally {
      const analysisView = r.querySelector('[data-a3-analysis]');
      if (analysisView) analysisView.hidden = true;
      r.classList.remove('rogma-a3--analyzing');
      clearTimeout(timeout); request = null; encodedPayload = null; requestJson = null; state.sending = false; state.controller = null;
    }
  }
  function install() {
    const r = root(); if (!r || r.dataset.a3Installed === 'true') return;
    r.dataset.a3Installed = 'true';
    const sendButton = q('[data-a3-send]');
    const consentDialog = q('[data-a3-consent-dialog]');
    const consentTitle = q('[data-a3-consent-title]');
    function chooseImproveConsent(value) {
      state.improveConsentPrompted = true; state.improveConsentChoice = value;
      state.consents = { ...(state.consents || {}), mejora_sistema: value };
      const consentSummary = q('[data-a3-consent-summary]');
      if (consentSummary) consentSummary.textContent = `Consentimientos: procesar imágenes ${state.consents.procesar_imagenes === true ? 'sí' : 'no'} · mejora del sistema ${value ? 'sí' : 'no'}.`;
      consentDialog.close();
      submit();
    }
    sendButton.addEventListener('click', () => {
      if (state.improveConsentPrompted) { submit(); return; }
      if (!consentDialog || typeof consentDialog.showModal !== 'function') return;
      consentDialog.showModal();
      requestAnimationFrame(() => consentTitle && consentTitle.focus({ preventScroll: true }));
    });
    if (consentDialog) {
      consentDialog.addEventListener('cancel', (event) => event.preventDefault());
      consentDialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); return; }
        if (event.key !== 'Tab') return;
        const choices = [...consentDialog.querySelectorAll('[data-a3-consent-choice]')];
        const first = choices[0]; const last = choices[choices.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === consentTitle)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      consentDialog.querySelectorAll('[data-a3-consent-choice]').forEach((button) => button.addEventListener('click', () => chooseImproveConsent(button.dataset.a3ConsentChoice === 'true')));
    }
    function cancelReview() { state.cancelled = true; if (state.controller) state.controller.abort(); clearImages(); r.hidden = true; document.dispatchEvent(new CustomEvent('rogma:a3-cancelled')); }
    q('[data-a3-retake-all]').addEventListener('click', () => {
      const detail = { edad: state.age, consentimiento: { ...(state.consents || {}) } };
      revokePreviews(); state.captures = null; state.captureMetadata = null; state.success = null; r.hidden = true;
      document.dispatchEvent(new CustomEvent('rogma:a1-ready-for-capture', { detail: { edad: detail.edad, consentimientos: detail.consentimiento } }));
    });
    q('[data-a3-review-back]').addEventListener('click', cancelReview);
    document.addEventListener('rogma:a2-captures-ready', (event) => renderReview(event.detail));
    window.addEventListener('pagehide', () => { state.cancelled = true; if (state.controller) state.controller.abort(); clearImages(); }, { once: true });
  }
  const API = Object.freeze({ CONFIG, ORDER, friendly, postJson, install, validateSizes, state, renderReview, clearImages, configFor, blobToBase64, defaultSerializeRequest, normalizeResponse, safeScanId });
  if (typeof window !== 'undefined') window.RogmaA3 = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  if (typeof document !== 'undefined') install();
})();

/* RŌGMA results B — renderer for the server-owned rogma_findings_screen_v1 contract. */
(() => {
  'use strict';
  const API = Object.freeze({
    fieldText(value) { return typeof value === 'string' ? value : Array.isArray(value) && value.every((x) => typeof x === 'string') ? value.join(' · ') : ''; },
    arr(value) { return Array.isArray(value) ? value : []; },
    responseView(response) { const view = response && response.client_view; return view && typeof view === 'object' && view.contract_version === 'rogma_findings_screen_v1' ? view : null; },
    safeScanId(value) { return typeof value === 'string' && value.length <= 80 && /^[A-Za-z0-9_-]+$/.test(value) ? value : ''; },
    prepareCartItems(view) {
      const products = ['am', 'pm', 'focal'].flatMap((key) => API.arr(view && view.ritual && view.ritual[key]));
      const quantities = new Map();
      for (const product of products) {
        if (!product || product.variant_id == null) throw new Error('variant_missing');
        const rawId = String(product.variant_id);
        if (!/^\d{1,20}$/.test(rawId)) throw new Error('variant_invalid');
        const id = Number(rawId);
        if (!Number.isSafeInteger(id) || id <= 0) throw new Error('variant_invalid');
        const quantity = (quantities.get(id) || 0) + 1;
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) throw new Error('quantity_invalid');
        quantities.set(id, quantity);
      }
      if (quantities.size < 1 || quantities.size > 20) throw new Error('cart_size_invalid');
      return [...quantities].map(([id, quantity]) => ({ id, quantity }));
    },
    install(root) {
      if (!root || root.dataset.bInstalled === 'true') return;
      root.dataset.bInstalled = 'true';
      const q = (s) => root.querySelector(s);
      function text(node, value) { if (node && typeof value === 'string') node.textContent = value; }
      function list(node, rows, render) { node.replaceChildren(); rows.forEach((row, index) => { const el = render(row, index); if (el) node.append(el); }); node.hidden = !node.childElementCount; }
      const productUseLabels = Object.freeze({
        'blemish care': 'IMPERFECCIONES',
        'dune biotech solar defense spf50+': 'PROTECCIÓN RAYOS UV',
        'niacinamida 10%': 'POROS Y BRILLO',
        'acido salicilico 2%': 'POROS OBSTRUIDOS',
        'lum bright tranex': 'MANCHAS Y TONO UNIFORME',
        'moisture support': 'HIDRATACIÓN',
        'antioxidant treatment': 'ANTIOXIDANTE Y LUMINOSIDAD',
        'night repair': 'RENOVACIÓN NOCTURNA',
        'ray of light': 'LUMINOSIDAD Y FIRMEZA',
      });
      function productKicker(product, segment) {
        const moment = segment === 'am' ? 'AM' : segment === 'pm' ? 'PM' : 'FOCAL';
        const name = API.fieldText(product && product.nombre).normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
        const label = productUseLabels[name];
        return label ? `${moment} · ${label}` : moment;
      }
      function prepareDetailsMotion(details) {
        if (!details || details.querySelector(':scope > .rogma-b__details-content')) return;
        const summary = [...details.children].find((child) => child.tagName === 'SUMMARY');
        if (!summary) return;
        const content = document.createElement('div'); content.className = 'rogma-b__details-content';
        const inner = document.createElement('div'); inner.className = 'rogma-b__details-content-inner';
        while (summary.nextSibling) inner.append(summary.nextSibling);
        content.append(inner); details.append(content);
        summary.setAttribute('aria-expanded', String(details.open));
        inner.inert = !details.open;
        if (details.open) requestAnimationFrame(() => { if (details.open && details._rogmaDesiredOpen !== false) { content.classList.add('is-expanded'); details.classList.add('is-expanded'); } });
      }
      function setDetailsOpen(details, open) {
        if (!details) return;
        const content = details.querySelector(':scope > .rogma-b__details-content');
        const summary = [...details.children].find((child) => child.tagName === 'SUMMARY');
        const inner = content && content.querySelector(':scope > .rogma-b__details-content-inner');
        const nextOpen = Boolean(open);
        details._rogmaDesiredOpen = nextOpen;
        if (details._rogmaCloseTimer) { clearTimeout(details._rogmaCloseTimer); details._rogmaCloseTimer = 0; }
        if (details._rogmaTransitionHandler && content) { content.removeEventListener('transitionend', details._rogmaTransitionHandler); details._rogmaTransitionHandler = null; }
        if (summary) summary.setAttribute('aria-expanded', String(nextOpen));
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          details.open = nextOpen;
          if (content) content.classList.toggle('is-expanded', nextOpen);
          details.classList.toggle('is-expanded', nextOpen);
          if (inner) inner.inert = !nextOpen;
          return;
        }
        if (nextOpen) {
          details.open = true;
          if (inner) inner.inert = false;
          if (content) requestAnimationFrame(() => { if (details.open && details._rogmaDesiredOpen) { content.classList.add('is-expanded'); details.classList.add('is-expanded'); } });
          return;
        }
        if (!details.open) return;
        if (inner) inner.inert = true;
        if (!content) { details.open = false; return; }
        const finishClose = () => {
          if (details._rogmaCloseTimer) clearTimeout(details._rogmaCloseTimer);
          details._rogmaCloseTimer = 0;
          if (details._rogmaTransitionHandler) content.removeEventListener('transitionend', details._rogmaTransitionHandler);
          details._rogmaTransitionHandler = null;
          details.open = false;
        };
        details._rogmaTransitionHandler = (event) => {
          if (event.target === content && event.propertyName === 'grid-template-rows') finishClose();
        };
        content.addEventListener('transitionend', details._rogmaTransitionHandler);
        content.classList.remove('is-expanded');
        details.classList.remove('is-expanded');
        details._rogmaCloseTimer = setTimeout(finishClose, 550);
      }
      root.querySelectorAll('details.rogma-b__others, details.rogma-b__disclosure, .rogma-b__feedback details').forEach(prepareDetailsMotion);
      const iconPaths = Object.freeze({
        textura: '<path d="M2 6c3-3 5 3 8 0s5-3 8 0 4 0 4 0M2 12c3-3 5 3 8 0s5-3 8 0 4 0 4 0M2 18c3-3 5 3 8 0s5-3 8 0 4 0 4 0"/>',
        manchas: '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 0 0 18Z" fill="currentColor" stroke="none"/>',
        poros: '<path d="M6 6h.01M12 6h.01M18 6h.01M6 12h.01M12 12h.01M18 12h.01M6 18h.01M12 18h.01M18 18h.01" stroke-width="3"/>',
        acne: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="1.8" fill="currentColor" stroke="none"/>',
        cicatrices: '<path d="M3 12h18M7 9l3 6m2-6 3 6m2-6 3 6"/>',
        arrugas: '<path d="M3 9c3-2 5 2 8 0s5-2 10 0M3 15c3-2 5 2 8 0s5-2 10 0"/>',
        rojez: '<path d="M12 22a8 8 0 0 0 8-8c0-4.5-8-12-8-12S4 9.5 4 14a8 8 0 0 0 8 8Z"/>',
        ojeras: '<path d="M2 12s3.6-5 10-5 10 5 10 5-3.6 5-10 5S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/>',
        opacidad: '<path d="m12 2 2.1 7.9L22 12l-7.9 2.1L12 22l-2.1-7.9L2 12l7.9-2.1L12 2Z"/>',
        general: '<circle cx="12" cy="12" r="9"/><path d="m12 6 1.3 4.7L18 12l-4.7 1.3L12 18l-1.3-4.7L6 12l4.7-1.3L12 6Z"/>',
        capas: '<rect x="4" y="4" width="11" height="11" rx="2"/><path d="M9 19h9a2 2 0 0 0 2-2V9"/>',
        destellos: '<path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3ZM19 17l.7 1.3L21 19l-1.3.7L19 21l-.7-1.3L17 19l1.3-.7L19 17Z"/>',
        arrow: '<path d="M7 17 17 7M8 7h9v9"/>',
        chevron: '<path d="m6 9 6 6 6-6"/>'
      });
      function iconSvg(key) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '1.5');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('aria-hidden', 'true');
        svg.innerHTML = iconPaths[key] || iconPaths.general;
        return svg;
      }
      function iconNode(key) {
        const holder = root.querySelector('[data-b-icons]'); const url = holder && holder.dataset[key];
        if (!url) return iconSvg(key);
        const img = document.createElement('img'); img.className = 'rogma-b__ico'; img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.decoding = 'async'; img.src = url;
        img.addEventListener('error', () => { if (img.parentNode) img.replaceWith(iconSvg(key)); }, { once: true });
        return img;
      }
      function setIcon(node, key) { if (node) node.replaceChildren(iconNode(key)); }
      function glyph(name) {
        const value = API.fieldText(name).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        if (/imperfeccion|granito|acne|brote/.test(value)) return 'acne';
        if (/mancha|tono|pigment/.test(value)) return 'manchas';
        if (/poro/.test(value)) return 'poros';
        if (/cicatri|marca|hendidura/.test(value)) return 'cicatrices';
        if (/textura|relieve/.test(value)) return 'textura';
        if (/arruga|linea|expresion/.test(value)) return 'arrugas';
        if (/rojez|enrojec|irritacion/.test(value)) return 'rojez';
        if (/ojera/.test(value)) return 'ojeras';
        if (/opacidad|luminos|apagad|brillo/.test(value)) return 'opacidad';
        return 'general';
      }
      function levelBars(value) {
        const level = API.fieldText(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        if (/alto|alta|intenso|intensa|marcado|marcada|severo|severa/.test(level)) return 3;
        if (/moderado|moderada|medio|media/.test(level)) return 2;
        if (/leve|bajo|baja/.test(level)) return 1;
        return 0;
      }
      function appearanceLabel(value) {
        const level = API.fieldText(value);
        if (!level) return '';
        if (/^moderado$/i.test(level)) return 'Apariencia moderada';
        if (/^alto$/i.test(level)) return 'Apariencia alta';
        if (/^leve$/i.test(level)) return 'Apariencia leve';
        return `Nivel ${level}`;
      }
      function itemCard(item, type, index) {
        if (!item || typeof item !== 'object') return null;
        const article = document.createElement('article'); article.className = `rogma-b__card rogma-b__card--${type}`;
        if (type === 'finding') {
          const button = document.createElement('button'); button.type = 'button'; button.className = 'rogma-b__finding-button'; button.dataset.bFindingIndex = String(index);
          const head = document.createElement('span'); head.className = 'rogma-b__finding-head';
          const icon = document.createElement('span'); icon.className = 'rogma-b__finding-glyph'; icon.setAttribute('aria-hidden', 'true'); setIcon(icon, glyph(item.nombre));
          const labels = document.createElement('span'); labels.className = 'rogma-b__finding-text';
          const name = document.createElement('span'); name.className = 'rogma-b__finding-name'; name.textContent = API.fieldText(item.nombre);
          const zone = document.createElement('span'); zone.className = 'rogma-b__finding-zone'; zone.textContent = zoneOf(item);
          const more = document.createElement('span'); more.className = 'rogma-b__finding-more'; more.setAttribute('aria-hidden', 'true'); more.append(iconSvg('arrow'));
          labels.append(name); if (zone.textContent) labels.append(zone); head.append(icon, labels, more); button.append(head);
          const level = document.createElement('span'); level.className = 'rogma-b__level'; level.textContent = API.fieldText(item.nivel);
          if (level.textContent) {
            const indicator = document.createElement('span'); indicator.className = 'rogma-b__level-indicator'; indicator.setAttribute('aria-hidden', 'true');
            const filled = levelBars(item.nivel);
            for (let i = 0; i < 3; i += 1) {
              const bar = document.createElement('i'); if (i < filled) bar.className = 'is-filled'; indicator.append(bar);
            }
            const levelGroup = document.createElement('span'); levelGroup.className = 'rogma-b__level-group'; levelGroup.append(indicator, level); button.append(levelGroup);
          }
          article.append(button); return article;
        }
        const title = document.createElement('h3'); title.textContent = API.fieldText(item.nombre);
        const copy = document.createElement('p'); copy.textContent = [item.zonas, item.nivel, item.disposicion, item.estado_tratamiento, item.motivo].filter((x) => typeof x === 'string' && x).join(' · ');
        article.append(title); if (copy.textContent) article.append(copy); return article;
      }
      function productCard(product, _index, segment, segmentTotal) {
        if (!product || typeof product !== 'object') return null;
        const article = document.createElement('article'); article.className = 'rogma-b__product';
        const details = document.createElement('details'); const summary = document.createElement('summary');
        const mark = document.createElement('span'); mark.className = 'rogma-b__product-mark'; mark.setAttribute('aria-hidden', 'true');
        const imageUrl = typeof product.imagen === 'string' && /^https:\/\/cdn\.shopify\.com\//.test(product.imagen) ? product.imagen : '';
        if (imageUrl) {
          const img = document.createElement('img'); img.src = imageUrl; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          img.addEventListener('error', () => { img.remove(); mark.classList.remove('has-image'); mark.textContent = 'R'; });
          mark.classList.add('has-image'); mark.append(img);
        } else { mark.textContent = 'R'; }
        const labels = document.createElement('span'); labels.className = 'rogma-b__product-summary';
        const kicker = document.createElement('span'); kicker.className = 'rogma-b__product-kicker'; kicker.textContent = productKicker(product, segment);
        const name = document.createElement('span'); name.className = 'rogma-b__product-name'; name.textContent = API.fieldText(product.nombre);
        const frequency = document.createElement('span'); frequency.className = 'rogma-b__product-hint'; frequency.textContent = segment === 'am' ? `Mañana · Paso ${_index + 1} de ${segmentTotal}` : segment === 'pm' ? `Noche · Paso ${_index + 1} de ${segmentTotal}` : API.fieldText(product.frecuencia);
        const priceNum = Number(String(product.precio == null ? '' : product.precio).replace(/,/g, ''));
        const price = document.createElement('span'); price.className = 'rogma-b__product-price'; price.textContent = product.precio != null && product.precio !== '' && Number.isFinite(priceNum) && priceNum > 0 ? `$${Math.round(priceNum).toLocaleString('es-MX')} MXN` : '';
        const viewDetails = document.createElement('span'); viewDetails.className = 'rogma-b__product-view-details'; viewDetails.textContent = 'Ver detalles';
        const chevron = document.createElement('span'); chevron.className = 'rogma-b__product-chevron'; chevron.setAttribute('aria-hidden', 'true'); chevron.append(iconSvg('chevron'));
        labels.append(kicker, name); if (price.textContent) labels.append(price); if (frequency.textContent) labels.append(frequency); labels.append(viewDetails); summary.append(mark, labels, chevron); details.append(summary);
        const body = document.createElement('div'); body.className = 'rogma-b__product-detail';
        [['Objetivo cosmético', product.objetivo_cosmetico], ['Por qué está en tu rutina', product.por_que_esta_en_tu_rutina], ['Cómo usarlo', product.como_usarlo]].forEach(([heading, value]) => {
          const copy = API.fieldText(value); if (!copy) return;
          const section = document.createElement('section'); const h4 = document.createElement('h4'); const p = document.createElement('p');
          h4.textContent = heading; p.textContent = copy; section.append(h4, p); body.append(section);
        });
        if (!body.childElementCount) { const p = document.createElement('p'); p.textContent = 'No hay más detalles disponibles en esta lectura.'; body.append(p); }
        const handle = typeof product.handle === 'string' && /^[a-z0-9-]+$/.test(product.handle) ? product.handle : '';
        if (handle) { const link = document.createElement('a'); link.className = 'rogma-b__product-link'; link.href = `/products/${handle}`; link.textContent = 'Ver producto'; body.append(link); }
        details.append(body); prepareDetailsMotion(details);
        article.append(details);
        article.dataset.variantId = product.variant_id == null ? '' : String(product.variant_id);
        return article;
      }
      function selectSegment(key) {
        root.querySelectorAll('[data-b-ritual-tab]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.bRitualTab === key)); });
        root.querySelectorAll('[data-b-ritual-panel]').forEach((panel) => { panel.hidden = panel.dataset.bRitualPanel !== key; });
      }
      function zoneOf(item) { const d = item && item.detalle; return API.fieldText(d && d.zonas) || API.fieldText(item && item.zonas); }
      function motiveOf(item) { const d = item && item.detalle; return API.fieldText(d && d.motivo) || API.fieldText(item && item.motivo); }
      function matchFinding(view, focus) {
        if (!focus) return null;
        const rows = API.arr(view && view.hallazgos); const norm = (v) => API.fieldText(v).trim().toLowerCase();
        return rows.find((r) => r && norm(r.nombre) && norm(r.nombre) === norm(focus.nombre) && norm(r.categoria) === norm(focus.categoria))
          || rows.find((r) => r && norm(r.categoria) && norm(r.categoria) === norm(focus.categoria)) || null;
      }
      function focusWithDetail(view) {
        const focus = view && view.enfoque_principal; if (!focus) return null;
        const match = matchFinding(view, focus);
        return match && match.detalle ? Object.assign({}, focus, { detalle: match.detalle }) : focus;
      }
      function cartDrawerEl() { return document.querySelector('cart-drawer'); }
      function drawerSections(drawer) {
        try { if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender().map((x) => x && x.id).filter(Boolean); } catch (_) { /* optional */ }
        return [];
      }
      function openCartDrawer(parsed) {
        const drawer = cartDrawerEl();
        if (drawer) {
          /* Dawn deja el cajón en estado vacío si estaba vacío al cargar: se limpia antes de pintar (igual que el escaneo V1) */
          drawer.classList.remove('is-empty');
          const inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          const items = drawer.querySelector('cart-drawer-items'); if (items) items.classList.remove('is-empty');
          try { if (parsed && parsed.sections && typeof drawer.renderContents === 'function') drawer.renderContents(parsed); } catch (_) { /* fall through */ }
          try { if (typeof drawer.open === 'function') { drawer.open(); return true; } } catch (_) { /* fall through */ }
        }
        const icon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (icon) { icon.click(); return true; }
        return false;
      }
      function openFinding(item) {
        if (!item || typeof item !== 'object') return;
        const dialog = q('[data-b-finding-dialog]');
        setIcon(q('[data-b-dialog-glyph]'), glyph(item.nombre));
        text(q('[data-b-dialog-title]'), API.fieldText(item.nombre));
        text(q('[data-b-dialog-zone]'), zoneOf(item));
        text(q('[data-b-dialog-level]'), API.fieldText(item.nivel));
        const motive = motiveOf(item);
        text(q('[data-b-dialog-motive]'), motive); q('[data-b-dialog-motive-wrap]').hidden = !motive;
        const tags = q('.rogma-b__dialog-tags'); if (tags) tags.hidden = Boolean(motive);
        if (typeof dialog.showModal === 'function') dialog.showModal();
      }
      function render(response) {
        const view = API.responseView(response);
        if (!view) { q('[data-b-error]').hidden = false; q('.rogma-b__content').hidden = true; text(q('[data-b-error]'), 'No llegó una lectura compatible. No mostraremos datos de formatos anteriores.'); root.hidden = false; return false; }
        q('[data-b-error]').hidden = true;
        q('.rogma-b__content').hidden = false;
        if (q('[data-b-finding-dialog]').open) q('[data-b-finding-dialog]').close();
        text(q('[data-b-state]'), view.estado && view.estado.texto);
        const coverage = view.cobertura || {};
        text(q('[data-b-coverage]'), coverage.estado === 'parcial' ? 'La lectura es parcial; algunas zonas no pudieron evaluarse.' : '');
        list(q('[data-b-coverage-list]'), API.arr(coverage.no_evaluados), (row) => { const p = document.createElement('p'); p.textContent = typeof row === 'string' ? row : [row && row.region, row && row.motivo].filter((v) => typeof v === 'string').join(' · '); return p.textContent ? p : null; });
        const focus = view.enfoque_principal && API.fieldText(view.enfoque_principal.nombre).trim() ? view.enfoque_principal : null;
        q('[data-b-focus]').hidden = !focus;
        if (focus) {
          setIcon(q('[data-b-focus-glyph]'), glyph(focus.nombre));
          text(q('[data-b-focus-title]'), API.fieldText(focus.nombre));
          const focusFull = focusWithDetail(view);
          text(q('[data-b-focus-zone]'), zoneOf(focusFull));
          text(q('[data-b-focus-level]'), appearanceLabel(focus.nivel));
          text(q('[data-b-focus-detail]'), (focusFull.detalle && motiveOf(focusFull)) || (zoneOf(focusFull) ? `Observación visual en ${zoneOf(focusFull).toLowerCase()}.` : 'Conoce más sobre este hallazgo de tu lectura cosmética.'));
        }
        const findings = API.arr(view.hallazgos);
        const general = q('[data-b-general]');
        general.hidden = Boolean(focus);
        text(q('[data-b-findings-heading]'), focus ? 'Otros aspectos observados' : 'Aspectos observados');
        setDetailsOpen(q('[data-b-others]'), !focus);
        if (!focus) {
          const count = findings.length;
          setIcon(q('[data-b-general-icon]'), count > 1 ? 'capas' : count === 1 ? glyph(findings[0] && findings[0].nombre) : 'destellos');
          text(q('[data-b-general-title]'), count > 1 ? 'Ningún aspecto destaca sobre los demás' : count === 1 ? 'Un aspecto observado' : 'Sin aspectos destacados');
          text(q('[data-b-general-copy]'), count > 1
            ? `Observamos ${count} aspectos con apariencia similar. Revisa cada uno abajo y decide cuáles te interesa cuidar.`
            : count === 1
              ? 'Observamos un aspecto en esta lectura. Revísalo abajo y decide si te interesa cuidarlo.'
              : 'En esta lectura no observamos aspectos que destaquen. Mantener una rutina constante ayuda a cuidar tu piel.');
          list(q('[data-b-general-chips]'), count > 1 ? findings : [], (row) => {
            const name = API.fieldText(row && row.nombre);
            if (!name) return null;
            const chip = document.createElement('span'); chip.textContent = name; return chip;
          });
        }
        const focusMatch = matchFinding(view, focus);
        const sameAsFocus = (item) => Boolean(focus && item && (item === focusMatch || (API.fieldText(item.nombre).trim().toLowerCase() === API.fieldText(focus.nombre).trim().toLowerCase()
          && zoneOf(item).trim().toLowerCase() === zoneOf(focusWithDetail(view)).trim().toLowerCase())));
        const focusIncluded = findings.some(sameAsFocus);
        const visibleFindings = findings.map((row, index) => ({ row, index })).filter(({ row }) => !sameAsFocus(row));
        q('[data-b-others]').hidden = visibleFindings.length === 0;
        text(q('[data-b-others-count]'), visibleFindings.length ? String(visibleFindings.length) : '');
        const observedCount = findings.length + (focus && !focusIncluded ? 1 : 0);
        text(q('[data-b-findings-count]'), observedCount ? `${observedCount} aspecto${observedCount === 1 ? '' : 's'} observado${observedCount === 1 ? '' : 's'}` : '');
        list(q('[data-b-findings]'), visibleFindings, ({ row, index }) => itemCard(row, 'finding', index));
        const severeCopy = 'Para este nivel de apariencia, una valoración dermatológica puede orientarte mejor.';
        const findingNotes = findings.map((row) => {
          if (!row) return '';
          const n = typeof row.nota === 'string' && row.nota ? row.nota : (/severo/i.test(API.fieldText(row.nivel)) ? severeCopy : '');
          return n ? `${API.fieldText(row.nombre)}: ${n}` : '';
        }).filter(Boolean);
        const findingsBox = q('[data-b-findings]');
        if (findingsBox) {
          let noteEl = findingsBox.parentNode && findingsBox.parentNode.querySelector('[data-b-findings-note]');
          if (!noteEl && findingsBox.parentNode) { noteEl = document.createElement('p'); noteEl.setAttribute('data-b-findings-note', ''); findingsBox.insertAdjacentElement('afterend', noteEl); }
          if (noteEl) { noteEl.classList.add('rogma-b__findings-note'); noteEl.removeAttribute('style'); noteEl.textContent = findingNotes.join(' '); noteEl.hidden = !findingNotes.length; }
        }
        list(q('[data-b-natural]'), API.arr(view.rasgos_naturales), (row) => { const p = document.createElement('p'); p.textContent = typeof row === 'string' ? row : API.fieldText(row && (row.frase || row.texto)); return p.textContent ? p : null; });
        list(q('[data-b-unevaluated]'), API.arr(view.no_evaluados), (row) => { const p = document.createElement('p'); p.textContent = typeof row === 'string' ? row : [row && row.region, row && row.motivo].filter((v) => typeof v === 'string').join(' · '); return p.textContent ? p : null; });
        q('[data-b-natural-wrap]').hidden = q('[data-b-natural]').hidden;
        q('[data-b-coverage-wrap]').hidden = q('[data-b-coverage-list]').hidden && q('[data-b-unevaluated]').hidden;
        const ritual = view.ritual || {};
        const segments = ['am', 'pm', 'focal'];
        segments.forEach((key) => { const rows = API.arr(ritual[key]); list(q(`[data-b-products="${key}"]`), rows, (product, index) => productCard(product, index, key, rows.length)); });
        const baseNotes = {
          am: 'Empieza con una limpieza suave y termina siempre con protector solar.',
          pm: 'Empieza con una limpieza suave que retire el protector solar y termina con tu hidratante habitual si lo necesitas.',
          focal: 'Por ahora no hay un producto focal específico para esta lectura.',
        };
        segments.forEach((key) => {
          const panel = q(`[data-b-ritual-panel="${key}"]`); if (!panel) return;
          let note = panel.querySelector('[data-b-base-note]');
          if (!note) { note = document.createElement('p'); note.setAttribute('data-b-base-note', ''); panel.insertBefore(note, panel.firstChild); }
          note.classList.add('rogma-b__base-note'); note.removeAttribute('style');
          note.textContent = baseNotes[key];
          const hasProducts = !q(`[data-b-products="${key}"]`).hidden;
          note.hidden = key === 'focal' ? hasProducts : !hasProducts;
          if (key !== 'focal') {
            let title = panel.querySelector('[data-b-base-note-title]');
            if (!title) { title = document.createElement('h3'); title.setAttribute('data-b-base-note-title', ''); title.className = 'rogma-b__base-note-title'; panel.insertBefore(title, note); }
            title.textContent = 'Cómo aplicarlo'; title.hidden = !hasProducts;
          }
        });
        const available = segments.filter((key) => !q(`[data-b-products="${key}"]`).hidden);
        root.querySelectorAll('[data-b-ritual-tab]').forEach((button) => { button.hidden = !available.includes(button.dataset.bRitualTab); button.disabled = button.hidden; });
        q('.rogma-b__tabs').hidden = available.length <= 1;
        q('[data-b-ritual-empty]').hidden = available.length !== 0;
        selectSegment(available[0] || 'am');
        text(q('[data-b-focal-order]'), ritual.orden_focal === 'despues_de_los_pasos_pm' ? 'El cuidado focal va después de los pasos PM.' : '');
        list(q('[data-b-alternation]'), API.arr(ritual.alternancia), (row) => { const p = document.createElement('p'); p.textContent = typeof row === 'string' ? row : API.fieldText(row.instruccion); return p.textContent ? p : null; });
        list(q('[data-b-after]'), API.arr(view.para_despues), (row) => itemCard(row, 'later'));
        list(q('[data-b-notices]'), API.arr(view.avisos), (row) => { const p = document.createElement('p'); p.textContent = typeof row === 'string' ? row : API.fieldText(row && (row.texto || row.mensaje)); return p.textContent ? p : null; });
        q('[data-b-after-wrap]').hidden = q('[data-b-after]').hidden;
        q('[data-b-notices-wrap]').hidden = q('[data-b-notices]').hidden;
        const cart = view.carrito || {}; const cartButton = q('[data-b-add-cart]');
        let variantsReady = false;
        if (available.length) { try { API.prepareCartItems(view); variantsReady = true; } catch (_) { /* The ritual remains visible without confirmed variants. */ } }
        cartButton.hidden = available.length === 0;
        cartButton.disabled = !(cart.habilitado === true && variantsReady);
        cartButton.dataset.reason = API.fieldText(cart.motivo);
        text(q('[data-b-cart-status]'), '');
        text(q('[data-b-price]'), cartButton.disabled ? cartReasonCopy(API.fieldText(cart.motivo)) : '');
        q('[data-b-price]').hidden = !cartButton.disabled || available.length === 0;
        const scanId = API.safeScanId(view.scan_id || (root.__rogmaEventMeta && root.__rogmaEventMeta.scan_id));
        root.__rogmaScanId = scanId;
        text(q('[data-b-scan-id]'), scanId ? `ID de lectura: ${scanId}` : '');
        q('[data-b-scan-id-wrap]').hidden = !scanId;
        q('[data-b-feedback]').hidden = !(scanId && root.__rogmaEventMeta && root.__rogmaEventMeta.feedback_url);
        q('[data-b-delete-note]').hidden = false;
        root.hidden = false; return true;
      }
      function cartReasonCopy(code) {
        const map = {
          existencias_pendientes: 'Aún no podemos confirmar las existencias de este ritual.',
          producto_no_disponible: 'Alguno de los productos no está disponible por ahora.',
        };
        return map[code] || 'Precio y disponibilidad no confirmados en esta lectura.';
      }
      async function resolveCartItems(view, route) {
        const rows = ['am', 'pm', 'focal'].flatMap((k) => API.arr(view && view.ritual && view.ritual[k])).filter((p) => p && typeof p === 'object');
        const validHandle = (p) => (typeof p.handle === 'string' && /^[a-z0-9-]+$/.test(p.handle) ? p.handle : '');
        const handles = [...new Set(rows.map(validHandle).filter(Boolean))];
        const infos = new Map();
        await Promise.all(handles.map(async (h) => {
          try { const r = await fetch(`${route}products/${h}.js`, { headers: { Accept: 'application/json' } }); infos.set(h, r.ok ? await r.json() : null); }
          catch (_) { infos.set(h, null); }
        }));
        const ids = new Set(); const skipped = [];
        for (const p of rows) {
          const info = infos.get(validHandle(p));
          const variants = info && Array.isArray(info.variants) ? info.variants : [];
          let id = null;
          if (variants.length) {
            const exact = variants.find((v) => String(v.id) === String(p.variant_id));
            const pick = exact && exact.available ? exact : variants.find((v) => v.available);
            if (!pick) { const n = API.fieldText(p.nombre); if (n && !skipped.includes(n)) skipped.push(n); continue; }
            id = Number(pick.id);
          } else {
            const raw = String(p.variant_id == null ? '' : p.variant_id);
            if (!/^\d{1,20}$/.test(raw)) throw new Error('variant_invalid');
            id = Number(raw);
          }
          if (Number.isSafeInteger(id) && id > 0) ids.add(id);
        }
        if (!ids.size) throw new Error('nothing_available');
        return { items: [...ids].slice(0, 20).map((id) => ({ id, quantity: 1 })), skipped };
      }
      async function addCart() {
        const view = root.__rogmaView; const cart = view && view.carrito;
        if (!cart || cart.habilitado !== true) return;
        const button = q('[data-b-add-cart]'); button.disabled = true;
        text(q('[data-b-cart-status]'), 'Preparando tu ritual…');
        try {
          const route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          let items; let skipped = [];
          try { ({ items, skipped } = await resolveCartItems(view, route)); }
          catch (e) { text(q('[data-b-cart-status]'), e && e.message === 'nothing_available' ? 'Estos productos no están disponibles por ahora.' : 'No se pudo validar una variante del ritual; no se envió al carrito.'); return; }
          const drawer = cartDrawerEl(); const sections = drawerSections(drawer);
          const payload = sections.length ? { items, sections, sections_url: window.location.pathname } : { items };
          const res = await fetch(`${route}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          if (!res.ok) throw new Error('not_available');
          const parsed = await res.json();
          const opened = openCartDrawer(parsed);
          const added = [...new Set(['am', 'pm', 'focal'].flatMap((k) => API.arr(view.ritual && view.ritual[k])).map((p) => API.fieldText(p && p.nombre)).filter((n) => n && !skipped.includes(n)))];
          const base = `Tu ritual se añadió al carrito${added.length ? `: ${added.join(', ')}` : ''}.`;
          const statusEl = q('[data-b-cart-status]');
          text(statusEl, skipped.length ? `${base} No añadimos por falta de existencias: ${skipped.join(', ')}.` : base);
          await new Promise((resolve) => setTimeout(resolve, 700));
          const drawerNow = cartDrawerEl();
          const drawerHasItems = Boolean(opened && drawerNow && drawerNow.querySelector('.cart-item, [id^="CartDrawer-Item"], cart-drawer-items tbody tr, .cart-drawer__item'));
          if (!drawerHasItems && drawerNow) {
            /* Refresco de respaldo: pedir de nuevo las secciones del carrito y repintar el cajón */
            try {
              const ids = drawerSections(drawerNow);
              if (ids.length && typeof drawerNow.renderContents === 'function') {
                const r2 = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(ids.join(','))}&sections_url=${encodeURIComponent(window.location.pathname)}`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
                if (r2.ok) { drawerNow.classList.remove('is-empty'); drawerNow.renderContents({ id: null, sections: await r2.json() }); try { if (typeof drawerNow.open === 'function') drawerNow.open(); } catch (_) { /* optional */ } await new Promise((resolve) => setTimeout(resolve, 500)); }
              }
            } catch (_) { /* optional */ }
          }
          const drawerFinal = cartDrawerEl();
          const hasItemsFinal = Boolean(drawerFinal && drawerFinal.querySelector('.cart-item, [id^="CartDrawer-Item"], cart-drawer-items tbody tr, .cart-drawer__item'));
          let cartLink = root.querySelector('[data-b-cart-fallback]');
          if (!hasItemsFinal && statusEl) {
            if (!cartLink) { cartLink = document.createElement('a'); cartLink.setAttribute('data-b-cart-fallback', ''); cartLink.className = 'rogma-b__product-link rogma-b__cart-fallback'; cartLink.textContent = 'Ver mi carrito'; statusEl.insertAdjacentElement('afterend', cartLink); }
            cartLink.href = `${route}cart`; cartLink.hidden = false;
          } else if (cartLink) { cartLink.hidden = true; }
        } catch (_) { text(q('[data-b-cart-status]'), 'No pudimos añadir el ritual. Revisa la disponibilidad en la tienda e inténtalo de nuevo.'); }
        finally { button.disabled = false; }
      }
      async function sendFeedback() {
        const meta = root.__rogmaEventMeta || {};
        const scanId = API.safeScanId(root.__rogmaScanId);
        if (!scanId || !meta.feedback_url) return;
        const rating = Number(q('[data-b-rating]').value);
        const aspect = q('[data-b-aspect]').value;
        if (!Number.isInteger(rating) || rating < 1 || rating > 5 || !aspect) {
          text(q('[data-b-feedback-status]'), 'Elige una valoración y un aspecto antes de enviar.'); return;
        }
        const button = q('[data-b-feedback-send]'); button.disabled = true;
        try {
          const response = await fetch(meta.feedback_url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ scan_id: scanId, rating, aspecto_mas_util: aspect, comentario: String(q('[data-b-comment]').value || '').slice(0, 250) }) });
          if (!response.ok) throw new Error('feedback_rejected');
          text(q('[data-b-feedback-status]'), 'Gracias por compartir tu opinión.');
          button.hidden = true;
        } catch (_) { text(q('[data-b-feedback-status]'), 'No pudimos guardar tu opinión. Puedes intentarlo más tarde.'); }
        finally { button.disabled = false; }
      }
      root.addEventListener('click', (event) => {
        const target = event.target;
        const summary = target.closest('summary');
        const disclosure = summary && summary.parentElement;
        if (disclosure && disclosure.matches('details.rogma-b__others, details.rogma-b__disclosure, .rogma-b__feedback details, .rogma-b__product details')) {
          event.preventDefault(); setDetailsOpen(disclosure, !disclosure.open); return;
        }
        if (target.closest('[data-b-add-cart]')) { addCart(); return; }
        if (target.closest('.rogma-b__cart-link') && cartDrawerEl()) { event.preventDefault(); openCartDrawer(null); return; }
        const tab = target.closest('[data-b-ritual-tab]'); if (tab) { selectSegment(tab.dataset.bRitualTab); return; }
        const finding = target.closest('[data-b-finding-index]');
        if (finding) { openFinding(API.arr(root.__rogmaView && root.__rogmaView.hallazgos)[Number(finding.dataset.bFindingIndex)]); return; }
        if (target.closest('[data-b-focus-open]')) { openFinding(focusWithDetail(root.__rogmaView)); return; }
        if (target.closest('[data-b-finding-close]')) { q('[data-b-finding-dialog]').close(); return; }
        if (target.closest('[data-b-new-evaluation]')) window.location.reload();
      });
      const findingDialog = q('[data-b-finding-dialog]');
      findingDialog.addEventListener('click', (event) => {
        const dialog = event.currentTarget;
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      let sheetStartY = null;
      findingDialog.addEventListener('touchstart', (event) => {
        if (event.target !== findingDialog || event.touches.length !== 1) return;
        const y = event.touches[0].clientY;
        const top = findingDialog.getBoundingClientRect().top;
        sheetStartY = y >= top && y <= top + 44 ? y : null;
      }, { passive: true });
      findingDialog.addEventListener('touchend', (event) => {
        if (sheetStartY !== null && event.changedTouches[0].clientY - sheetStartY > 80) findingDialog.close();
        sheetStartY = null;
      }, { passive: true });
      q('[data-b-feedback-send]').addEventListener('click', sendFeedback);
      // Controles propios para la opinión (los select originales quedan ocultos y sincronizados).
      root.querySelectorAll('.rogma-b__feedback select').forEach((select) => {
        const label = select.closest('label');
        const caption = label ? (label.firstChild && label.firstChild.textContent || '').trim() : '';
        const group = document.createElement('div');
        group.className = 'rogma-b__pills'; group.setAttribute('role', 'group'); group.setAttribute('aria-label', caption);
        group.dataset.pills = select.hasAttribute('data-b-rating') ? 'rating' : 'aspect';
        [...select.options].filter((o) => o.value).forEach((o) => {
          const b = document.createElement('button'); b.type = 'button'; b.textContent = o.textContent; b.dataset.value = o.value; b.setAttribute('aria-pressed', 'false'); group.append(b);
        });
        const sync = () => group.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.value === select.value)));
        group.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; select.value = select.value === b.dataset.value ? '' : b.dataset.value; sync(); });
        select.hidden = true;
        if (label) label.after(group); else select.after(group);
      });

      document.addEventListener('rogma:a3-result-ready', (event) => { root.__rogmaEventMeta = { scan_id: event.detail && event.detail.scan_id, feedback_url: event.detail && event.detail.feedback_url }; root.__rogmaView = API.responseView(event.detail && event.detail.response); render(event.detail && event.detail.response); });
      if (root.dataset.bFixtureMode === 'true') window.RogmaBTest = Object.freeze({ render, root });
    },
  });
  if (typeof window !== 'undefined') window.RogmaB = API;
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  if (typeof document !== 'undefined') document.querySelectorAll('[data-b-root]').forEach(API.install);
})();


/* RŌGMA IA · coordinador de flujo (historial del navegador + sesión corta). No guarda fotos. */
(() => {
  'use strict';
  const root = document.querySelector('[data-rogma-scan]');
  if (!root) return;
  const a1 = root.querySelector('[data-rogma-a1]');
  const a2 = root.querySelector('[data-a2-root]');
  const a3 = root.querySelector('[data-a3-root]');
  const b = root.querySelector('[data-b-root]');
  if (!a1 || !a2 || !a3 || !b) return;
  const KEY = 'rogma_scan_session_v1';
  const TTL = 10 * 60 * 1000;
  let fromPop = false;
  let restoring = false;
  let hasResult = false;

  const store = {
    get() { try { const raw = sessionStorage.getItem(KEY); if (!raw) return null; const d = JSON.parse(raw); if (!d || !d.response || Date.now() - d.t > TTL) { sessionStorage.removeItem(KEY); return null; } return d; } catch (_) { return null; } },
    set(v) { try { const s = JSON.stringify({ t: Date.now(), ...v }); if (s.length < 800000) sessionStorage.setItem(KEY, s); } catch (_) {} },
    clear() { try { sessionStorage.removeItem(KEY); } catch (_) {} },
  };
  const live = () => (!b.hidden ? 'results' : !a3.hidden ? 'review' : !a2.hidden ? 'camera' : 'a1');
  const cur = () => (history.state && history.state.rogmaScan != null ? history.state.rogmaScan : null);
  const push = (s) => { try { history.pushState({ rogmaScan: s }, ''); } catch (_) {} };
  const replace = (s) => { try { history.replaceState({ rogmaScan: s }, ''); } catch (_) {} };
  const top = () => { try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (_) {} };

  function restore(saved) {
    restoring = true;
    a1.hidden = true; a2.hidden = true; a3.hidden = true;
    try { document.dispatchEvent(new CustomEvent('rogma:a3-result-ready', { detail: { response: saved.response, scan_id: saved.scan_id, feedback_url: saved.feedback_url } })); } catch (_) {}
    restoring = false;
    if (b.hidden) { a1.hidden = false; store.clear(); replace(0); return false; }
    hasResult = true; replace('results'); return true;
  }

  function go(s) {
    const l = live();
    if (typeof s === 'number') {
      if (l === 'camera') { const x = a2.querySelector('[data-a2-exit]'); if (x) x.click(); }
      else if (l === 'review') { const x = a3.querySelector('[data-a3-review-back]'); if (x) x.click(); }
      else if (l === 'results') { b.hidden = true; }
      a2.hidden = true; a3.hidden = true; a1.hidden = false;
      if (typeof a1.__rogmaShow === 'function') a1.__rogmaShow(s, false);
      top();
    } else if (s === 'results') {
      if (l === 'results') return;
      if (hasResult) { a1.hidden = true; a2.hidden = true; a3.hidden = true; b.hidden = false; top(); return; }
      const saved = store.get();
      if (!(saved && restore(saved))) { replace(0); go(0); }
    } else if (s === 'capture') {
      if (l !== 'camera' && l !== 'review') { replace(3); go(3); }
    }
  }

  try { new MutationObserver(() => document.body.classList.toggle('rogma-scan-results', !b.hidden)).observe(b, { attributes: true, attributeFilter: ['hidden'] }); } catch (_) {}


  // Cierra cualquier hueco entre el header del sitio y esta página (mide y compensa; no depende del tema).
  function hideEmptySpacers() {
    try {
      const wrap = root.closest('[id^="shopify-section"]') || root;
      let n = wrap.previousElementSibling; let guard = 0;
      while (n && guard++ < 6) {
        if (n.matches('header, .section-header, [id*="header"]')) break;
        if (n.matches('[id^="shopify-section"]') && !(n.textContent || '').trim() && !n.querySelector('img,video,svg,iframe,input,button,a')) n.style.display = 'none';
        n = n.previousElementSibling;
      }
    } catch (_) {}
  }
  function closeGap() {
    try {
      hideEmptySpacers();
      const hs = [...document.querySelectorAll('header, .header-wrapper, [id^="shopify-section-header"], .section-header')].filter((h) => !root.contains(h) && h.getClientRects().length);
      if (hs.length) {
        const bottom = Math.max(...hs.map((h) => h.getBoundingClientRect().bottom + window.scrollY));
        const gap = root.getBoundingClientRect().top + window.scrollY - bottom;
        const cur = parseFloat(root.style.marginTop) || 0;
        if (gap <= 150) {
          const next = Math.min(0, cur - gap);
          if (Math.abs(next - cur) > 0.5) root.style.marginTop = next + 'px';
        }
      }
    } catch (_) {}
  }
  function updateAvailableHeight() {
    try {
      const rootTop = Math.max(0, root.getBoundingClientRect().top);
      root.style.setProperty('--rogma-available-height', `${Math.max(0, window.innerHeight - rootTop)}px`);
    } catch (_) {}
  }
  closeGap();
  updateAvailableHeight();
  window.addEventListener('load', () => { closeGap(); updateAvailableHeight(); });
  let lastWindowWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    closeGap();
    if (window.innerWidth !== lastWindowWidth) {
      lastWindowWidth = window.innerWidth;
      updateAvailableHeight();
    }
  });
  window.addEventListener('orientationchange', () => {
    closeGap();
    lastWindowWidth = window.innerWidth;
    updateAvailableHeight();
  });
  setTimeout(closeGap, 400); setTimeout(closeGap, 1500);
  try {
    let gt = 0;
    const mo = new MutationObserver(() => { clearTimeout(gt); gt = setTimeout(closeGap, 80); });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    setTimeout(() => mo.disconnect(), 20000);
  } catch (_) {}

  // Estado inicial
  let navType = 'navigate';
  try { const n = performance.getEntriesByType('navigation')[0]; if (n && n.type) navType = n.type; } catch (_) {}
  if (navType !== 'back_forward') store.clear();
  const saved = navType === 'back_forward' ? store.get() : null;
  if (saved && cur() === 'results') restore(saved); else replace(0);

  document.addEventListener('rogma:a1-screen', (e) => {
    if (fromPop) return;
    const n = e.detail && e.detail.screen; const c = cur();
    if (typeof n !== 'number') return;
    if (typeof c === 'number' && n > c) push(n); else replace(n);
  });
  document.addEventListener('rogma:a1-ready-for-capture', () => { if (!fromPop) push('capture'); top(); });
  document.addEventListener('rogma:a2-captures-ready', top);
  document.addEventListener('rogma:a2-exit', () => { if (fromPop) return; if (cur() === 'capture') history.back(); top(); });
  document.addEventListener('rogma:a3-result-ready', (e) => {
    const d = e.detail || {};
    hasResult = true;
    if (!restoring) { store.set({ response: d.response, scan_id: d.scan_id, feedback_url: d.feedback_url }); replace('results'); }
    top();
  });
  window.addEventListener('popstate', (e) => {
    const s = e.state && e.state.rogmaScan;
    if (s == null) return;
    fromPop = true;
    try { go(s); } finally { fromPop = false; }
  });
  document.addEventListener('click', (e) => {
    const t = e.target && e.target.closest ? e.target : null; if (!t) return;
    if (t.closest('[data-b-new-evaluation]')) { store.clear(); return; }
    const bk = t.closest('[data-back]');
    if (bk && a1.contains(bk)) {
      e.preventDefault(); e.stopImmediatePropagation();
      const c = cur();
      if (typeof c === 'number' && c > 0) history.back();
      else if (typeof a1.__rogmaShow === 'function' && typeof a1.__rogmaScreen === 'function') a1.__rogmaShow(Math.max(0, a1.__rogmaScreen() - 1));
    }
  }, true);
})();